{
  "% к прошлой неделе": "% до минулого тижня",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID і фінансові квитанції зберігаються.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Готові голоси доступні в розділі «Озвучення» → «Мої».",
  ". Он не меняет голос озвучки чата.": ". Він не змінює голос озвучення чату.",
  ". После подтверждения обновите профиль.": ". Після підтвердження оновіть профіль.",
  ". Проверьте папку «Спам».": ". Перевірте папку «Спам».",
  "Circle каждый месяц по подписке": "Circle щомісяця за підпискою",
  "Circle по подписке на этот месяц потрачены": "Circle за підпискою на цей місяць витрачено",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Не підключено",
  "Telegram ID скопирован.": "Telegram ID скопійовано.",
  "{0} {1} C сгорят {2}": "{0} {1} C згорять {2}",
  "{0} из {1}": "{0} з {1}",
  "{0} фото хватит для сходства": "{0} фото достатньо для схожості",
  "{0}: {1} работ": "{0}: {1} робіт",
  "{0}: пока недоступно": "{0}: поки недоступно",
  "· Вы и варианты": "· Ви та варіанти",
  "· Новое": "· Нове",
  "· занято": "· зайнято",
  "· отменена": "· скасовано",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Навчання почнеться після окремого натискання «Повторити обробку» в картці.",
  "Автовоспроизведение примеров": "Автовідтворення прикладів",
  "Аккаунт": "Обліковий запис",
  "Аккаунт подключён": "Обліковий запис підключено",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Архів недоступний або термін дії посилання минув. Можна запросити нове вивантаження.",
  "Бабушка": "Бабуся",
  "Баланс и вывод доступны в STEOS ID.": "Баланс і виведення коштів доступні в STEOS ID.",
  "Баланс и награды": "Баланс і винагороди",
  "Без имени": "Без імені",
  "Бесплатный план": "Безкоштовний тариф",
  "Ближайшие": "Найближчі",
  "Близкие": "Близькі",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Близька людина зникне з профілю. Її фото більше не будуть доступні для нових робіт.",
  "Близкий удалён.": "Близьку людину видалено.",
  "Близких пока нет.": "Близьких людей поки немає.",
  "Брат": "Брат",
  "В Steos с": "У Steos з",
  "В избранное": "До обраного",
  "Валюта": "Валюта",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "Варіант буде видалено. Оригінальні фото та STEOS ID збережуться.",
  "Вариантов: {0}": "Варіантів: {0}",
  "Варианты": "Варіанти",
  "Ваш собственный голос": "Ваш власний голос",
  "Введите УДАЛИТЬ": "Введіть УДАЛИТЬ",
  "Введите пароль": "Введіть пароль",
  "Введите почту": "Введіть електронну пошту",
  "Вернуться ко входу": "Повернутися до входу",
  "Версия": "Версія",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Версія згоди змінилася. Оновіть сторінку та підтвердьте актуальний текст.",
  "Версия согласия изменилась. Обновите страницу.": "Версія згоди змінилася. Оновіть сторінку.",
  "Версия:": "Версія:",
  "Взрослый": "Дорослий",
  "Включаем микрофон…": "Увімкнення мікрофона…",
  "Включено": "Увімкнено",
  "Возраст": "Вік",
  "Войти": "Увійти",
  "Восстановить пароль": "Відновити пароль",
  "Все Circle на балансе без срока": "Усі Circle на балансі безстрокові",
  "Вы": "Ви",
  "Вы и близкие": "Ви та близькі",
  "Вы и варианты": "Ви й варіанти",
  "Выберите голос": "Виберіть голос",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Виберіть інструмент і заповніть його форму. Готова робота збережеться в історії.",
  "Выбран": "Вибрано",
  "Выбрать голос": "Вибрати голос",
  "Выбрать голос по умолчанию": "Вибрати голос за замовчуванням",
  "Выбрать из работ": "Вибрати з робіт",
  "Выгрузить мои данные": "Вивантажити мої дані",
  "Выгрузка:": "Вивантаження:",
  "Выключено": "Вимкнено",
  "Голос": "Голос",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Голос готовий. Він доступний на вкладці «Мої» в розділі озвучення.",
  "Голос и клон": "Голос і клон",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Голос змінився. Дані оновлено — перевірте їх перед збереженням.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Голос змінився. Перевірте оновлені дані перед повторною обробкою.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "Голос зникне з вашого списку. Цю дію не можна скасувати.",
  "Голос по умолчанию для создания:": "Голос за замовчуванням для створення:",
  "Голос принят в обработку. Здесь появится его статус.": "Голос прийнято в обробку. Тут з'явиться його статус.",
  "Голос уже удалён или недоступен.": "Голос уже видалено або він недоступний.",
  "Голос:": "Голос:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Голосів не знайдено. Відкрийте каталог або змініть пошуковий запит.",
  "Горизонтальное": "Горизонтальний",
  "Готов": "Готовий",
  "Готовим образцы": "Готуємо зразки",
  "Готово": "Готово",
  "Готовые работы": "Готові роботи",
  "Далее": "Далі",
  "Данные Telegram обновлены.": "Дані Telegram оновлено.",
  "Данные баланса временно недоступны": "Дані балансу тимчасово недоступні",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Дані переносяться до підтвердженого облікового запису. Старі сеанси завершено; квитанція дає змогу продовжити перевірку після перезавантаження.",
  "Дедушка": "Дідусь",
  "До 5 фото: лицо крупно, при хорошем свете": "До 5 фото: обличчя крупним планом, за хорошого освітлення",
  "До пяти фото. Они будут использоваться как ваш образ.": "До п'яти фото. Вони використовуватимуться як ваш образ.",
  "Добавить близкого": "Додати близьку людину",
  "Добавить фото": "Додати фото",
  "Добавьте ещё": "Додайте ще",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Додайте від 2 секунд до 1,5 хвилин свого мовлення. Говоріть природно, без музики та інших голосів.",
  "Дочь": "Донька",
  "Друг": "Друг",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Якщо обліковий запис існує, посилання для створення нового пароля надіслано на",
  "Ещё варианты": "Ще варіанти",
  "Ещё операции": "Ще операції",
  "Ещё работы": "Ще роботи",
  "Жена": "Дружина",
  "ЗАМЕНА ОБРАЗЦОВ": "ЗАМІНА ЗРАЗКІВ",
  "Забыли пароль?": "Забули пароль?",
  "Загружаем аккаунт…": "Завантажуємо обліковий запис…",
  "Загружаем варианты…": "Завантажуємо варіанти…",
  "Загружаем ваши голоса…": "Завантажуємо ваші голоси…",
  "Загружаем голоса…": "Завантажуємо голоси…",
  "Загружаем настройки…": "Завантажуємо налаштування…",
  "Загружаем обновления…": "Завантажуємо оновлення…",
  "Загружаем операции…": "Завантажуємо операції…",
  "Загружаем пример…": "Завантажуємо приклад…",
  "Загружаем работы…": "Завантажуємо роботи…",
  "Загружаем фото…": "Завантажуємо фото…",
  "Загрузить аудиофайлы": "Завантажити аудіофайли",
  "Загрузить выбранные фото": "Завантажити вибрані фото",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Завантаження ще не підтверджено. Натисніть «Продовжити надсилання»: спочатку перевіримо попереднє завантаження.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Завантаження не підтверджено. Перш ніж продовжити, буде перевірено попередні завантаження.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Завантаження відхилено. Натисніть «Продовжити надсилання», щоб отримати нове посилання та завантажити зразок.",
  "Закрыть": "Закрити",
  "Закрыть мастер": "Закрити майстер",
  "Заменить образцы": "Замінити зразки",
  "Записать с микрофона": "Записати з мікрофона",
  "Запись": "Запис",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Запис тут недоступний. Відкрийте застосунок через HTTPS або завантажте аудіофайл.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Запис перервався. Спробуйте ще раз або завантажте файл.",
  "Запись-{0}.{1}": "Запис-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Запишіть зразок, дочекайтеся навчання та озвучуйте текст власним голосом.",
  "Запишите речь или загрузите аудиофайлы": "Запишіть мовлення або завантажте аудіофайли",
  "Запишите свой голос один раз — используйте его в озвучке.": "Запишіть свій голос один раз — використовуйте його для озвучення.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Запит збережено. Продовження перевірить попередній запит і не створить другий голос.",
  "Запустить обработку": "Запустити обробку",
  "Здесь появятся ваши работы": "Тут з'являться ваші роботи",
  "Из них": "З них",
  "Из них {0} C можно вывести": "З них {0} C можна вивести",
  "Избранное": "Обране",
  "Избранные работы": "Обрані роботи",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Зміну не підтверджено. Перевірте актуальну картку перед повторною спробою.",
  "Изменить": "Змінити",
  "Изменить близкого": "Змінити близьку людину",
  "Изменить вариант": "Змінити варіант",
  "Изменить голос": "Змінити голос",
  "Изменить мои фото": "Змінити мої фото",
  "Имя близкого": "Ім'я близької людини",
  "Имя голоса": "Назва голосу",
  "Имя пользователя не задано": "Ім'я користувача не задано",
  "Использовать как себя": "Використовувати як себе",
  "Используем сохранённые образцы голоса «": "Використовуємо збережені зразки голосу «",
  "Используйте свои фото и фото близких в инструментах студии.": "Використовуйте свої фото та фото близьких у студійних інструментах.",
  "История очищена: {0} работ, {1} заказов.": "Історію очищено: {0} робіт, {1} замовлень.",
  "КЛОН ГОЛОСА": "КЛОН ГОЛОСУ",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Кожен зразок має містити щонайменше одну секунду мовлення.",
  "Как в системе": "Як у системі",
  "Как пользоваться": "Як користуватися",
  "Как снимать": "Як фотографувати",
  "Каталог голосов": "Каталог голосів",
  "Квадрат": "Квадрат",
  "Кем приходится": "Ким доводиться",
  "Ко входу": "До входу",
  "Количество вариантов пока недоступно": "Кількість варіантів поки недоступна",
  "Конфиденциальность": "Конфіденційність",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Копіювання недоступне. ID показано в картці облікового запису.",
  "Кружок с героем": "Відеоповідомлення з персонажем",
  "Лимит {0} голосов выбран": "Вибрано ліміт у {0} голосів",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Ліміт голосів вичерпано. Видаліть непотрібний голос, щоб додати новий.",
  "Лимит:": "Ліміт:",
  "Мама": "Мама",
  "Можно добавить до {0} образцов.": "Можна додати до {0} зразків.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Можна закрити застосунок. Статус оновиться після обробки.",
  "Мои варианты": "Мої варіанти",
  "Мои голоса": "Мої голоси",
  "Мои данные": "Мої дані",
  "Мои фото": "Мої фото",
  "Моё": "Моє",
  "Моё фото": "Моє фото",
  "Муж": "Чоловік",
  "НОВЫЙ ГОЛОС": "НОВИЙ ГОЛОС",
  "Награды": "Винагороди",
  "Награды и задания": "Нагороди та завдання",
  "Назад": "Назад",
  "Название варианта": "Назва варіанта",
  "Назначить голос": "Призначити голос",
  "Настройки": "Налаштування",
  "Настройки уже изменились. Показана актуальная версия.": "Налаштування вже змінилися. Показано актуальну версію.",
  "Начните с 2 секунд речи в тихом месте.": "Почніть із 2 секунд мовлення в тихому місці.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Не більше 5 фото JPEG або PNG, до 10 МБ кожне.",
  "Не задано": "Не задано",
  "Не короче 8 знаков": "Щонайменше 8 символів",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Не вдалося ввімкнути мікрофон. Надайте дозвіл або завантажте файл.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Не вдалося увійти. Заново відкрийте застосунок із Telegram.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Не вдалося відтворити приклад. Заново відкрийте картку та спробуйте ще раз.",
  "Не удалось загрузить варианты.": "Не вдалося завантажити варіанти.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Не вдалося завантажити голоси. Змініть пошуковий запит або вкладку, щоб повторити спробу.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Не вдалося завантажити налаштування. Спробуйте оновити сторінку.",
  "Не удалось загрузить работы.": "Не вдалося завантажити роботи.",
  "Не удалось загрузить следующую страницу.": "Не вдалося завантажити наступну сторінку.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Не вдалося завантажити наступну сторінку. Спробуйте ще раз.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Не вдалося оновити дані з Telegram. Спробуйте пізніше.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Не вдалося підтвердити зміну обраного. Оновіть профіль.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Не вдалося підтвердити операцію. Перевірте стан облікового запису перед повторною спробою.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Не вдалося підтвердити збереження. Оновіть налаштування перед повторною спробою.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Не вдалося підтвердити видалення близької людини. Оновіть профіль.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Не вдалося отримати відповідь. Спробуйте ще раз — запит продовжиться з тим самим ключем.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Не вдалося перевірити вивантаження. Оновіть сторінку: продовжимо попередню операцію.",
  "Не удалось прочитать запись.": "Не вдалося прочитати запис.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Не вдалося створити голос. Відкрийте картку, щоб перевірити статус або повторити обробку.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Не вдалося створити голос. Перевірте дані та зразки.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Не вдалося зберегти перегляд. Можна закрити й повернутися пізніше.",
  "Неверная почта или пароль": "Неправильна електронна пошта або пароль",
  "Нет работ": "Немає робіт",
  "Новая выгрузка": "Нове вивантаження",
  "Новости": "Новини",
  "Новый вариант": "Новий варіант",
  "Новый голос": "Новий голос",
  "Новых публикаций пока нет.": "Нових публікацій поки немає.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Потрібно від 2 секунд до 1,5 хвилин мовлення загалом.",
  "О приложении": "Про застосунок",
  "Обновить": "Оновити",
  "Обновить варианты": "Оновити варіанти",
  "Обновить из Telegram": "Оновити з Telegram",
  "Обновить настройки": "Оновити налаштування",
  "Обновить профиль": "Оновити профіль",
  "Обновить работы": "Оновити роботи",
  "Обновления": "Оновлення",
  "Обновляем вход…": "Оновлюємо вхід…",
  "Обрабатывается": "Обробляється",
  "Образ готов": "Образ готовий",
  "Образ ещё не собран": "Образ ще не створено",
  "Образец {0}": "Зразок {0}",
  "Образец голоса": "Зразок голосу",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Зразок ще не перевірено. Зачекайте й продовжте надсилання.",
  "Образец не прошёл проверку. Выберите другую запись.": "Зразок не пройшов перевірку. Виберіть інший запис.",
  "Образцы готовы к повторной обработке.": "Зразки готові до повторної обробки.",
  "Образцы для «": "Зразки для «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Зразки оновлено. Натисніть «Повторити обробку», щоб навчити голос заново.",
  "Обучаем голос": "Навчаємо голос",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Загальна тривалість зразків не має перевищувати 1,5 хвилин.",
  "Объединение STEOS ID": "Об'єднання STEOS ID",
  "Объединяем аккаунты": "Об'єднуємо облікові записи",
  "Объём образцов": "Тривалість зразків",
  "Один аккаунт для бота и сайта STEOS": "Один обліковий запис для бота та сайту STEOS",
  "Озвучить текст голосом «": "Озвучити текст голосом «",
  "Операции": "Операції",
  "Операции в токенах STEOS ID": "Операції в токенах STEOS ID",
  "Операции временно недоступны.": "Операції тимчасово недоступні.",
  "Операций пока нет.": "Операцій поки немає.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "Операцію не підтверджено. Повторна спроба використає той самий ключ.",
  "Описание": "Опис",
  "Описание и согласие": "Опис і згода",
  "Остановить запись ·": "Зупинити запис ·",
  "Остаток Circle недоступен": "Залишок Circle недоступний",
  "Отклик": "Тактильний відгук",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Відкрийте посилання з листа та задайте новий пароль на id.steos.io. Потім увійдіть тут.",
  "Откройте ссылку подтверждения для": "Відкрийте посилання для підтвердження адреси",
  "Открыть id.steos.io": "Відкрити id.steos.io",
  "Открыть историю": "Відкрити історію",
  "Отмена": "Скасувати",
  "Отметьте согласие с условиями": "Підтвердьте згоду з умовами",
  "Отправить ссылку": "Надіслати посилання",
  "Отправляем…": "Надсилаємо…",
  "Оформить подписку": "Оформити підписку",
  "Оформление": "Оформлення",
  "Очистить историю": "Очистити історію",
  "Очистить историю?": "Очистити історію?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Очищення не підтверджено. Повторна спроба перевірить попередню операцію.",
  "Очищаем…": "Очищаємо…",
  "Ошибка": "Помилка",
  "Папа": "Тато",
  "Пароль": "Пароль",
  "Переименовать вариант": "Перейменувати варіант",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Перенесення ще не підтверджено. Квитанцію збережено; перевірка триватиме.",
  "Перенос завершён, обновляем вход…": "Перенесення завершено, оновлюємо вхід…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Переносимо дані до наявного STEOS ID. Після перенесення застосунок оновить сеанс. Не запускайте об'єднання повторно.",
  "Письмо отправлено": "Лист надіслано",
  "Питомец": "Домашній улюбленець",
  "Повторить загрузку": "Повторити завантаження",
  "Повторить обработку": "Повторити обробку",
  "Подготовить ZIP для скачивания": "Підготувати ZIP для завантаження",
  "Поддержка": "Підтримка",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "Підключення STEOS ID наразі недоступне. Спробуйте пізніше або відкрийте сайт STEOS ID.",
  "Подключён": "Підключено",
  "Подключён:": "Підключено:",
  "Подруга": "Подруга",
  "Подтвердите почту": "Підтвердьте електронну пошту",
  "Подтвердите согласие перед отправкой образцов.": "Підтвердьте згоду перед надсиланням зразків.",
  "Подтвердить очистку истории": "Підтвердити очищення історії",
  "Подтвердить удаление": "Підтвердити видалення",
  "Подтвердить удаление аккаунта": "Підтвердити видалення облікового запису",
  "Подтвердить удаление близкого": "Підтвердити видалення близької людини",
  "Подтвердить удаление варианта": "Підтвердити видалення варіанта",
  "Поиск голоса": "Пошук голосу",
  "Поиск по имени": "Пошук за іменем",
  "Пока нет своих голосов": "Власних голосів поки немає",
  "Показать ещё": "Показати ще",
  "Показать ещё голоса": "Показати ще голоси",
  "Показать пароль": "Показати пароль",
  "Пополнить": "Поповнити",
  "Попробовать": "Спробувати",
  "Портрет": "Портрет",
  "Пост": "Публікація",
  "Потрачено Circle:": "Витрачено Circle:",
  "Почта": "Електронна пошта",
  "Почта уже занята": "Електронну пошту вже зайнято",
  "Почта уже занята, войдите с ней": "Електронну пошту вже зайнято, увійдіть із нею",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Привіт! Це запис для мого голосу. Я говорю спокійно й у звичайному темпі, як у розмові з другом. Розповім, як минув мій день, що мене потішило та які плани маю на завтра. Продовжуйте говорити своїми словами щонайменше тридцять секунд.",
  "Приглашайте друзей": "Запрошуйте друзів",
  "Пример голоса {0}": "Приклад голосу {0}",
  "Принимаю": "Приймаю",
  "Присылать готовые работы в чат": "Надсилати готові роботи в чат",
  "Проверен": "Перевірено",
  "Проверить выгрузку": "Перевірити вивантаження",
  "Проверить подтверждение": "Перевірити підтвердження",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Голос не пройшов перевірку. Запишіть зразок без музики та інших людей.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Зразки не пройшли перевірку. Спробуйте зробити чистий запис одного голосу.",
  "Проверьте адрес": "Перевірте адресу",
  "Проверяем запись": "Перевіряємо запис",
  "Проверяем образец {0} из {1}…": "Перевіряємо зразок {0} із {1}…",
  "Проверяем состояние переноса…": "Перевіряємо стан перенесення…",
  "Проверяем…": "Перевіряємо…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Перевіряйте залишок у профілі та отримуйте доступні винагороди.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Продовжимо перевірку попереднього запиту без повторного запуску.",
  "Продолжим сохранённый запрос с теми же данными.": "Продовжимо збережений запит із тими самими даними.",
  "Продолжить отправку": "Продовжити надсилання",
  "Продолжить проверку": "Продовжити перевірку",
  "Продолжить создание голоса": "Продовжити створення голосу",
  "Продолжить сохранение": "Продовжити збереження",
  "Прослушать {0}": "Прослухати {0}",
  "Профиль": "Профіль",
  "Профиль «Вы» пока недоступен.": "Профіль «Ви» поки недоступний.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Профіль уже змінився. Закрийте форму та відкрийте актуальну версію.",
  "Работ в этом списке пока нет.": "У цьому списку поки немає робіт.",
  "Работа №": "Робота №",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Роботи та параметри замовлень зникнуть з історії. Голоси, варіанти «Ви» та близькі люди залишаться. Фінансові квитанції зберігаються. Відновити історію неможливо.",
  "Работы по неделям": "Роботи за тижнями",
  "Раздел профиля": "Розділ профілю",
  "Разделы профиля": "Розділи профілю",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Розмір кожного зразка має становити від 1 байта до 20 МБ.",
  "Ребёнок": "Дитина",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Результат обробки уточнюється. Повторний запуск поки недоступний.",
  "Русский": "Русский",
  "С": "З",
  "Сбросить голос по умолчанию": "Скинути голос за замовчуванням",
  "Светлая": "Світла",
  "Свой аватар": "Власний аватар",
  "Сгорят {0}, если не потратить": "Згорять {0}, якщо не витратити",
  "Сделать кружок": "Зробити відеоповідомлення",
  "Серия:": "Серія:",
  "Сестра": "Сестра",
  "Скачать ZIP": "Завантажити ZIP",
  "Скопировать Telegram ID": "Скопіювати Telegram ID",
  "Скорость речи": "Швидкість мовлення",
  "Скрыть пароль": "Приховати пароль",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Забагато запитів. Зачекайте трохи й спробуйте ще раз.",
  "Слишком много попыток. Попробуйте позже.": "Забагато спроб. Спробуйте пізніше.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Фотографуйте обличчя без фільтрів і темних окулярів, за рівномірного освітлення. Додайте фото з різних ракурсів. У кадрі має бути одна людина.",
  "Снять голос": "Записати голос",
  "Снять фото": "Зробити фото",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Згода змінилася до початку навчання. Оновіть сторінку та підтвердьте актуальну версію перед повторною обробкою.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Створюйте розмовні кружечки з вибраним персонажем або власним образом.",
  "Создание": "Створення",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Створення голосів тимчасово недоступне. Зразки збережено в цьому вікні.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Створення нових голосів поки недоступне. Уже створені голоси доступні нижче.",
  "Создано:": "Створено:",
  "Создан {0}": "Створено {0}",
  "Создать аккаунт": "Створити обліковий запис",
  "Создать голос": "Створити голос",
  "Создаём голос…": "Створюємо голос…",
  "Сохранение настроек создания сейчас выключено.": "Збереження налаштувань створення наразі вимкнено.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Збереження не підтверджено. Закрийте форму та перевірте актуальний профіль.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Збереження не підтверджено. Повторне створення використає попередній запит.",
  "Сохранение недоступно.": "Збереження недоступне.",
  "Сохранено": "Збережено",
  "Сохранить": "Зберегти",
  "Сохранить близкого": "Зберегти близьку людину",
  "Сохранить вариант": "Зберегти варіант",
  "Сохранить голос по умолчанию": "Зберегти голос за замовчуванням",
  "Сохранить мои фото": "Зберегти мої фото",
  "Сохранить образцы": "Зберегти зразки",
  "Сохраняем образцы…": "Зберігаємо зразки…",
  "Сохраняем…": "Зберігаємо…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Збережені варіанти себе доступні в профілі та інструментах створення.",
  "Сохранённых вариантов пока нет.": "Збережених варіантів поки немає.",
  "Сроки партий Circle временно недоступны": "Терміни дії пакетів Circle тимчасово недоступні",
  "Старший": "Старший",
  "Статистика": "Статистика",
  "Статистика по неделям временно недоступна.": "Статистика за тижнями тимчасово недоступна.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Статус видалення тимчасово недоступний. Квитанцію збережено в цій вкладці.",
  "Сторис": "Історії",
  "Сын": "Син",
  "Тариф": "Тариф",
  "Текст для чтения": "Текст для читання",
  "Тема": "Тема",
  "Тема сохраняется на этом устройстве.": "Тема зберігається на цьому пристрої.",
  "Тёмная": "Темна",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Я маю право використовувати ці фотографії та згоду зображених на них людей.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Прибираємо шум",
  "Убрать": "Прибрати",
  "Убрать {0}": "Прибрати {0}",
  "Убрать из избранного": "Прибрати з обраного",
  "Убрать фоновый шум": "Прибрати фоновий шум",
  "Убрать фото": "Прибрати фото",
  "Уведомления": "Сповіщення",
  "Уведомления недоступны.": "Сповіщення недоступні.",
  "Уведомления пока недоступны.": "Сповіщення поки недоступні.",
  "Удаление аккаунта Mini App": "Видалення облікового запису Mini App",
  "Удаление:": "Видалення:",
  "Удалить": "Видалити",
  "Удалить «": "Видалити «",
  "Удалить «{0}»?": "Видалити «{0}»?",
  "Удалить аккаунт Mini App": "Видалити обліковий запис Mini App",
  "Удалить близкого": "Видалити близьку людину",
  "Удалить вариант": "Видалити варіант",
  "Удалить голос": "Видалити голос",
  "Удаляем…": "Видаляємо…",
  "Удаляется": "Видаляється",
  "Українська": "Українська",
  "Условия использования": "Умови використання",
  "Файл": "Файл",
  "Формат": "Формат",
  "Фото Telegram": "Фото Telegram",
  "Фото {0}": "Фото {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Фото та ім'я беруться з вашого профілю в Telegram. Якщо ви їх змінили, оновіть дані тут.",
  "Фото и фотосессия": "Фото та фотосесія",
  "Фото перед загрузкой": "Фото перед завантаженням",
  "Фото профиля": "Фото профілю",
  "Фото профиля Telegram": "Фото профілю Telegram",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Фото, голоси, близькі люди та дані Mini App буде видалено в усіх сервісах. STEOS ID і фінансові квитанції залишаться. Скасувати видалення неможливо.",
  "Фото:": "Фото:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Частина профілю тимчасово недоступна. Спробуйте оновити.",
  "Читаем аудиофайлы…": "Читаємо аудіофайли…",
  "Что нового": "Що нового",
  "Что нового пока не опубликовано или временно недоступно.": "Новини поки не опубліковано або вони тимчасово недоступні.",
  "Что нового пока не опубликовано.": "Новини поки не опубліковано.",
  "Шаблоны": "Шаблони",
  "Шаблоны и рилс": "Шаблони та рилси",
  "Эта неделя": "Цей тиждень",
  "Этот голос используется:": "Цей голос використовується:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Цей запуск поки не можна повторити. Оновіть статус голосу.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Цей формат не підтримується. Виберіть MP3, WAV, M4A, OGG або WebM.",
  "Язык аккаунта": "Мова облікового запису",
  "готова": "готова",
  "готова частично": "готова частково",
  "дата недоступна": "дата недоступна",
  "для переозвучки": "для переозвучення",
  "до {0}, потом {1}": "до {0}, потім {1}",
  "другой тариф": "інший тариф",
  "закончится {0}": "закінчиться {0}",
  "и": "і",
  "из": "із",
  "из 1:30 · минимум 0:02": "із 1:30 · мінімум 0:02",
  "лимит уточняется": "ліміт уточнюється",
  "не задан": "не задано",
  "не назначен": "не призначено",
  "новых": "нових",
  "образец": "зразок",
  "образца": "зразка",
  "образцов": "зразків",
  "оплачено до {0}": "оплачено до {0}",
  "подарок до {0}": "подарунок до {0}",
  "пока недоступно": "поки недоступно",
  "политику конфиденциальности STEOS": "політику конфіденційності STEOS",
  "продлится {0}": "продовжиться {0}",
  "речи.": "мовлення.",
  "токенов": "токенів",
  "условия": "умови",
  "уточняется": "уточнюється",
  "Қазақша": "Қазақша",
  "← Профиль": "← Профіль",
  "▶ Прослушать": "▶ Прослухати",
  "Озвучка": "Озвучка",
  "Клон": "Клон",
  "Студия": "Студія",
  "Баланс": "Баланс",
  "История": "Історія",
  "Ещё": "Ще",
  "Клонирование голоса": "Клонування голосу",
  "Партнёрство": "Партнерство",
  "Добавить в чат": "Додати до чату",
  "Разделы": "Розділи",
  "Главное меню": "Головне меню",
  "Выберите": "Виберіть",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Після об’єднання збережено всі фото. Залиште до п’яти, щоб змінити образ.",
  "Абзацы": "Абзаци",
  "Альбом": "Альбом",
  "Аудио": "Аудіо",
  "Без изменения": "Без змін",
  "Бесплатно по текущему тестовому dev-тарифу.": "Безкоштовно за поточним тестовим dev-тарифом.",
  "Бесплатно по тестовому dev-тарифу": "Безкоштовно за тестовим dev-тарифом",
  "В избранном пока пусто": "В обраному поки що порожньо",
  "В очереди": "У черзі",
  "Вариант {0}": "Варіант {0}",
  "Введите текст до 1000 символов": "Введіть текст до 1000 символів",
  "Вернули": "Повернуто",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Запис не вдасться повернути в історію. Файл залишиться в чаті.",
  "Видео": "Відео",
  "Виды работ": "Види робіт",
  "Все": "Усі",
  "Вчера": "Учора",
  "Выбранный вариант": "Вибраний варіант",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Вибраний варіант недоступний. Поверніться до профілю й оновіть список.",
  "Выполняется": "Виконується",
  "Высота голоса": "Висота голосу",
  "Говорящее видео": "Відео з озвученням",
  "Голоса": "Голоси",
  "Дата неизвестна": "Дата невідома",
  "Длительность": "Тривалість",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Для цієї дії поки немає доступного опублікованого інструмента.",
  "Дополнительное поле": "Додаткове поле",
  "Заголовок": "Заголовок",
  "Загружаем историю…": "Завантажуємо історію…",
  "Загружаем работу…": "Завантажуємо роботу…",
  "Загружаем результат…": "Завантажуємо результат…",
  "Загружаем…": "Завантажуємо…",
  "Загружено": "Завантажено",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Завантаження не підтверджено. Продовжте перевірку цього файлу.",
  "Заказ": "Замовлення",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Замовлення не підтверджено. Продовження перевірить попередній запит із тим самим ключем.",
  "Заменить файл": "Замінити файл",
  "Избранное: {0}": "Обране: {0}",
  "Инструмент обновляется. Обновите форму позже.": "Інструмент оновлюється. Оновіть форму пізніше.",
  "Искать в {0} работах": "Шукати серед {0} робіт",
  "Искать в истории": "Шукати в історії",
  "Использовать фото выбранного варианта": "Використати фото вибраного варіанта",
  "Используется выбранный голос.": "Використовується вибраний голос.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Результат генерації уточнюється. Нова робота автоматично не запускається.",
  "К инструментам": "До інструментів",
  "Кавер": "Кавер",
  "Карусель": "Карусель",
  "Ключевые слова": "Ключові слова",
  "Коллаж": "Колаж",
  "Кратко": "Коротко",
  "Кружки": "Відеоповідомлення",
  "Кружок": "Відеоповідомлення",
  "Кто в кадре": "Хто в кадрі",
  "Название": "Назва",
  "Не получилось": "Не вдалося",
  "Не удалось выполнить": "Не вдалося виконати",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Не вдалося виконати дію з цією роботою. Оновіть її та спробуйте ще раз.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Не вдалося завершити створення. Спробуйте змінити налаштування.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Не вдалося завантажити історію. Спробуйте ще раз.",
  "Не удалось загрузить студию.": "Не вдалося завантажити студію.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Не вдалося завантажити фото варіанта. Оновіть профіль.",
  "Не удалось обработать запись": "Не вдалося обробити запис",
  "Не удалось озвучить текст": "Не вдалося озвучити текст",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Не вдалося відкрити інструмент. Спробуйте оновити сторінку.",
  "Не удалось открыть результат. Попробуйте снова.": "Не вдалося відкрити результат. Спробуйте ще раз.",
  "Не удалось отправить результат. Повторите отправку.": "Не вдалося надіслати результат. Надішліть ще раз.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Не вдалося зв'язатися із сервісом. Спробуйте ще раз.",
  "Не удалось скопировать. Выделите текст вручную.": "Не вдалося скопіювати. Виділіть текст вручну.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Не вдалося зберегти надсилання. Дозвольте доступ до сховища вкладки й спробуйте ще раз.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Деякі файли для повтору більше недоступні. Завантажте їх знову.",
  "Ничего не нашли": "Нічого не знайдено",
  "Нужно разных фото": "Потрібні різні фото",
  "Обрабатываем запись": "Обробляємо запис",
  "Озвучиваем текст": "Озвучуємо текст",
  "Озвучить": "Озвучити",
  "Озвучка готова": "Озвучення готове",
  "Озвучка проекта": "Озвучення проєкту",
  "Оплата": "Оплата",
  "Оплачено донатом": "Оплачено донатом",
  "Определить автоматически": "Визначити автоматично",
  "Основа": "Основа",
  "Открыть результат": "Відкрити результат",
  "Отменено": "Скасовано",
  "Отправить в чат": "Надіслати в чат",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Надсилання не прийнято. Перевірте повідомлення про помилку.",
  "Отправка принята. Бот доставит результат в чат.": "Надсилання прийнято. Бот доставить результат у чат.",
  "Отправлено": "Надіслано",
  "Переозвучить запись": "Переозвучити запис",
  "Переозвучка": "Переозвучення",
  "Персонаж": "Персонаж",
  "Площадка": "Майданчик",
  "Повтори движения": "Повтори рухи",
  "Повторить": "Повторити",
  "Подпись": "Підпис",
  "Подтверждаю право использовать загружаемые материалы": "Підтверджую право використовувати матеріали, що завантажуються",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Підтверджую право використовувати ці фото та згоду зображених людей на створення варіанта",
  "Поиск в истории": "Пошук в історії",
  "Показатели истории": "Статистика історії",
  "Показатели истории временно недоступны": "Статистика історії тимчасово недоступна",
  "Показать все работы": "Показати всі роботи",
  "Показать текст": "Показати текст",
  "Порядок": "Порядок",
  "Почистить запись": "Очистити запис",
  "Прежний голос недоступен. Выберите другой голос.": "Попередній голос недоступний. Виберіть інший голос.",
  "Преимущества": "Переваги",
  "Проверьте заполненные поля. Заказ не создан.": "Перевірте заповнені поля. Замовлення не створено.",
  "Проверяем итог операции": "Перевіряємо підсумок операції",
  "Проверяем отправку…": "Перевіряємо надсилання…",
  "Проверяем результат": "Перевіряємо результат",
  "Проверяем списание токенов": "Перевіряємо списання токенів",
  "Продолжить проверку озвучки": "Продовжити перевірку озвучення",
  "Работ пока нет": "Робіт поки що немає",
  "Работ: {0}": "Робіт: {0}",
  "Работа": "Робота",
  "Работа больше не найдена. Обновите историю.": "Роботу більше не знайдено. Оновіть історію.",
  "Работа из истории": "Робота з історії",
  "Работа не прошла проверку.": "Робота не пройшла перевірку.",
  "Работа обновилась. Загрузите её ещё раз.": "Роботу оновлено. Завантажте її ще раз.",
  "Распознавание": "Розпізнавання",
  "Распознанный текст": "Розпізнаний текст",
  "Распознать речь": "Розпізнати мовлення",
  "Расшифровка": "Розшифрування",
  "Режим озвучки": "Режим озвучення",
  "Результат": "Результат",
  "Результат больше недоступен": "Результат більше недоступний",
  "Результат операции уточняется. Повторный запуск отключён.": "Результат операції уточнюється. Повторний запуск вимкнено.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Результат надсилання поки невідомий. Повторіть перевірку.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Результат надсилання поки невідомий. Повторіть із тим самим ключем.",
  "Результат переозвучки": "Результат переозвучення",
  "Результат работы": "Результат роботи",
  "Реплики": "Репліки",
  "Речевая запись": "Мовленнєвий запис",
  "Рилс": "Рілс",
  "Сегодня": "Сьогодні",
  "Сейчас создаётся": "Створюється зараз",
  "Сервис сейчас недоступен.": "Сервіс зараз недоступний.",
  "Сессия истекла. Откройте приложение заново.": "Сеанс завершився. Відкрийте застосунок знову.",
  "Синтез": "Синтез",
  "Скачать": "Завантажити",
  "Скачать все файлы": "Завантажити всі файли",
  "Скачать набор": "Завантажити набір",
  "Скопировано": "Скопійовано",
  "Скопировать": "Скопіювати",
  "Слайды": "Слайди",
  "Слишком много запросов. Подождите немного.": "Забагато запитів. Зачекайте трохи.",
  "Слушать результат": "Прослухати результат",
  "Смена голоса": "Зміна голосу",
  "Сначала новые": "Спочатку нові",
  "Сначала старые": "Спочатку старі",
  "Создать": "Створити",
  "Создаётся": "Створюється",
  "Списано": "Списано",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Статус поки не підтверджено. Перевіряємо попереднє замовлення.",
  "Статус текущих заказов временно недоступен": "Статус поточних замовлень тимчасово недоступний",
  "Стиль": "Стиль",
  "Стоимость": "Вартість",
  "Сцена": "Сцена",
  "Съёмка": "Зйомка",
  "Текст": "Текст",
  "Текст для озвучки": "Текст для озвучення",
  "Текст песни": "Текст пісні",
  "Текст поста": "Текст допису",
  "Товар": "Товар",
  "Удалить из истории": "Видалити з історії",
  "Удалить из истории?": "Видалити з історії?",
  "Уточняем результат": "Уточнюємо результат",
  "Уточняем состояние сохранённого заказа…": "Уточнюємо стан збереженого замовлення…",
  "Файл в чате останется": "Файл залишиться в чаті",
  "Файлов: {0}": "Файлів: {0}",
  "Форма недоступна.": "Форма недоступна.",
  "Формат отправки": "Формат надсилання",
  "Фото": "Фото",
  "Фотосессии": "Фотосесії",
  "Фотосессия": "Фотосесія",
  "Фотосессия товара": "Фотосесія товару",
  "Части": "Частини",
  "Шаблон": "Шаблон",
  "Эта работа недоступна вашему аккаунту.": "Ця робота недоступна для вашого облікового запису.",
  "Это вся история": "Це вся історія",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Цей інструмент зараз недоступний. Спробуйте оновити форму.",
  "Язык записи": "Мова запису",
  "MP3 · пауза между репликами 0,6 с": "MP3 · пауза між репліками 0,6 с",
  "{0} / 1 000 знаков": "{0} / 1 000 символів",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 символів · версія {1}",
  "{0} реплик": "{0} реплік",
  "{0} ролей · {1} новых реплик": "{0} ролей · {1} нових реплік",
  "Аудио больше недоступно. Обновите статус проекта.": "Аудіо більше недоступне. Оновіть статус проєкту.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Буфер обміну недоступний. Вставте текст у поле вручну.",
  "В проекте должно быть от 1 до 50 ролей.": "У проєкті має бути від 1 до 50 ролей.",
  "В проекте может быть не больше 500 реплик.": "У проєкті може бути не більше ніж 500 реплік.",
  "Вставить из буфера": "Вставити з буфера обміну",
  "Вставить сценарий": "Вставити сценарій",
  "Выберите голос для каждой непустой роли.": "Виберіть голос для кожної непорожньої ролі.",
  "Выше": "Вище",
  "Голос {0}": "Голос {0}",
  "Голос роли": "Голос ролі",
  "Готовим аудио…": "Готуємо аудіо…",
  "Добавить {0} реплик": "Додати {0} реплік",
  "Добавьте реплику или вставьте сценарий.": "Додайте репліку або вставте сценарій.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Дочекайтеся завантаження спільного файлу й спробуйте ще раз.",
  "Дублировать": "Дублювати",
  "Загружаем аудио…": "Завантажуємо аудіо…",
  "Загружаем проекты…": "Завантажуємо проєкти…",
  "Загрузить версию сервера": "Завантажити версію із сервера",
  "Закрыть раздел без сохранения изменений?": "Закрити розділ без збереження змін?",
  "Заменить текущие роли и реплики?": "Замінити поточні ролі та репліки?",
  "Заменить текущий сценарий": "Замінити поточний сценарій",
  "Изменить сценарий": "Змінити сценарій",
  "Имя роли": "Ім’я ролі",
  "Кто говорит": "Хто говорить",
  "Мои проекты": "Мої проєкти",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Натисніть відтворення в плеєрі, щоб увімкнути звук.",
  "Название проекта": "Назва проєкту",
  "Название слишком длинное.": "Назва надто довга.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Не вдалося відновити операції. Не запускайте озвучення повторно; перевірте історію.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Не вдалося виконати дію. Зміни залишаються на екрані.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Не вдалося завантажити аудіо. Перевірте з’єднання й спробуйте ще раз.",
  "Не удалось озвучить проект": "Не вдалося озвучити проєкт",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Не вдалося підготувати аудіо. Перевірте репліку та вибраний голос.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Не вдалося перевірити власника проєкту. Оновіть сторінку.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Не вдалося зв’язатися із сервером. Перевірте з’єднання та повторіть спробу.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Недостатньо Circle. Поповніть баланс і повторіть дію.",
  "Ниже": "Нижче",
  "Новый дубль реплики": "Новий дубль репліки",
  "Общий файл · MP3": "Спільний файл · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Один із голосів більше недоступний. Виберіть інший голос.",
  "Озвучено реплик: {0} из {1}": "Озвучено реплік: {0} із {1}",
  "Озвучиваем проект": "Озвучуємо проєкт",
  "Озвучить · {0} Circle": "Озвучити · {0} Circle",
  "Озвучить проект": "Озвучити проєкт",
  "Озвучка проектов": "Озвучка проєктів",
  "Озвучка уже выполняется. Дождитесь результата.": "Озвучення вже виконується. Дочекайтеся результату.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "Операцію вже прийнято або її результат невідомий. Перевірте попередній запит.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Відхилити локальні зміни й завантажити версію із сервера?",
  "Открыть в истории": "Відкрити в історії",
  "Отменить изменения": "Скасувати зміни",
  "Отменить несохранённые изменения?": "Скасувати незбережені зміни?",
  "Перед озвучкой дождитесь сохранения изменений.": "Дочекайтеся збереження змін перед озвученням.",
  "Переозвучить": "Переозвучити",
  "Переозвучить реплику": "Переозвучити репліку",
  "Повторить проверку": "Повторити перевірку",
  "Подтвердить и запустить": "Підтвердити й запустити",
  "Подтверждение озвучки": "Підтвердження озвучення",
  "Проверить прежний запрос": "Перевірити попередній запит",
  "Проверить статус": "Перевірити статус",
  "Проверьте роли, голоса и длину реплик.": "Перевірте ролі, голоси та довжину реплік.",
  "Проект больше недоступен.": "Проєкт більше недоступний.",
  "Проект длиннее 20 000 знаков.": "Проєкт містить понад 20 000 символів.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Проєкт змінено в іншому вікні. Порівняйте свою версію та завантажте актуальну.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Проєкт змінено. Збережіть його й перевірте ціну ще раз.",
  "Проект или результат больше недоступен.": "Проєкт або результат більше недоступний.",
  "Проект озвучен": "Проєкт озвучено",
  "Проекты {0}": "Проєкти {0}",
  "Прослушать": "Прослухати",
  "Прослушать реплику": "Прослухати репліку",
  "Прослушать текущую версию": "Прослухати поточну версію",
  "Прослушивание в очереди": "Прослуховування в черзі",
  "Прослушивание реплики": "Прослуховування репліки",
  "Результат изменился. Загрузите его актуальную версию.": "Результат змінено. Завантажте його актуальну версію.",
  "Результат озвучки проекта": "Результат озвучення проєкту",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Результат уточнюється. Повторна генерація автоматично не запускається.",
  "Реплика {0}": "Репліка {0}",
  "Реплика длиннее 1 000 знаков.": "Репліка містить понад 1 000 символів.",
  "Реплики · {0}": "Репліки · {0}",
  "Реплику {0} выше": "Перемістити репліку {0} вище",
  "Реплику {0} ниже": "Перемістити репліку {0} нижче",
  "Роли и голоса": "Ролі та голоси",
  "Роль {0}": "Роль {0}",
  "Роль реплики": "Роль репліки",
  "Скачать MP3": "Завантажити MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Забагато запитів. Зачекайте й повторіть перевірку.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Створіть проєкт, потім вставте сценарій або додайте ролі й репліки.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Вартість підтверджено сервером. Повторна перевірка цього самого запиту не спричиняє нового списання.",
  "Стоимость: {0} Circle": "Вартість: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "Рядки «Ім’я: репліка» стануть ролями й репліками. Таймкоди можна залишити.",
  "Сценарий": "Сценарій",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Сценарій змінено. Ця аудіодоріжка належить до попередньої версії проєкту.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Сценарій із розподілом за ролями — кожна роль звучить своїм голосом.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Текст або голос змінено. Для поточної версії потрібно нове прослуховування.",
  "Текст реплики": "Текст репліки",
  "Удалить проект": "Видалити проєкт",
  "Удалить реплику {0}": "Видалити репліку {0}",
  "Удалить реплику?": "Видалити репліку?",
  "Удалить роль {0}": "Видалити роль {0}",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Видалити роль «{0}» разом із її репліками ({1})?",
  "Удалить этот проект?": "Видалити цей проєкт?",
  "Укажите имя каждой роли.": "Укажіть ім’я кожної ролі.",
  "Уточняем результат озвучки": "Уточнюємо результат озвучення",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Ціна змінилася. Перевірте нову ціну перед запуском.",
  "есть несохранённые изменения": "є незбережені зміни",
  "сохранено": "збережено",
  "＋ Новый проект": "＋ Новий проєкт",
  "＋ Реплика": "＋ Репліка",
  "＋ Роль": "＋ Роль",
  "Circle из пакетов без срока действия.": "Circle з пакетів без строку дії.",
  "Circle каждый месяц": "Circle щомісяця",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle надходять кожні {0} днів, перша партія — одразу.",
  "Circle этой партии действуют до {0}": "Ця партія Circle діє до {0}",
  "{0} Circle каждый месяц": "{0} Circle щомісяця",
  "{0} Circle каждый месяц · до {1} своих голосов": "{0} Circle щомісяця · до {1} власних голосів",
  "{0} мес.": "{0} міс.",
  "Баланс и профиль": "Баланс і профіль",
  "В текущем месяце осталось {0} из {1} Circle": "У поточному місяці залишилося {0} із {1} Circle",
  "Ваш текущий тариф": "Ваш поточний тариф",
  "Включить тестовое продление": "Увімкнути тестове продовження",
  "Выбор тарифа": "Вибір тарифу",
  "Действует до {0}": "Діє до {0}",
  "Для этой подписки продление пока недоступно.": "Для цієї підписки продовження поки недоступне.",
  "До {0} своих голосов": "До {0} власних голосів",
  "До {0} сохраняется текущий тариф.": "До {0} зберігається поточний тариф.",
  "Докупить Circle": "Докупити Circle",
  "Доступные сроки": "Доступні строки",
  "Загружаем подписку…": "Завантажуємо підписку…",
  "Запланировать переход": "Запланувати перехід",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "Запит не збігається зі збереженою операцією. Не повторюйте покупку; зверніться до служби підтримки.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Потрібно перевірити результат попереднього запиту. Нову покупку поки заблоковано.",
  "Начислить {0} тестовых Circle": "Нарахувати {0} тестових Circle",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Не вдалося відновити операцію. Перевірте підписку перед новою покупкою.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Операцію підтверджено. Оновіть дані; повторювати покупку не потрібно.",
  "Оставить текущий тариф": "Залишити поточний тариф",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Скасування продовження зберігає тариф і ліміти до кінця оплаченого строку.",
  "Отменить продление": "Скасувати продовження",
  "Оформить dev-подписку": "Оформити dev-підписку",
  "Пакет Circle начислен.": "Пакет Circle нараховано.",
  "Пакеты Circle доступны с активной подпиской.": "Пакети Circle доступні за активної підписки.",
  "Перейти на выбранный тариф": "Перейти на вибраний тариф",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Перехід почнеться після завершення поточної підписки. Зараз оплата не потрібна.",
  "Подписка": "Підписка",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Підписка тимчасово недоступна. Спробуйте оновити дані.",
  "Подписка не продлится": "Підписку не буде продовжено",
  "Подписка обновлена.": "Підписку оновлено.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Підписка вже активна. Оновіть дані та виберіть доступну дію.",
  "Подписка уже закончилась. Обновите данные.": "Підписка вже завершилася. Оновіть дані.",
  "Подтвердить": "Підтвердити",
  "Подтверждение подписки": "Підтвердження підписки",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Покупка зараз недоступна. Реальні платежі не ввімкнено.",
  "Получить dev-пакет бесплатно": "Отримати dev-пакет безкоштовно",
  "Потом: {0}": "Потім: {0}",
  "Предыдущая подписка закончилась {0}": "Попередня підписка завершилася {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "У разі продовження оплаченого строку нова партія надійде в наступному періоді.",
  "Проверка операции": "Перевірка операції",
  "Продление включено": "Продовження ввімкнено",
  "Продлить подписку": "Продовжити підписку",
  "Свои голоса": "Власні голоси",
  "Свои голоса: {0} из {1}": "Власні голоси: {0} із {1}",
  "Сравнить тарифы": "Порівняти тарифи",
  "Срок": "Строк",
  "Срок подписки": "Строк підписки",
  "Срок: {0} мес.": "Строк: {0} міс.",
  "Тариф останется до конца срока. Следующего продления не будет.": "Тариф діятиме до кінця строку. Наступного продовження не буде.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Тарифи поки недоступні. Спробуйте оновити дані пізніше.",
  "Текущий тариф": "Поточний тариф",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Тестовий dev-каталог. Реальних платежів немає; нараховуються тестові Circle.",
  "Управление подпиской": "Керування підпискою",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Умови тарифу змінилися. Оновіть дані перед підтвердженням.",
  "Что входит": "Що входить",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Це безкоштовна dev-операція. Кошти та Telegram Stars не списуються.",
  "Этот переход между тарифами недоступен.": "Цей перехід між тарифами недоступний.",
  "Этот тариф больше недоступен. Обновите список.": "Цей тариф більше недоступний. Оновіть список.",
  "QR-код": "QR-код",
  "QR-код приглашения": "QR-код запрошення",
  "{0} из {1} · {2} Circle": "{0} із {1} · {2} Circle",
  "Виды заданий": "Типи завдань",
  "Выполнение этого задания пока недоступно.": "Виконання цього завдання поки що недоступне.",
  "Готовим материал…": "Готуємо матеріал…",
  "Действие подтверждено. Обновляем задания.": "Дію підтверджено. Оновлюємо завдання.",
  "День {0}": "День {0}",
  "День {0} из {1}": "День {0} із {1}",
  "Дней подряд: {0}": "Днів поспіль: {0}",
  "Друзья": "Друзі",
  "Ежедневная серия": "Щоденна серія",
  "Ежедневные": "Щоденні",
  "Есть награды": "Є нагороди",
  "Забрать {0} Circle": "Забрати {0} Circle",
  "Загружаем награды…": "Завантажуємо нагороди…",
  "Задание ещё не выполнено. Обновите прогресс.": "Завдання ще не виконано. Оновіть прогрес.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "Завдання зараховує відкриття надсилання сторіс. Telegram не підтверджує публікацію.",
  "Заданий в этой группе пока нет.": "У цій групі поки що немає завдань.",
  "Задания дня": "Завдання дня",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Заходьте щодня. Пропуск дня починає серію спочатку.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Потрібно перевірити результат попереднього запиту. Нові нарахування поки що заблоковано.",
  "Копирование недоступно. Выделите текст вручную.": "Копіювання недоступне. Виділіть текст вручну.",
  "Материал для сторис": "Матеріал для сторіс",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Нагороду підтверджено. Оновіть дані; повторно нараховувати не потрібно.",
  "Награда получена": "Нагороду отримано",
  "Награда получена. Завтра +{0} Circle": "Нагороду отримано. Завтра +{0} Circle",
  "Награда уже получена. Обновите данные.": "Нагороду вже отримано. Оновіть дані.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Нагороди тимчасово недоступні. Спробуйте оновити дані.",
  "Награды за друзей": "Нагороди за друзів",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Нагороди надходять у Circle: ними можна платити в STEOS, але не можна виводити.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Нарахування не підтверджено. Перевірте попередній запит; нову нагороду поки що заблоковано.",
  "Начисления приостановлены.": "Нарахування призупинено.",
  "Начислено {0} Circle": "Нараховано {0} Circle",
  "Начислено: {0} Circle": "Нараховано: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Не вдалося відновити запит на отримання нагороди. Перевірте баланс і зверніться до служби підтримки.",
  "Не удалось загрузить QR-код.": "Не вдалося завантажити QR-код.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Не вдалося відкрити надсилання сторіс. Нагороду не нараховано.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Не вдалося підготувати сторіс. Спробуйте ще раз.",
  "Новый день: {0}": "Новий день: {0}",
  "Обновить награды": "Оновити нагороди",
  "Обновятся: {0}": "Оновляться: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Відкрийте Mini App у Telegram із підтримкою сторіс.",
  "Открыть STEOS ID в профиле": "Відкрити STEOS ID у профілі",
  "Открыть сторис": "Відкрити сторіс",
  "Отправить в сторис": "Опублікувати в сторіс",
  "Партнёрские данные временно недоступны.": "Дані партнерської програми тимчасово недоступні.",
  "Партнёрство · Статистика, материалы и вывод": "Партнерство · Статистика, матеріали та виведення",
  "Первые шаги": "Перші кроки",
  "Перейти к заданию": "Перейти до завдання",
  "Получить ежедневную награду": "Отримати щоденну нагороду",
  "Приглашено: {0} · Покупателей: {1}": "Запрошено: {0} · Покупців: {1}",
  "Прогресс задания": "Прогрес завдання",
  "Прогресс задания временно недоступен.": "Прогрес завдання тимчасово недоступний.",
  "Промокод": "Промокод",
  "Разовые": "Одноразові",
  "Скопировать приглашение": "Скопіювати запрошення",
  "Скопировать промокод": "Скопіювати промокод",
  "Ссылка приглашения": "Посилання-запрошення",
  "Сторис в Telegram": "Сторіс у Telegram",
  "Челленджи недели": "Щотижневі челенджі",
  "Circle используются внутри STEOS": "Circle використовуються всередині STEOS",
  "Telegram подтвердил отправку сообщения.": "Telegram підтвердив надсилання повідомлення.",
  "Без покупок": "Без покупок",
  "В этом списке пока нет друзей.": "У цьому списку поки немає друзів.",
  "Возможен вывод по условиям программы": "Виведення можливе згідно з умовами програми",
  "Вопросы": "Запитання",
  "Всё время": "За весь час",
  "Вы здесь": "Ви тут",
  "Выберите PDF, JPG или PNG.": "Виберіть PDF, JPG або PNG.",
  "Выберите плательщика": "Виберіть платника",
  "Выбрать чат в Telegram": "Вибрати чат у Telegram",
  "Выбрать чат для отправки": "Вибрати чат для надсилання",
  "Вывод": "Виведення",
  "Вывод недоступен на текущем уровне.": "Виведення недоступне на поточному рівні.",
  "Вывод сейчас недоступен.": "Виведення наразі недоступне.",
  "Вывод средств": "Виведення коштів",
  "Выплачен": "Виплачено",
  "Выставьте счёт на": "Виставте рахунок на",
  "Для вывода войдите в STEOS ID.": "Для виведення увійдіть у STEOS ID.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Для розрахунку потрібні опубліковані рівні та тарифи.",
  "До уровня «{0}»: ещё {1} покупателей": "До рівня «{0}»: ще {1} покупців",
  "Доступно к выводу": "Доступно для виведення",
  "Доступных шаблонов пока нет.": "Доступних шаблонів поки немає.",
  "Доход": "Дохід",
  "Если купят {0} друзей": "Якщо куплять {0} друзів",
  "Есть покупки": "Є покупки",
  "За этот период начислений пока нет.": "За цей період нарахувань поки немає.",
  "Загружаем QR-код…": "Завантажуємо QR-код…",
  "Загружаем друзей…": "Завантажуємо друзів…",
  "Загружаем материалы…": "Завантажуємо матеріали…",
  "Загружаем партнёрские данные…": "Завантажуємо партнерські дані…",
  "Загрузите проверенный счёт на оплату.": "Завантажте перевірений рахунок на оплату.",
  "Заказать материал в чат": "Замовити матеріал у чат",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Запит прийнято. Доставку в чат ще не підтверджено.",
  "Заявка принята. Статус выплаты появится в истории.": "Заявку прийнято. Статус виплати з’явиться в історії.",
  "Заявок на вывод пока нет.": "Заявок на виведення поки немає.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Зміну реквізитів заблоковано до отримання результату за цією заявкою.",
  "Имя получателя": "Ім’я отримувача",
  "История выводов": "Історія виведень",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Результат запиту потрібно перевірити. Новий матеріал поки заблоковано.",
  "Как определяется уровень?": "Як визначається рівень?",
  "Как это работает": "Як це працює",
  "Калькулятор станет доступен после публикации расчётной политики.": "Калькулятор стане доступним після публікації політики розрахунків.",
  "Количество друзей": "Кількість друзів",
  "Материалы": "Матеріали",
  "Материалы временно недоступны. Попробуйте обновить список.": "Матеріали тимчасово недоступні. Спробуйте оновити список.",
  "Материалы пока недоступны.": "Матеріали поки недоступні.",
  "Месяц": "Місяць",
  "Минимальная сумма": "Мінімальна сума",
  "На рассмотрении": "На розгляді",
  "Налоговый номер": "Податковий номер",
  "Начисления за период": "Нарахування за період",
  "Начислено Circle": "Нараховано Circle",
  "Начислено за период: {0} Circle": "Нараховано за період: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Не вдалося безпечно зберегти заявку або перевірити власника. Надсилання не виконано.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Не вдалося відновити надсилання. Зверніться до служби підтримки перед новим запитом.",
  "Не удалось загрузить друзей.": "Не вдалося завантажити друзів.",
  "Не удалось загрузить историю выводов.": "Не вдалося завантажити історію виведень.",
  "Не удалось загрузить тарифы.": "Не вдалося завантажити тарифи.",
  "Не удалось открыть отправку в Telegram.": "Не вдалося відкрити надсилання в Telegram.",
  "Не удалось проверить владельца. Обновите страницу.": "Не вдалося перевірити власника. Оновіть сторінку.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Не вдалося прочитати збережену заявку. Нове виведення заблоковано.",
  "Не удалось сохранить состояние отправки.": "Не вдалося зберегти стан надсилання.",
  "Неделя": "Тиждень",
  "Нет данных": "Немає даних",
  "Новая заявка": "Нова заявка",
  "Новая заявка на вывод сейчас недоступна.": "Нова заявка на виведення наразі недоступна.",
  "О программе": "Про програму",
  "Обзор": "Огляд",
  "Обновите страницу или обратитесь в поддержку.": "Оновіть сторінку або зверніться до служби підтримки.",
  "Обновить историю выводов": "Оновити історію виведень",
  "Обновить материалы": "Оновити матеріали",
  "От {0} покупателей": "Від {0} покупців",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Відповідь не отримано. Перевірте ту саму заявку: її дані та ключ збережено.",
  "Отклонён": "Відхилено",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Відкрийте Mini App у Telegram із підтримкою надсилання матеріалів.",
  "Открыть сторис в Telegram": "Відкрити сторис у Telegram",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Надсилання не підтверджено. Повторна спроба перевірить попередній запит без нового надсилання.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Надсилання скасовано. Можна знову відкрити вибір чату.",
  "Оценка дохода": "Оцінка доходу",
  "Оценка за {0} месяцев: {1} Circle": "Оцінка за {0} місяців: {1} Circle",
  "Оценка за месяц: {0} Circle": "Оцінка за місяць: {0} Circle",
  "Переходы": "Переходи",
  "Период обзора": "Період огляду",
  "Плательщик": "Платник",
  "Подать заявку на вывод": "Подати заявку на виведення",
  "Подготовить QR-код": "Підготувати QR-код",
  "Подготовить другой материал": "Підготувати інший матеріал",
  "Подготовить материал": "Підготувати матеріал",
  "Поделитесь своей ссылкой или промокодом.": "Поділіться своїм посиланням або промокодом.",
  "Поделиться": "Поділитися",
  "Пока без покупок": "Поки без покупок",
  "Пока недоступно": "Поки недоступно",
  "Покупатели": "Покупці",
  "Покупки друзей учитывает сервер STEOS ID.": "Покупки друзів враховує сервер STEOS ID.",
  "Полные условия программы": "Повні умови програми",
  "Пользователь": "Користувач",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Спробуйте STEOS: {0}\nПромокод: {1}",
  "Привязка до: {0}": "Прив’язка до: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "Прив’язка запрошеного друга діє {0} місяців.",
  "Приглашён: {0}": "Запрошено: {0}",
  "Проверить загрузку счёта": "Перевірити завантаження рахунку",
  "Проверить ту же заявку": "Перевірити ту саму заявку",
  "Проверьте налоговый номер получателя.": "Перевірте податковий номер отримувача.",
  "Проверьте реквизиты и счёт.": "Перевірте реквізити та рахунок.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Перевірте суму виведення: ціле число в доступному діапазоні.",
  "Проверяем владельца…": "Перевіряємо власника…",
  "Проверяем заявку или счёт…": "Перевіряємо заявку або рахунок…",
  "Процент и доступность вывода определяет опубликованная программа.": "Відсоток і доступність виведення визначає опублікована програма.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Відсотки, строки й обмеження наведено за опублікованими даними сервера.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "Розмір рахунку має становити від 1 байта до 10 МБ.",
  "Регистрации": "Реєстрації",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Результат завантаження рахунку невідомий. Перевірте завантаження без повторного надсилання файлу.",
  "Скачать PNG": "Завантажити PNG",
  "Сколько действует привязка друга?": "Як довго діє прив’язка друга?",
  "Скопировать текст": "Копіювати текст",
  "Сохранена неподтверждённая заявка": "Збережено непідтверджену заявку",
  "Срок рассмотрения, дней": "Строк розгляду, днів",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Посилання та промокод додає сервер. Виберіть доступний матеріал.",
  "Ссылка на полный документ условий пока не опубликована.": "Посилання на повний документ з умовами ще не опубліковано.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Сторис відкрито в Telegram. Публікацію потрібно підтвердити в редакторі.",
  "Сумма в Circle": "Сума в Circle",
  "Сумма меньше минимальной суммы вывода.": "Сума менша за мінімальну суму виведення.",
  "Сумма превышает доступный остаток.": "Сума перевищує доступний залишок.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Рахунок на оплату · PDF, JPG або PNG, до 10 МБ",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Рахунок не пройшов завантаження або перевірку. Виберіть PDF, JPG або PNG розміром до 10 МБ.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "Рахунок ще не підтверджено. Повторіть перевірку або виберіть інший файл.",
  "Счёт проверен": "Рахунок перевірено",
  "Текст приглашения": "Текст запрошення",
  "Текст сообщения": "Текст повідомлення",
  "Тексты": "Тексти",
  "Тестовая заявка": "Тестова заявка",
  "Тестовая программа dev. Реальные выплаты выключены.": "Тестова програма dev. Реальні виплати вимкнено.",
  "Тестовая программа: реальные выплаты отключены.": "Тестова програма: реальні виплати вимкнено.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "Тестовий розрахунок dev. Це оцінка, нарахування не здійснюється.",
  "Укажите имя получателя: до 200 символов.": "Укажіть ім’я отримувача: до 200 символів.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Рівень визначає сервер на основі врахованих покупців. Дивіться вкладку «Рівні».",
  "Уровни": "Рівні",
  "Условия начислений пока не опубликованы.": "Умови нарахувань ще не опубліковано.",
  "Условия программы": "Умови програми",
  "Учёт переходов по ссылке пока недоступен.": "Облік переходів за посиланням поки недоступний.",
  "Фильтр друзей": "Фільтр друзів",
  "Что делать, если данные не обновились?": "Що робити, якщо дані не оновилися?",
  "Шаги": "Кроки",
  "Баннер": "Банер",
  "QR-постер": "QR-постер",
  "{0} / 300 знаков": "{0} / 300 символів",
  "· до 20 МБ": "· до 20 МБ",
  "Агент готовит ответ…": "Агент готує відповідь…",
  "Аудиозапись": "Аудіозапис",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Безкоштовно лише в dev. До 30 секунд і 10 МБ. Текст можна виправити перед надсиланням.",
  "Ваш вопрос": "Ваше запитання",
  "Вопрос или название инструмента": "Запитання або назва інструмента",
  "Вопросов: {0}": "Запитань: {0}",
  "Вопросы · {0}": "Запитання · {0}",
  "Восстанавливаем чат…": "Відновлення чату…",
  "Все сервисы работают": "Усі сервіси працюють",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Виберіть MP3, WAV або M4A розміром до 20 МБ.",
  "Выберите инструкцию к нужному инструменту или странице.": "Виберіть інструкцію до потрібного інструмента або сторінки.",
  "Диктовать вопрос": "Надиктувати запитання",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Диктування не підтверджено. Повторіть перевірку попереднього запиту або завантаження.",
  "До": "До",
  "Ещё спрашивают": "Також запитують",
  "Загружаем справку…": "Завантаження довідки…",
  "Загружаем статус…": "Завантаження статусу…",
  "Закрыть чат": "Закрити чат",
  "ИИ-агент поддержки": "ШІ-агент підтримки",
  "ИИ-агент сейчас недоступен.": "ІІ-агент наразі недоступний.",
  "Инструкции": "Інструкції",
  "Инструкции · {0}": "Інструкції · {0}",
  "Инструкции пока не опубликованы.": "Інструкції ще не опубліковано.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Результат запиту поки невідомий. Нове запитання не надсилається.",
  "Как пользоваться STEOS": "Як користуватися STEOS",
  "Кружки и говорящие видео": "Відеоповідомлення та відео з мовленням",
  "Медленнее обычного": "Повільніше, ніж зазвичай",
  "Написать агенту": "Написати агенту",
  "Начать": "Почати",
  "Начать новую диктовку": "Почати нове диктування",
  "Не помогло": "Не допомогло",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Не вдалося відновити диктування. Новий запит заблоковано.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Не вдалося відновити чат. Зверніться до служби підтримки.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Не вдалося завантажити довідку. Спробуйте ще раз.",
  "Не удалось загрузить статус сервисов.": "Не вдалося завантажити статус сервісів.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Не вдалося підтвердити відповідь. Можна почати новий чат або написати до служби підтримки.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Не вдалося отримати відповідь. Повторіть перевірку без нового запитання.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Не вдалося перевірити власника чату. Спробуйте відкрити чат знову.",
  "Не удалось сохранить новый чат.": "Не вдалося зберегти новий чат.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Не вдалося зберегти оцінку. Спробуйте ще раз.",
  "Недоступен": "Недоступний",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Деякі сервіси працюють повільніше, ніж зазвичай. Відкрити статус",
  "Нет подтверждённых данных": "Немає підтверджених даних",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Нічого не знайдено. Спробуйте інші слова або запитайте ІІ-агента.",
  "Новый чат": "Новий чат",
  "Обзор приложения": "Огляд застосунку",
  "Обновить справку": "Оновити довідку",
  "Обновить статус": "Оновити статус",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Опублікована перевірка. Автоматичний моніторинг не заявлено.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Відповідь не підтверджено. Перевірте попередній запит або напишіть до служби підтримки.",
  "Отвечает по опубликованной справке STEOS": "Відповідає на основі опублікованої довідки STEOS",
  "Открыть инструкции": "Відкрити інструкції",
  "Открыть инструкцию": "Відкрити інструкцію",
  "Открыть инструмент": "Відкрити інструмент",
  "Открыть ответ справки": "Відкрити відповідь у довідці",
  "Открыть раздел": "Відкрити розділ",
  "Отправить вопрос": "Надіслати запитання",
  "Оценка ответа": "Оцінка відповіді",
  "Очистить поиск": "Очистити пошук",
  "Поиск по справке": "Пошук у довідці",
  "Полезно": "Корисно",
  "Помощь": "Допомога",
  "Популярные вопросы": "Популярні запитання",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "Остання перевірка застаріла. Поточний стан невідомий.",
  "Посмотреть короткий обзор": "Переглянути короткий огляд",
  "Предыдущая": "Попередня",
  "Проверено: {0}": "Перевірено: {0}",
  "Проверить диктовку": "Перевірити диктування",
  "Пропустить": "Пропустити",
  "Работает": "Працює",
  "Распознать вопрос": "Розпізнати запитання",
  "Распознаём вопрос…": "Розпізнавання запитання…",
  "Результаты поиска": "Результати пошуку",
  "Следующая": "Наступна",
  "Советы": "Поради",
  "Справка пока не опубликована.": "Довідку ще не опубліковано.",
  "Спросите что угодно": "Запитайте будь-що",
  "Спросить ИИ-агента": "Запитати ШІ-агента",
  "Спросить ИИ-агента поддержки": "Запитати ІІ-агента підтримки",
  "Статус": "Статус",
  "Статус сервисов": "Статус сервісів",
  "Статус сервисов пока не публикуется.": "Статус сервісів поки не публікується.",
  "Статья недоступна": "Стаття недоступна",
  "Темы": "Теми",
  "Темы пока не опубликованы.": "Теми ще не опубліковано.",
  "Точного ответа в справке нет.": "У довідці немає точної відповіді.",
  "Чат не отправляет сообщения человеку автоматически.": "Чат не надсилає повідомлення людині автоматично.",
  "Читаем запись…": "Читання запису…",
  "Эта статья больше не входит в опубликованную справку.": "Ця стаття більше не входить до опублікованої довідки.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Виберіть MP3, WAV або M4A розміром до {0} МБ.",
  "До {0} · до {1} МБ": "До {0} · до {1} МБ",
  "Нужна запись от 1 секунды до {0}.": "Потрібен запис тривалістю від 1 секунди до {0}.",
  "Остановить запись · {0}": "Зупинити запис · {0}",
  "{0} C/сек": "{0} кадр/с",
  "Все инструменты": "Усі інструменти",
  "Все шаблоны": "Усі шаблони",
  "Вся подборка": "Уся добірка",
  "Выбрать, кто играет": "Вибрати, хто грає",
  "Голос и музыка": "Голос і музика",
  "Двое": "Двоє",
  "Дети": "Діти",
  "Дешевле": "Дешевше",
  "Для бизнеса": "Для бізнесу",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Для цієї дії доступно кілька шаблонів. Виберіть відповідний у каталозі.",
  "Загружаем шаблон…": "Завантажуємо шаблон…",
  "Закрыть поиск": "Закрити пошук",
  "Закрыть превью": "Закрити попередній перегляд",
  "Инструменты": "Інструменти",
  "Искать во всех шаблонах": "Шукати в усіх шаблонах",
  "Короче": "Коротше",
  "Кто играет": "Хто грає",
  "Найти инструмент или шаблон": "Знайти інструмент або шаблон",
  "Не удалось загрузить выбранный вариант.": "Не вдалося завантажити вибраний варіант.",
  "Не удалось загрузить шаблон. Обновите превью.": "Не вдалося завантажити шаблон. Оновіть попередній перегляд.",
  "Не удалось открыть инструмент.": "Не вдалося відкрити інструмент.",
  "Несколько": "Кілька",
  "Новые": "Нові",
  "Один": "Один",
  "от {0} C": "Від {0} C",
  "от {0} C/сек": "Від {0} C/сек",
  "От {0} Circle": "Від {0} Circle",
  "От А до Я": "Від А до Я",
  "Очистить": "Очистити",
  "Питомцы": "Домашні тварини",
  "По желанию": "За бажанням",
  "Подборка пока недоступна.": "Добірка поки недоступна.",
  "Подборки": "Добірки",
  "Поиск": "Пошук",
  "Пока нет доступных шаблонов": "Поки немає доступних шаблонів",
  "Популярные": "Популярні",
  "После": "Після",
  "Превью шаблона": "Попередній перегляд шаблону",
  "Пример результата пока не опубликован.": "Приклад результату ще не опубліковано.",
  "Пример сейчас недоступен.": "Приклад наразі недоступний.",
  "Рекомендуем": "Рекомендовані",
  "Смотреть все": "Переглянути всі",
  "Сначала": "Спочатку",
  "Сравнить до и после": "Порівняти до та після",
  "Стилей: {0}. Выбор на следующем шаге.": "Стилів: {0}. Вибір на наступному кроці.",
  "Удерживайте для просмотра": "Утримуйте, щоб переглянути",
  "Цена уточняется в форме создания.": "Ціну буде уточнено у формі створення.",
  "Частые вопросы": "Поширені запитання",
  "Что нужно": "Що потрібно",
  "Что хотите сделать?": "Що хочете зробити?",
  "Шаблоны и подборки": "Шаблони та добірки",
  "Это действие пока недоступно.": "Ця дія поки недоступна.",
  "е": "е",
  "за секунду": "за секунду",
  "ё": "ё",
  "{0} C в минуту": "{0} ₴ за хвилину",
  "{0} C за 100 знаков": "{0} ₴ за 100 символів",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Власник сесії змінився. Поверніться до студії після оновлення сторінки.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Не вдалося відновити збережену заявку. Нову генерацію заблоковано.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Не вдалося оновити збережену заявку. Нову генерацію заблоковано.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Не вдалося перевірити власника. Нову генерацію заблоковано.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Не вдалося зберегти заявку. Надсилання не виконано.",
  "от {0} C в минуту": "Від {0} ₴ за хвилину",
  "от {0} C за 100 знаков": "Від {0} ₴ за 100 символів",
  "Проверить статус заказа": "Перевірити статус замовлення",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Статус ще не підтверджено. Перевірте це саме замовлення пізніше.",
  "в минуту": "за хвилину",
  "за 100 знаков": "за 100 символів",
  "Анимация звука": "Анімація звуку",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "У відео залишиться оригінальна мова. Виберіть фрагмент тривалістю до однієї хвилини.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "У відео залишаться оригінальні слова. Голос можна змінити. Виберіть фрагмент тривалістю до однієї хвилини.",
  "Вид персонажа": "Вигляд персонажа",
  "Видео готово": "Відео готове",
  "Видео не создано": "Відео не створено",
  "Волна": "Хвиля",
  "Выберите, кто говорит": "Виберіть, хто говорить",
  "Выбранное фото": "Вибране фото",
  "Движение": "Рух",
  "Добавьте видео": "Додайте відео",
  "Дополнительная настройка": "Додаткове налаштування",
  "Другой голос для записи": "Інший голос для запису",
  "Ещё вариант": "Ще один варіант",
  "Ещё настройки": "Ще налаштування",
  "Изменить данные": "Змінити дані",
  "Источник": "Джерело",
  "Источник лица": "Джерело обличчя",
  "Источник речи": "Джерело мовлення",
  "Кадр по вертикали": "Кадр по вертикалі",
  "Кадр по горизонтали": "Кадр по горизонталі",
  "Каких движений избегать": "Яких рухів уникати",
  "Конец фрагмента, секунды": "Кінець фрагмента, секунди",
  "Кружком": "Відеоповідомленням",
  "Кружок готов": "Кружечок готовий",
  "Кружок не создан": "Кружечок не створено",
  "Люди и персонажи": "Люди та персонажі",
  "Напишите текст или добавьте запись": "Напишіть текст або додайте запис",
  "Начало фрагмента, секунды": "Початок фрагмента, секунди",
  "Не удалось загрузить виды персонажа.": "Не вдалося завантажити види персонажа.",
  "Не удалось загрузить людей и персонажей.": "Не вдалося завантажити людей і персонажів.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Не вдалося підтвердити завершення замовлення. Нову генерацію не розпочато.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Не вдалося перевірити доставку. Відкрийте історію замовлення.",
  "Оставить голос записи": "Залишити голос запису",
  "Открыть в чате": "Відкрити в чаті",
  "Отправлено в чат": "Надіслано в чат",
  "По умолчанию": "За замовчуванням",
  "Подтвердите право использовать материалы": "Підтвердьте право використовувати матеріали",
  "Полосы": "Смуги",
  "Портретное": "Портретне",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "Попереднє замовлення ще не завершено. Спочатку перевірте його результат.",
  "Приближение": "Наближення",
  "Проверка отклонила материал. Измените исходные данные.": "Перевірка відхилила матеріал. Змініть вихідні дані.",
  "Продолжить проверку отправки": "Продовжити перевірку надсилання",
  "Результат недоступен. Проверьте историю заказа.": "Результат недоступний. Перевірте історію замовлення.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Результат надсилання ще не підтверджено. Продовжте перевірку з тим самим ключем.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Результат ще не підтверджено. Перевірте це замовлення, перш ніж створювати нове.",
  "Своё видео": "Власне відео",
  "Своё фото": "Власне фото",
  "Создание сейчас недоступно": "Створення наразі недоступне",
  "Создать кружок": "Створити відеоповідомлення",
  "Создаём видео": "Створюємо відео",
  "Списание возвращено": "Списання повернено",
  "Тестовый заказ без списания": "Тестове замовлення без списання",
  "Файлом": "Файлом",
  "Фоновый звук": "Фоновий звук",
  "Фото с лицом": "Фото з обличчям",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Ціна або версія інструмента змінилася. Оновіть форму та перевірте вартість.",
  "Человек или персонаж": "Людина або персонаж",
  "Что скажет?": "Що скаже?",
  "Напишите не меньше {0} знаков": "Введіть щонайменше {0} символів",
  "Текст отклонён проверкой. Измените текст.": "Текст відхилено під час перевірки. Змініть текст.",
  "В видео прозвучат новые слова.": "У відео прозвучать нові слова.",
  "Если речь длиннее видео, ролик повторится.": "Якщо мовлення довше за відео, ролик повторюватиметься.",
  "Исходная речь": "Вихідне мовлення",
  "Новая запись": "Новий запис",
  "Новые слова текстом": "Нові слова текстом",
  "Речь в видео": "Мовлення у відео",
  "Размер файла не должен превышать {0} МБ.": "Розмір файлу не має перевищувати {0} МБ.",
  "До {0} МБ": "До {0} МБ",
  "Альбомное": "Альбомна",
  "Альбомом": "Альбомна орієнтація",
  "Без стиля": "Без стилю",
  "В новом стиле": "У новому стилі",
  "Вариант": "Варіант",
  "Во весь экран": "На весь екран",
  "Восстановить фото": "Відновити фото",
  "Все стили": "Усі стилі",
  "Все темы": "Усі теми",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Виберіть інструмент у каталозі, а потім підтвердьте використання фото.",
  "Выберите подходящее фото до {0} МБ.": "Виберіть відповідне фото розміром до {0} МБ.",
  "Выберите стиль или свой референс": "Виберіть стиль або власний референс",
  "Выбран свой референс": "Вибрано власний референс",
  "Выбрать стиль": "Вибрати стиль",
  "Двигайте картинку, чтобы выбрать кадр": "Переміщуйте зображення, щоб вибрати кадр",
  "Диафрагма": "Діафрагма",
  "Добавить человека": "Додати людину",
  "Добавьте описание, от 10 знаков": "Додайте опис завдовжки щонайменше 10 символів",
  "Загрузите фото": "Завантажте фото",
  "Заполните обязательные поля": "Заповніть обов’язкові поля",
  "Изменить фото": "Змінити фото",
  "Использовать выбранное фото результата": "Використати вибране фото результату",
  "Кадр": "Кадр",
  "Кадрирование": "Кадрування",
  "Как у фото": "Як на фото",
  "Камера": "Камера",
  "Найти настройку съёмки": "Знайти налаштування зйомки",
  "Найти стиль": "Знайти стиль",
  "Настройки съёмки недоступны.": "Налаштування зйомки недоступні.",
  "Начать новое улучшение": "Почати нове покращення",
  "Не выбран": "Не вибрано",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Не вдалося відновити покращення. Повторне надсилання заблоковано.",
  "Не удалось загрузить режимы фото.": "Не вдалося завантажити режими фото.",
  "Не удалось загрузить фото.": "Не вдалося завантажити фото.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Не вдалося використати фото результату. Відкрийте початкове замовлення та спробуйте ще раз.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Не вдалося відкрити режим. Спробуйте ще раз.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Не вдалося передати вибране фото. Спробуйте ще раз.",
  "Не удалось проверить владельца.": "Не вдалося перевірити власника.",
  "Не удалось прочитать фото.": "Не вдалося прочитати фото.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Не вдалося покращити текст. Початковий текст збережено.",
  "О стиле": "Про стиль",
  "Объектив": "Об’єктив",
  "Оживить фото": "Оживити фото",
  "Описание во весь экран": "Опис на весь екран",
  "Описание длиннее допустимого": "Опис перевищує допустиму довжину",
  "По вертикали": "Вертикально",
  "По горизонтали": "Горизонтально",
  "По описанию": "За описом",
  "Повторить прежнее улучшение": "Повторити попереднє покращення",
  "Подтвердите права на материалы": "Підтвердьте права на матеріали",
  "Пример": "Приклад",
  "Проверить улучшение": "Перевірити покращення",
  "Проверяем фото…": "Перевіряємо фото…",
  "Ракурс": "Ракурс",
  "Раскрасить чёрно-белое": "Розфарбувати чорно-біле фото",
  "Режим фото": "Режим фото",
  "Референс должен быть не меньше 256 × 256 пикселей.": "Референс має бути розміром не менше 256 × 256 пікселів.",
  "Свернуть": "Згорнути",
  "Свет": "Світло",
  "Свой референс": "Власний референс",
  "Свой референс сейчас недоступен": "Власний референс наразі недоступний",
  "Сделать рилс": "Створити рилс",
  "Сколько фото": "Кількість фото",
  "Создать фото": "Створити фото",
  "Создаём фото": "Створюємо фото",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Час перевірки покращення минув. Початковий текст збережено.",
  "Тема стиля": "Тема стилю",
  "Убрать из кадра": "Прибрати з кадру",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "Покращення ще не підтверджено. Початковий текст збережено.",
  "Улучшить": "Покращити",
  "Формат файла": "Формат файлу",
  "Фото готовы": "Фото готові",
  "Фото на аватарку": "Фото на аватар",
  "Фото не создано": "Фото не створено",
  "Цвет": "Колір",
  "Что дальше": "Що далі",
  "Что делает в кадре": "Що робить у кадрі",
  "Выберите разных людей в кадре": "Виберіть різних людей у кадр",
  "Измените описание и попробуйте улучшить его снова.": "Змініть опис і спробуйте покращити його знову.",
  "Использовать референс": "Використати референс",
  "Авто": "Авто",
  "Без движения": "Без руху",
  "Видео должно длиться не меньше секунды": "Відео має тривати щонайменше секунду",
  "Выберите главное фото": "Виберіть головне фото",
  "Выберите один исходный файл": "Виберіть один вихідний файл",
  "Выберите файл подходящего формата и размера": "Виберіть файл підтримуваного формату й розміру",
  "Выберите фрагмент от 1 до 10 секунд": "Виберіть фрагмент від 1 до 10 секунд",
  "Главное фото": "Головне фото",
  "Длительность исходника: {0} с": "Тривалість оригіналу: {0} с",
  "Добавить речь": "Додати мовлення",
  "Загрузите видео": "Завантажте відео",
  "Загрузите фото или видео": "Завантажте фото або відео",
  "Загрузить": "Завантажити",
  "Загрузить видео": "Завантажити відео",
  "Загрузить фото": "Завантажити фото",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Звук оригіналу не зберігається: модель створює новий звук.",
  "Звук от модели": "Звук від моделі",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Модель створює фонові звуки, шуми й музику. Мовлення можна додати після створення.",
  "Использовать видео результата": "Використати отримане відео",
  "Исходное видео": "Вихідне відео",
  "Исходный файл": "Вихідний файл",
  "Как двигаться": "Як рухатися",
  "Конец фрагмента, мс": "Кінець фрагмента, мс",
  "Конец, секунды": "Кінець, секунди",
  "Люди в кадре недоступны для этого режима": "Люди в кадрі недоступні в цьому режимі",
  "Начало фрагмента, мс": "Початок фрагмента, мс",
  "Начало, секунды": "Початок, секунди",
  "Не удалось загрузить режимы видео.": "Не вдалося завантажити режими відео.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Не вдалося використати отримане відео. Відкрийте вихідне замовлення й спробуйте знову.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Не вдалося передати відео. Відкрийте вихідне замовлення й спробуйте знову.",
  "Новое": "Нове",
  "Объёмное фото создаётся без звука": "Об’ємне фото створюється без звуку",
  "Первый кадр": "Перший кадр",
  "Продолжить загрузку": "Продовжити завантаження",
  "Разрешение": "Роздільність",
  "Режим видео": "Режим відео",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Використаємо головне фото. Виберіть головне фото для кадрування.",
  "Снять": "Зняти",
  "Снять видео": "Зняти відео",
  "Создать видео": "Створити відео",
  "Темп": "Темп",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Фіксований формат: портрет 3:4, відео на 5 секунд",
  "Фото товара": "Фото товару",
  "Фрагмент от 1 до 10 секунд": "Фрагмент від 1 до 10 секунд",
  "Хит": "Популярне",
  "Что изменить": "Що змінити",
  "Этот режим видео пока недоступен": "Цей режим відео поки недоступний",
  "Как у исходника": "Як в оригіналі",
  "Со звуком": "Зі звуком",
  "Без звука": "Без звуку",
  "5 секунд": "5 секунд",
  "10 секунд": "10 секунд",
  "Не удалось прочитать файл.": "Не вдалося прочитати файл.",
  "1. Видео с вами": "1. Відео з вами",
  "1. Видео с движениями": "1. Відео з рухами",
  "2. Кем стать": "2. Ким стати",
  "2. Кто повторит": "2. Хто повторить",
  "Видео должно длиться не меньше {0} секунд": "Відео має тривати щонайменше {0} секунд",
  "Водяной знак — недоступен": "Водяний знак — недоступний",
  "Вы, близкий или персонаж": "Ви, близька людина або персонаж",
  "Выберите допустимый фрагмент видео": "Виберіть фрагмент допустимої тривалості",
  "Выберите одного героя": "Виберіть одного героя",
  "Выберите фон": "Виберіть фон",
  "Выберите, кто повторит движения": "Виберіть, хто повторить рухи",
  "Голос героя — недоступен": "Голос героя — недоступний",
  "Другой голос — недоступен": "Інший голос — недоступний",
  "Загрузите видео с движениями": "Завантажте відео з рухами",
  "Из видео": "Із відео",
  "Изменить людей и свои фото": "Змінити людей і свої фото",
  "Источник героя": "Джерело героя",
  "Исходный звук сохраняется, если он есть в ролике.": "Звук оригіналу зберігається, якщо він є у відео.",
  "Кадр, ракурс и фон берутся с фото героя.": "Кадр, ракурс і фон беруться з фото героя.",
  "Кто повторит движения": "Хто повторить рухи",
  "На фото должны быть видны голова, плечи и корпус.": "На фото мають бути видні голова, плечі й тулуб.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "У кадрі має бути одна людина. На фото й відео мають бути видні голова, плечі й тулуб.",
  "Подтвердите права и согласие человека": "Підтвердьте права й згоду людини",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Підтверджую права на матеріали й згоду людини на використання її зображення",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Перетворення на кружечок недоступне: у результаті немає підтвердженої звукової доріжки.",
  "Режим движения": "Режим руху",
  "С героя": "З героя",
  "Смена голоса пока недоступна": "Зміна голосу поки недоступна",
  "Снять выбор": "Скасувати вибір",
  "Сохранение исходного звука не подтверждено.": "Збереження звуку оригіналу не підтверджено.",
  "Стать персонажем": "Стати персонажем",
  "Сцена и движения берутся из видео; внешность может отличаться.": "Сцена й рухи беруться з відео; зовнішність може відрізнятися.",
  "Только свои фото или с согласием человека на фото": "Лише власні фото або за згодою людини на фото",
  "Фон": "Фон",
  "Фото героя": "Фото героя",
  "Фрагмент от {0} до {1} секунд": "Фрагмент від {0} до {1} секунд",
  "{0} символов": "{0} символів",
  "Авито": "Avito",
  "Английский": "Англійська",
  "Выберите аудио или видео": "Виберіть аудіо або відео",
  "Выбрать": "Вибрати",
  "Гарантия": "Гарантія",
  "Да": "Так",
  "Для чего нужен промпт": "Для чого потрібен промпт",
  "Для этого инструмента сократите текст до 500 символов.": "Для цього інструмента скоротіть текст до 500 символів.",
  "Добавьте текст": "Додайте текст",
  "Добавьте файл": "Додайте файл",
  "Дополнительные варианты": "Додаткові варіанти",
  "Дополнительные варианты пока не подтверждены.": "Додаткові варіанти ще не підтверджені.",
  "Дружелюбный": "Дружній",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Завантажте запис або запишіть голос. Розпізнавання почнеться після підтвердження.",
  "Исходное фото": "Вихідне фото",
  "Как изменить текст": "Як змінити текст",
  "Комплект": "Комплект",
  "Короткий": "Короткий",
  "Материал": "Матеріал",
  "Музыка": "Музика",
  "На весь экран": "На весь екран",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Не вдалося відкрити інструмент. Перевірте акаунт і довжину тексту.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Не вдалося підтвердити додаткові варіанти. Перевірте той самий запит.",
  "Не удалось скачать текст.": "Не вдалося завантажити текст.",
  "Не удалось скопировать текст.": "Не вдалося скопіювати текст.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Не вдалося зберегти чернетку. Створення заблоковане, щоб не втратити дані.",
  "Нейтральный": "Нейтральний",
  "Нет": "Ні",
  "Объём описания": "Обсяг опису",
  "Описание товара": "Опис товару",
  "Повторить запрос с тем же ключом": "Повторити з тим самим ключем",
  "Подарочный": "Подарунковий",
  "Подробнее": "Докладніше",
  "Подробный": "Докладний",
  "Подтверждаю права на материалы": "Підтверджую права на матеріали",
  "Пожелания": "Побажання",
  "Показать время": "Показати час",
  "Показать всё": "Показати все",
  "Премиальный": "Преміальний",
  "Проверить тот же запрос": "Перевірити той самий запит",
  "Продающий": "Продавальний",
  "Промпт из видео пока недоступен.": "Промпт із відео поки недоступний.",
  "Промпт из фото": "Промпт із фото",
  "Разделить по собеседникам": "Розділити за співрозмовниками",
  "Размеры": "Розміри",
  "Распознавание по ссылке YouTube пока недоступно.": "Розпізнавання за посиланням YouTube поки недоступне.",
  "Распознать": "Розпізнати",
  "Редактировать текст": "Редагувати текст",
  "Сайт": "Сайт",
  "Сбросить сохранённый черновик": "Скинути збережену чернетку",
  "Скачать TXT": "Завантажити TXT",
  "Скопировать весь текст": "Скопіювати весь текст",
  "Собеседник {0}": "Співрозмовник {0}",
  "Создать промпт": "Створити промпт",
  "Создать сценарий": "Створити сценарій",
  "Создаём текст": "Створюємо текст",
  "Сократите пожелания": "Скоротіть побажання",
  "Сократите текст": "Скоротіть текст",
  "Список": "Список",
  "Текст готов": "Текст готовий",
  "Текст из аудио и видео": "Текст з аудіо та відео",
  "Текст не создан": "Текст не створено",
  "Тестовый режим без списания": "Тестовий режим без списання",
  "Тон описания": "Тон опису",
  "Улучшить промпт": "Покращити промпт",
  "Уход": "Догляд",
  "Что добавить в описание": "Що додати до опису",
  "Экспертный": "Експертний",
  "Язык": "Мова",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Додайте фото у відкритому інструменті.",
  "Не удалось открыть фото.": "Не вдалося відкрити фото.",
  "Текст для видео": "Текст для відео",
  "Цена этого выбора пока не подтверждена": "Ціну цього вибору ще не підтверджено",
  "C за фото": "C за фото",
  "C за секунду": "C за секунду",
  "Обычный": "Звичайний",
  "Кто повторил": "Хто повторив",
  "Человек с фото": "Людина з фото",
  "Сменить фон": "Змінити фон",
  "Убрать лишнее": "Прибрати зайве",
  "Добавить очки": "Додати окуляри",
  "Причёска": "Зачіска",
  "Улыбка": "Усмішка",
  "Деловой образ": "Діловий образ",
  "Летний фон": "Літній фон",
  "Машет рукой": "Махає рукою",
  "Ветер": "Вітер",
  "Плавнее": "Плавніше",
  "Ярче": "Яскравіше",
  "День в ночь": "День на ніч",
  "Снег": "Сніг",
  "Очки": "Окуляри",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Що має бути на фото? Наприклад: дівчина з парасолькою на мокрій вулиці, вечір, вогні вітрин",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Що змінити на фото? Наприклад: заміни фон на нічне місто, додай окуляри",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Що додати чи змінити? Наприклад: діловий костюм, легка усмішка",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Що відбувається в ролику? Наприклад: камера повільно летить над нічним містом, вогні й мокрий асфальт",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Як рухатися? Наприклад: усміхається й махає рукою, вітер у волоссі",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Що змінити у відео? Наприклад: заміни фон на нічне місто, додай сніг",
  "Что добавить? Например: движения плавнее, ярче": "Що додати? Наприклад: плавніші рухи, яскравіше",
  "Сменить голос в записи": "Змінити голос у записі",
  "Загрузите запись": "Завантажте запис",
  "Ваша речь зазвучит выбранным голосом": "Ваше мовлення звучатиме вибраним голосом",
  "Голосовое, интервью или заметку: уберём шум": "Голосове, інтерв’ю чи нотатку: приберемо шум",
  "Библиотека и ваши клоны": "Бібліотека та ваші клони",
  "Без переозвучки, выберите другой": "Без переозвучення, виберіть інший",
  "· Мой голос": "· Мій голос",
  "· ещё {0}+ голосов": "· ще {0}+ голосів",
  "Убрать шум": "Прибрати шум",
  "Перед сменой голоса уберём фон и эхо": "Перед зміною голосу приберемо фон і відлуння",
  "Оставим только голос, без фона и эха": "Залишимо тільки голос, без фону й відлуння",
  "Голосовым или файлом: выберете, когда запись будет готова": "Голосовим або файлом: виберете, коли запис буде готовий",
  "Сменить голос": "Змінити голос",
  "Сделать голосовым": "Зробити голосовим",
  "{0} · от {1} C": "{0} · від {1} C",
  "Сначала остановите запись": "Спершу зупиніть запис",
  "Загрузите или запишите аудио": "Завантажте або запишіть аудіо",
  "Читаем запись, секунду": "Читаємо запис, секунду",
  "Запись длиннее {0}, загрузите короче": "Запис довший за {0}, завантажте коротший",
  "Выберите голос, которым зазвучит запись": "Виберіть голос, яким звучатиме запис",
  "Этот голос не умеет переозвучку, выберите другой": "Цей голос не вміє переозвучувати, виберіть інший",
  "Пауза": "Пауза",
  "Длиннее {0}": "Довше за {0}",
  "Звучит запись": "Звучить запис",
  "Прослушать запись": "Прослухати запис",
  "Загрузите запись короче": "Завантажте коротший запис",
  "Запись с микрофона": "Запис із мікрофона",
  "Без шума": "Без шуму",
  "Как в записи": "Як у записі",
  "Слушать": "Слухати",
  "Отправить голосовым": "Надіслати голосовим",
  "Отправить файлом": "Надіслати файлом",
  "Голосовое в чате": "Голосове в чаті",
  "Файл в чате": "Файл у чаті",
  "Голосовое в чате, в отдельной теме": "Голосове в чаті, в окремій темі",
  "Файл в чате, в отдельной теме": "Файл у чаті, в окремій темі",
  "Тут откроется тема чата, куда бот прислал голосовое": "Тут відкриється тема чату, куди бот надіслав голосове",
  "Тут откроется тема чата, куда бот прислал запись": "Тут відкриється тема чату, куди бот надіслав запис",
  "Меняем голос": "Змінюємо голос",
  "Собираем запись": "Збираємо запис",
  "Шум убран": "Шум прибрано",
  "Запись готова": "Запис готовий",
  "Голос изменён": "Голос змінено",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Можна піти з екрана: бот напише, коли запис буде готовий.",
  "Голос ваш, шума больше нет.": "Голос ваш, шуму більше немає.",
  "Голос ваш, запись готова стать голосовым.": "Голос ваш, запис готовий стати голосовим.",
  "Слова и интонация ваши, голос новый.": "Слова та інтонація ваші, голос новий.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Надішлемо в чат голосовим або файлом, як зручніше.",
  "Запись ещё собирается": "Запис ще збирається",
  "Заставить говорить": "Змусити говорити",
  "Заменить запись": "Замінити запис",
  "Загружаем запись": "Завантажуємо запис",
  "Запись загружена": "Запис завантажено",
  "Запись собрана": "Запис зібрано",
  "Запись не прошла проверку": "Запис не пройшов перевірку",
  "запись не собрана": "запис не зібрано",
  "голос не изменён": "голос не змінено",
  "Не получилось убрать шум": "Не вдалося прибрати шум",
  "Не получилось собрать запись": "Не вдалося зібрати запис",
  "Не получилось сменить голос": "Не вдалося змінити голос",
  "Обновить форму": "Оновити форму",
  "Запись {0}": "Запис {0}",
  "Проверяем доступность": "Перевіряємо доступність",
  "Загрузите запись заново": "Завантажте запис знову",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Не вдалося вибрати голос. Спробуйте ще раз.",
  "Запись здесь недоступна, загрузите файл": "Запис тут недоступний, завантажте файл",
  "Не удалось прочитать запись, попробуйте ещё раз": "Не вдалося прочитати запис, спробуйте ще раз",
  "Ваш голос": "Ваш голос",
  "в аудио": "в аудіо",
  "со скидкой, {0} водяной знак": "зі знижкою, {0} водяний знак",
  "Запись ещё загружается": "Запис ще завантажується",
  "Проверяем отправку": "Перевіряємо надсилання",
  "Этот способ отправки сейчас недоступен": "Цей спосіб надсилання зараз недоступний",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Надсилання ще не підтверджено. Натисніть ще раз — перевіримо той самий запит.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Не вдалося передати запис. Відкрийте роботу в «Історії» та спробуйте знову.",
  "Попробовать ещё раз": "Спробувати ще раз",
  "Проверить ещё раз": "Перевірити ще раз",
  "К настройкам": "До налаштувань",
  "Заказ не создан": "Замовлення не створено",
  "Заказ не подтверждён": "Замовлення не підтверджено",
  "остаток": "залишок",
  "Права на материалы": "Права на матеріали",
  "Только свои файлы или с согласия владельца": "Лише власні файли або за згодою власника",
  "Загружаем файл": "Завантажуємо файл",
  "Создаём": "Створюємо",
  "Файл больше {0} МБ, загрузите меньше": "Файл більший за {0} МБ, завантажте менший",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "Фото менше за {0} × {1} пікселів, завантажте більше",
  "Видео длиннее {0}, загрузите короче": "Відео довше за {0}, завантажте коротше",
  "Запись короче {0}, загрузите длиннее": "Запис коротший за {0}, завантажте довший",
  "Видео короче {0}, загрузите длиннее": "Відео коротше за {0}, завантажте довше",
  "Не удалось открыть фото. Загрузите его заново.": "Не вдалося відкрити фото. Завантажте його знову.",
  "Не удалось открыть видео. Загрузите его заново.": "Не вдалося відкрити відео. Завантажте його знову.",
  "Можно до {0} фото": "Можна до {0} фото",
  "Этот человек не участвует": "Ця людина не бере участі",
  "Добавьте фото": "Додайте фото",
  "Файл не читается, загрузите другой": "Файл не читається, завантажте інший",
  "Запись слишком короткая": "Запис надто короткий",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Не вдалося відкрити запис для прослуховування. Завантажте його знову.",
  "Файл не прошёл проверку. Выберите другой файл.": "Файл не пройшов перевірку. Виберіть інший файл.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Забагато завантажень поспіль. Зачекайте хвилину й виберіть файл знову.",
  "Файл не принят. Выберите его снова.": "Файл не прийнято. Виберіть його знову.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Вибраний персонаж, голос або шаблон став недоступним. Виберіть інший — замовлення не створено.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Створення зараз недоступне. Замовлення не створено, Circle не списано.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Попередня робота ще створюється. Коли вона буде готова, надішліть замовлення знову.",
  "Политику и запрещённые темы не пропускаем.": "Політику та заборонені теми не пропускаємо.",
  "{0} C списаны, {1}.": "{0} C списано, {1}.",
  "{0} C вернулись на баланс.": "{0} C повернулися на баланс.",
  ", на шаге «{0}»": ", на кроці «{0}»",
  "Сбой на нашей стороне": "Збій на нашому боці",
  "{0} или {1}": "{0} або {1}",
  "до {0}": "до {0}",
  "Записать": "Записати",
  "Заменить": "Замінити",
  "Нужна запись: MP3, WAV или M4A": "Потрібен запис: MP3, WAV або M4A",
  "Нужно фото: JPG или PNG": "Потрібне фото: JPG або PNG",
  "Нужно видео: MP4 или MOV": "Потрібне відео: MP4 або MOV",
  "Нужен файл PDF, DOCX или TXT": "Потрібен файл PDF, DOCX або TXT",
  "Нужно фото или видео": "Потрібне фото або відео",
  "Файл больше {0} МБ": "Файл більший за {0} МБ",
  "Остановить запись": "Зупинити запис",
  "Запрашиваем микрофон": "Запитуємо мікрофон",
  "Отменить запись": "Скасувати запис",
  "{0} КБ": "{0} КБ",
  "{0} МБ": "{0} МБ",
  "Не хватает {0} C · Пополнить": "Бракує {0} C · Поповнити",
  "Не хватает Circle": "Бракує Circle",
  "Не хватает {0} C": "Бракує {0} C",
  "На балансе {0} C, нужно {1} C": "На балансі {0} C, потрібно {1} C",
  "Создать за {0} вместо {1} C": "Створити за {0} замість {1} C",
  "Создать за {0} C вместо {1} C": "Створити за {0} C замість {1} C",
  "Со скидкой всё равно не хватает {0}": "Навіть зі знижкою бракує {0}",
  "Со скидкой всё равно не хватает {0} C": "Навіть зі знижкою бракує {0} C",
  "Для этой работы скидки нет": "Для цієї роботи знижки немає",
  "Сделать дешевле на {0}%, с водяным знаком": "Зробити дешевше на {0}%, з водяним знаком",
  "Сделать дешевле на 10%, с водяным знаком": "Зробити дешевше на 10%, з водяним знаком",
  "Назад в студию": "Назад до студії",
  "Работа ещё создаётся": "Робота ще створюється",
  "Ваше фото": "Ваше фото",
  "Ваши фото": "Ваші фото",
  "Ваш текст": "Ваш текст",
  "Ваша тема": "Ваша тема",
  "Тема поста": "Тема публікації",
  "Готовые кадры": "Готові кадри",
  "Готовый кружок": "Готовий відеокружечок",
  "Готовый ролик": "Готовий ролик",
  "Готовое фото": "Готове фото",
  "Готовая аватарка": "Готова аватарка",
  "Готовые слайды": "Готові слайди",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Готовий сюжет із вами: монтаж і музика вже в шаблоні",
  "Пост в стиле шаблона, {0} на выбор": "Публікація в стилі шаблону, {0} на вибір",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Аватарка для соцмереж і месенджерів, {0} на вибір",
  "Фотосессия из {0} кадра в стиле шаблона": "Фотосесія з {0} кадру в стилі шаблону",
  "Фотосессия из {0} кадров в стиле шаблона": "Фотосесія з {0} кадрів у стилі шаблону",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Ваш знімок оживе в короткому ролику, {0} на вибір",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Персонаж скаже ваш текст у відеокружечку Telegram, {0} на вибір",
  "Карусель слайдов для поста, {0} на выбор": "Карусель слайдів для публікації, {0} на вибір",
  "{0} стиль": "{0} стиль",
  "{0} стиля": "{0} стилі",
  "{0} стилей": "{0} стилів",
  "{0}, выберете на следующем шаге": "{0}, оберете на наступному кроці",
  "Что скажет герой, до 250 знаков": "Що скаже герой, до 250 знаків",
  "1 фото": "1 фото",
  "Любое, где хорошо видно лицо": "Будь-яке, де добре видно обличчя",
  "Лицо крупно и при хорошем свете": "Обличчя крупно й при доброму світлі",
  "Селфи, лицо крупно": "Селфі, обличчя крупно",
  "Снимок оживёт в ролике": "Знімок оживе в ролику",
  "Или фото, из которых сделаем слайды": "Або фото, з яких зробимо слайди",
  "Стиль кружка": "Стиль відеокружечка",
  "1 человек": "1 людина",
  "Вы, близкие или персонаж": "Ви, близькі або персонаж",
  "Ваши дети, до {0}": "Ваші діти, до {0}",
  "Ребёнок, одно фото": "Дитина, одне фото",
  "Питомец, одно фото": "Улюбленець, одне фото",
  "Вы или близкие, одно фото": "Ви або близькі, одне фото",
  "По желанию: вы, близкие или персонаж": "За бажанням: ви, близькі або персонаж",
  "По желанию: ваши дети, до {0}": "За бажанням: ваші діти, до {0}",
  "По желанию: ребёнок, одно фото": "За бажанням: дитина, одне фото",
  "По желанию: питомец, одно фото": "За бажанням: улюбленець, одне фото",
  "По желанию: вы или близкие, одно фото": "За бажанням: ви або близькі, одне фото",
  "Reels": "Reels",
  "Аватар": "Аватар",
  "{0} кадр": "{0} кадр",
  "{0} кадра": "{0} кадри",
  "{0} кадров": "{0} кадрів",
  "Выбрать, кто играет: {0}": "Вибрати, хто грає: {0}",
  "Сравнить: {0} и {1}": "Порівняти: {0} і {1}",
  "Поровну": "Порівну",
  "Пример результата пока не опубликован": "Приклад результату ще не опубліковано",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Результат збережено в «Історії». У чат не надсилаємо — так вибрано в налаштуваннях.",
  "Результат сохранён в «Истории».": "Результат збережено в «Історії».",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Файл результату поки недоступний. Перевірте роботу в «Історії».",
  ", голос для: {0}": ", голос для: {0}",
  ", играет: {0}": ", грає: {0}",
  ": добавьте свои фото": ": додайте свої фото",
  ": добавьте фото": ": додайте фото",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> з <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG або PNG, до 10 МБ",
  "JPG, PNG · до {0} снимков": "JPG, PNG · до {0} знімків",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV або M4A, до 50 МБ",
  "MP4 или MOV, до 200 МБ": "MP4 або MOV, до 200 МБ",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX або TXT, до 20 МБ",
  "{0} и {1}": "{0} і {1}",
  "{0} фото": "{0} фото",
  "{0} фото · как в жизни": "{0} фото · як у житті",
  "{0}, персонаж": "{0}, персонаж",
  "Анфас, вполоборота, с улыбкой и без": "Анфас, упівоберта, з усмішкою і без",
  "Без модели": "Без моделі",
  "Без сильных теней и фильтров": "Без різких тіней і фільтрів",
  "Было": "Було",
  "В близких": "У близьких",
  "В кадре {0}": "У кадрі {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "У кадрі вже {0} з {1}: зніміть позначку з когось",
  "В кадре: {0}": "У кадрі: {0}",
  "В роли «{0}» не больше {1}": "У ролі «{0}» не більше {1}",
  "В роль «{0}» персонажи не входят": "У роль «{0}» персонажі не входять",
  "В роль «{0}» подходят {1}": "У роль «{0}» підходять {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Варіанти створюються з ваших фото в розділі «Власний аватар». Вибраний з’являється в «Хто в кадрі» на всіх екранах.",
  "Ваш питомец из близких": "Ваш улюбленець із близьких",
  "Ваш ребёнок из близких": "Ваша дитина з близьких",
  "Ваши фото: один раз для всех инструментов": "Ваші фото: один раз для всіх інструментів",
  "Вкл": "Увімк.",
  "Впишите имя": "Впишіть ім’я",
  "Все <span class=\"mono\">{0}</span>": "Усі <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Усі варіанти на виду",
  "Все персонажи": "Усі персонажі",
  "Вы и персонажи": "Ви і персонажі",
  "Вы или персонаж": "Ви або персонаж",
  "Вы, близкие и персонажи": "Ви, близькі й персонажі",
  "Вы, свои фото": "Ви, свої фото",
  "Вы: добавьте свои фото": "Ви: додайте свої фото",
  "Выберите вариант": "Виберіть варіант",
  "Выберите вариант для поля «{0}»": "Виберіть варіант для поля «{0}»",
  "Выберите ниже": "Виберіть нижче",
  "Выберите одного": "Виберіть одного",
  "Выберите, кто играет: {0}": "Виберіть, хто грає: {0}",
  "Выберите, кто это для вас": "Виберіть, ким це вам доводиться",
  "Выбирать во всех инструментах без загрузки": "Вибирати в усіх інструментах без завантаження",
  "Выбор встанет во все инструменты": "Вибір застосується до всіх інструментів",
  "Выбрать «{0}»": "Вибрати «{0}»",
  "Выбрать вариант": "Вибрати варіант",
  "Выбрать: {0}": "Вибрати: {0}",
  "Выкл": "Вимк.",
  "Выключится, когда выберете вариант": "Вимкнеться, коли ви виберете варіант",
  "Группы": "Групи",
  "Добавить": "Додати",
  "Добавить в кадр": "Додати в кадр",
  "Добавьте свои фото": "Додайте свої фото",
  "Добавьте свои фото или вариант": "Додайте свої фото або варіант",
  "Добавьте фото: {0}": "Додайте фото: {0}",
  "Другой голос": "Інший голос",
  "Ещё {0}: {1}": "Ще {0}: {1}",
  "Заготовки": "Заготовки",
  "Загрузите файл": "Завантажте файл",
  "Загрузить ещё": "Завантажити ще",
  "Закрыть камеру": "Закрити камеру",
  "Запись недоступна. Загрузите видео.": "Запис недоступний. Завантажте відео.",
  "Здесь подходят {0}": "Тут підходять {0}",
  "Здесь только персонажи своей подборки": "Тут лише персонажі своєї добірки",
  "Играет: {0}": "Грає: {0}",
  "Из ваших фото": "З ваших фото",
  "Из каталога": "З каталогу",
  "Изменить ваши фото": "Змінити ваші фото",
  "Изменить свои фото": "Змінити свої фото",
  "Изменить: {0}": "Змінити: {0}",
  "Иллюстрация": "Ілюстрація",
  "Имя": "Ім’я",
  "Имя и фото · роли выбираются в ряду": "Ім’я та фото · ролі вибираються в ряду",
  "Искать стиль": "Шукати стиль",
  "Каким вы будете": "Яким ви будете",
  "Камера · лицо в кадр": "Камера · обличчя в кадр",
  "Камера · селфи в кадр": "Камера · селфі в кадр",
  "Камера недоступна · имитация": "Камера недоступна · імітація",
  "Камера недоступна. Загрузите файл.": "Камера недоступна. Завантажте файл.",
  "Каталог 2 400+ голосов, подборки": "Каталог 2 400+ голосів, добірки",
  "Ко всем стилям": "До всіх стилів",
  "Кто будет моделью на фото": "Хто буде моделлю на фото",
  "Кто играет: <b>{0}</b>": "Хто грає: <b>{0}</b>",
  "Кто играет: {0}": "Хто грає: {0}",
  "Кто это для вас": "Ким це вам доводиться",
  "Лицо в круг, смотрите в камеру": "Обличчя в коло, дивіться в камеру",
  "Люди": "Люди",
  "Можно близких или персонажа": "Можна близьких або персонажа",
  "Можно ваших близких": "Можна ваших близьких",
  "Можно до {0} видео": "Можна до {0} відео",
  "Можно до {0} записей": "Можна до {0} записів",
  "Можно до {0} записи": "Можна до {0} записів",
  "Можно до {0} запись": "Можна до {0} запису",
  "Можно до {0} файл": "Можна до {0} файлу",
  "Можно до {0} файла": "Можна до {0} файлів",
  "Можно до {0} файлов": "Можна до {0} файлів",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Можна і так, але 3 або більше знімків дадуть точнішу схожість",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Можна і так, але 3 або більше фото дадуть точнішу схожість",
  "Можно себя или близких": "Можна себе або близьких",
  "Можно себя, близких или персонажа": "Можна себе, близьких або персонажа",
  "На этом экране вы в кадре всегда": "На цьому екрані ви завжди в кадрі",
  "Навсегда, вместе с фото": "Назавжди, разом із фото",
  "Нажмите, чтобы выбрать": "Натисніть, щоб вибрати",
  "Найти": "Знайти",
  "Напишите пару слов, и мы предложим варианты": "Напишіть кілька слів, і ми запропонуємо варіанти",
  "Например: Барсик": "Наприклад: Барсик",
  "Например: Лёша": "Наприклад: Олекса",
  "Нашли": "Знайшли",
  "Не получилось подготовить файл": "Не вдалося підготувати файл",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Не вдалося покращити. Спробуйте дописати кілька слів",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Не вміщується<span class=\"nfx\">: до {0} знаків</span>",
  "Необязательно: всё уже настроено": "Необов’язково: усе вже налаштовано",
  "Ничего не нашлось": "Нічого не знайшлося",
  "Нужно выбрать": "Потрібно вибрати",
  "Объём": "Об’єм",
  "Один раз для всех инструментов": "Один раз для всіх інструментів",
  "Отменить свой вариант": "Скасувати свій варіант",
  "Отметьте, кто будет в кадре · {0}": "Позначте, хто буде в кадрі · {0}",
  "Персонажи": "Персонажі",
  "Подберём сами": "Підберемо самі",
  "Подбираем варианты": "Добираємо варіанти",
  "Пожилой": "Літній",
  "Поиск стилей": "Пошук стилів",
  "Пока нечего сохранять": "Поки нічого зберігати",
  "Попробуйте другое слово": "Спробуйте інше слово",
  "Порядок здесь один": "Порядок тут один",
  "Примеры": "Приклади",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Зникне {0} разом із фото. Повернути не вийде.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Зникне з близьких разом із фото. Повернути не вийде.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Зникне з близьких і {0} разом із фото. Повернути не вийде.",
  "Профиль близкого": "Профіль близької людини",
  "Разные ракурсы и выражения": "Різні ракурси та вирази",
  "Реалистичный": "Реалістичний",
  "Реалистичный, иллюстрация или 3D": "Реалістичний, ілюстрація або 3D",
  "Роли": "Ролі",
  "Роль «{0}»": "Роль «{0}»",
  "Роль «{0}» для женского персонажа": "Роль «{0}» для жіночого персонажа",
  "Роль «{0}» для мужского персонажа": "Роль «{0}» для чоловічого персонажа",
  "Роль «{0}» для персонажей своей подборки": "Роль «{0}» для персонажів своєї добірки",
  "Свой вариант": "Свій варіант",
  "Скачать здесь не получится": "Тут завантажити не вийде",
  "Создайте новый вариант": "Створіть новий варіант",
  "Сортировка": "Сортування",
  "Сохранится в близких": "Збережеться в близьких",
  "Сохранить в близких": "Зберегти в близьких",
  "Стало": "Стало",
  "Только для этой фотосессии": "Лише для цієї фотосесії",
  "Удаление": "Видалення",
  "Удалить «{0}» {1}?": "Видалити «{0}» {1}?",
  "Удалить «{0}» из близких?": "Видалити «{0}» з близьких?",
  "Удалить из близких": "Видалити з близьких",
  "Удалить из фотосессии": "Видалити з фотосесії",
  "Удерживайте, чтобы посмотреть примеры": "Утримуйте, щоб переглянути приклади",
  "Управление": "Керування",
  "Файл готов. Нажмите ещё раз": "Файл готовий. Натисніть ще раз",
  "Фото до 10 МБ, видео до 200 МБ": "Фото до 10 МБ, відео до 200 МБ",
  "Фрагмент": "Фрагмент",
  "Что делает? Например: поправляет шарф": "Що робить? Наприклад: поправляє шарф",
  "Что делают в кадре": "Що роблять у кадрі",
  "Эта настройка здесь закреплена": "Цей параметр тут закріплено",
  "Этот голос не умеет переозвучку записи": "Цей голос не вміє переозвучувати запис",
  "вариант «{0}»": "варіант «{0}»",
  "взрослая": "доросла",
  "взрослый": "дорослий",
  "всё видео умещается": "усе відео вміщується",
  "выберите": "виберіть",
  "до <span class=\"mono\">{0}</span>": "до <span class=\"mono\">{0}</span>",
  "до {0} человек": "до {0} осіб",
  "до {0} человека": "до {0} осіб",
  "ещё {0} из {1}": "ще {0} з {1}",
  "женская роль": "жіноча роль",
  "из фотосессии": "з фотосесії",
  "из этой фотосессии": "з цієї фотосесії",
  "камера": "камера",
  "максимум {0} секунд": "максимум {0} секунд",
  "максимум {0} секунда": "максимум {0} секунда",
  "максимум {0} секунды": "максимум {0} секунди",
  "можно до <span class=\"mono\">{0}</span>": "можна до <span class=\"mono\">{0}</span>",
  "мужская роль": "чоловіча роль",
  "не из подборки этой роли": "не з добірки цієї ролі",
  "не подходит по возрасту": "не підходить за віком",
  "не участвует в этой фотосессии": "не бере участі в цій фотосесії",
  "необязательно": "необов’язково",
  "нет фото": "немає фото",
  "нужно выбрать": "потрібно вибрати",
  "нужно: Вы": "потрібно: Ви",
  "персонажи в эту роль не входят": "персонажі в цю роль не входять",
  "питомец": "улюбленець",
  "по желанию": "за бажанням",
  "пожилая": "літня",
  "пожилой": "літній",
  "ребёнок": "дитина",
  "роль для взрослого": "роль для дорослого",
  "роль для женщины": "роль для жінки",
  "роль для мужчины": "роль для чоловіка",
  "роль для питомца": "роль для улюбленця",
  "роль для ребёнка": "роль для дитини",
  "роль для человека": "роль для людини",
  "Попробуйте другое слово или сбросьте тему": "Спробуйте інше слово або скиньте тему",
  "Искать среди {n}+ голосов": "Шукати серед {n}+ голосів",
  "Голосов: {n}": "Голосів: {n}",
  "Персонажей: {n}": "Персонажів: {n}",
  "Голосов: {0}": "Голосів: {0}",
  "Прослушать {n}": "Прослухати {n}",
  "Загружаем ещё {n}": "Завантажуємо ще {n}",
  "{a} из {b}": "{a} з {b}",
  "Подборка": "Добірка",
  "Закрыть подборку": "Закрити добірку",
  "По имени": "За назвою",
  "Загружаем подборки…": "Завантажуємо добірки…",
  "Не удалось загрузить голоса": "Не вдалося завантажити голоси",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Не вдалося відтворити приклад. Спробуйте ще раз.",
  "Мой голос": "Мій",
  "Мои": "Мої",
  "Своих голосов пока нет": "Власних голосів поки немає",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Клонуйте свій голос — і він з’явиться тут.",
  "Клонировать голос": "Клонувати голос",
  "Открыть персонажа {0}": "Відкрити персонажа {0}",
  "От": "Від",
  "Тренды недели": "Тренди тижня",
  "Голоса, которые быстрее всего набирают заказы": "Голоси, які найшвидше набирають замовлення",
  "Мужские": "Чоловічі",
  "Все мужские голоса библиотеки": "Усі чоловічі голоси бібліотеки",
  "Женские": "Жіночі",
  "Все женские голоса библиотеки": "Усі жіночі голоси бібліотеки",
  "Детские": "Дитячі",
  "Детские и мультяшные голоса": "Дитячі та мультяшні голоси",
  "меню: Озвучка": "Голоси",
  "Системная": "Системна",
  "Для аватарки и ленты": "Для аватарки та стрічки",
  "Как снимок с телефона": "Як знімок з телефона",
  "Для ленты": "Для стрічки",
  "На весь экран телефона": "На весь екран телефона",
  "Для обложки и экрана": "Для обкладинки та екрана",
  "Станет голосом по умолчанию для озвучки.": "Стане голосом за замовчуванням для озвучки.",
  "Когда генерация закончится": "Коли генерація завершиться",
  "Награды и серия": "Нагороди й серія",
  "Напомним о награде за день": "Нагадаємо про нагороду за день",
  "Новые шаблоны и стили": "Нові шаблони й стилі",
  "Не чаще раза в неделю": "Не частіше ніж раз на тиждень",
  "Новости STEOS": "Новини STEOS",
  "Только крупные обновления": "Лише великі оновлення",
  "Тут откроется документ в браузере": "Документ відкриється в браузері",
  "Язык и валюта": "Мова й валюта",
  "Интерфейс и цены картой": "Інтерфейс і ціни карткою",
  "новое|новых|новых": "нове|нових|нових",
  "работа|работы|работ": "робота|роботи|робіт",
  "заказ|заказа|заказов": "замовлення|замовлення|замовлень",
  "Счётчики недоступны": "Лічильники недоступні",
  "История пуста": "Історія порожня",
  "Не задан": "Не задано",
  "Недоступны": "Недоступні",
  "Срок истёк": "Термін минув",
  "Не удалась": "Не вдалася",
  "Готовится": "Готується",
  "Запрошено": "Запитано",
  "Запрошено {0}": "Запитано {0}",
  "Недоступно": "Недоступно",
  "Пусто": "Порожньо",
  "Данные Mini App удалены": "Дані Mini App видалено",
  "Удаление данных не удалось": "Не вдалося видалити дані",
  "Данные удалены частично": "Дані видалено частково",
  "Удаление требует проверки": "Видалення потребує перевірки",
  "Запрос удаления принят": "Запит на видалення прийнято",
  "Удаляем данные Mini App": "Видаляємо дані Mini App",
  "Удаление данных в очереди": "Видалення в черзі",
  "STEOS ID сохранён": "STEOS ID збережено",
  "Финансовые квитанции сохранены": "Фінансові квитанції збережено",
  "Статус удаления не подтверждён": "Статус видалення не підтверджено",
  "Удаление аккаунта": "Видалення акаунта",
  "Удалить данные Mini App?": "Видалити дані Mini App?",
  "Удалить аккаунт?": "Видалити акаунт?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Роботи, голоси й варіанти «Ви» в Mini App буде видалено. STEOS ID і фінансові квитанції збережуться.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Роботи, голоси, варіанти «Ви» і Circle буде видалено. Повернути їх не вийде.",
  "Удалить данные Mini App": "Видалити дані Mini App",
  "Удалить аккаунт": "Видалити акаунт",
  "Данные Mini App. STEOS ID сохранится": "Дані Mini App. STEOS ID залишиться",
  "Все данные удалятся навсегда": "Усі дані буде видалено назавжди",
  "В прототипе аккаунт не удаляется": "У прототипі акаунт не видаляється",
  "Автовоспроизведение": "Автовідтворення",
  "Пример при выборе голоса": "Приклад під час вибору голосу",
  "Присылать в чат": "Надсилати в чат",
  "Готовые работы от бота": "Готові роботи від бота",
  "Уведомления и отклик": "Сповіщення й відгук",
  "Данные": "Дані",
  "Выгрузить данные": "Вивантажити дані",
  "Настройки создания сейчас только для чтения": "Налаштування створення зараз лише для читання",
  "Формат по умолчанию": "Формат за замовчуванням",
  "Для новых фото и видео": "Для нових фото й відео",
  "На экране создания их можно поменять для одной работы.": "На екрані створення його можна змінити для однієї роботи.",
  "Сообщения приходят в чат с ботом": "Повідомлення приходять у чат із ботом",
  "Бот напишет только в ответ на действия": "Бот писатиме лише у відповідь на дії",
  "Уведомления пока недоступны": "Сповіщення поки недоступні",
  "Вибрация": "Вібрація",
  "Лёгкий отклик на нажатия": "Легкий відгук на натискання",
  "Выгрузка данных": "Вивантаження даних",
  "Выгрузка запрошена": "Вивантаження запитано",
  "Пришлём архив в чат в течение суток": "Надішлемо архів у чат протягом доби",
  "Настройки и доступные текстовые данные аккаунта": "Налаштування й доступні текстові дані акаунта",
  "Ссылка на архив придёт в чат с ботом": "Посилання на архів прийде в чат із ботом",
  "Готовые работы и заказы": "Готові роботи й замовлення",
  "Клоны и записи образцов": "Клони й записи зразків",
  "Ваши фото и варианты себя": "Ваші фото й варіанти себе",
  "Люди и питомцы из фотосессий": "Люди й улюбленці з фотосесій",
  "Запросить выгрузку": "Запитати вивантаження",
  "Готовим архив": "Готуємо архів",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Це займе кілька хвилин. Аркуш можна закрити, вивантаження триватиме",
  "Срок хранения архива истёк": "Термін зберігання архіву минув",
  "Запросите новую выгрузку данных": "Запитайте нове вивантаження даних",
  "Архив не собрался": "Архів не зібрався",
  "Запросите выгрузку ещё раз": "Запитайте вивантаження ще раз",
  "Не вошли: {0}": "Не ввійшли: {0}",
  "Вошли частично: {0}": "Увійшли частково: {0}",
  "Не входят в выгрузку: {0}": "Не входять у вивантаження: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Частина даних недоступна. Точний склад указано в manifest.json всередині архіву",
  "Архив готов, но не полностью": "Архів готовий, але не повністю",
  "Архив готов": "Архів готовий",
  "Скачать можно до {0}": "Завантажити можна до {0}",
  "Архив в формате ZIP": "Архів у форматі ZIP",
  "Скачать архив": "Завантажити архів",
  "Счётчики истории не загрузились": "Лічильники історії не завантажилися",
  "Загружаем историю": "Завантажуємо історію",
  "Проверьте связь и повторите загрузку": "Перевірте зв'язок і повторіть завантаження",
  "История очищена": "Історію очищено",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Голоси, варіанти «Ви», близькі й Circle на місці",
  "Здесь появятся работы, когда вы что-то создадите": "Тут з'являться роботи, коли ви щось створите",
  "Раздел «История»": "Розділ «Історія»",
  "Работы": "Роботи",
  "Фото, видео, кружки и озвучки": "Фото, відео, кружечки й озвучки",
  "Заказы": "Замовлення",
  "Параметры и статусы генераций": "Параметри й статуси генерацій",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Голоси, варіанти «Ви», близькі й Circle залишаться.",
  "Удалить работы и заказы": "Видалити роботи й замовлення",
  "Без возможности восстановления": "Без можливості відновлення",
  "Подтверждение удаления": "Підтвердження видалення",
  "Попробовать: {0}": "Спробувати: {0}",
  "Обновление": "Оновлення",
  "Загружаем «Что нового»": "Завантажуємо «Що нового»",
  "Новых обновлений пока нет": "Нових оновлень поки немає",
  "Уведомления сейчас не сохранить": "Сповіщення зараз не зберегти",
  "Настройки сейчас только для чтения": "Налаштування зараз лише для читання",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Вивантаження не запиталося. Спробуйте ще раз",
  "Удалить всю историю?": "Видалити всю історію?",
  "{0}. Вернуть не получится.": "{0}. Повернути не вийде.",
  "История не очистилась. Попробуйте ещё раз": "Історія не очистилася. Спробуйте ще раз",
  "Удаление не началось. Попробуйте ещё раз": "Видалення не почалося. Спробуйте ще раз",
  "Не удалось загрузить настройки": "Не вдалося завантажити налаштування",
  "«Что нового» не загрузилось": "«Що нового» не завантажилося",
  "Сохранение настроек сейчас недоступно": "Збереження налаштувань зараз недоступне",
  "Настройки уже изменились, показываем актуальные": "Налаштування вже змінилися, показуємо актуальні",
  "Не удалось сохранить. Попробуйте ещё раз": "Не вдалося зберегти. Спробуйте ще раз",
  "Настройки, ресурсы и история": "Налаштування, ресурси й історія",
  "Данные Mini App": "Дані Mini App",
  "Учётная запись и финансовые данные STEOS ID": "Обліковий запис і фінансові дані STEOS ID",
  "Переписка с ботом": "Листування з ботом",
  "Фото, аудио, видео и модели": "Фото, аудіо, відео й моделі",
  "Данные других продуктов STEOS": "Дані інших продуктів STEOS",
  "Рубли": "Рублі",
  "Драмы": "Драми",
  "Евро": "Євро",
  "Доллары": "Долари",
  "Другие языки": "Інші мови",
  "Интерфейс и сообщения бота": "Інтерфейс і повідомлення бота",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Ціни карткою покажемо в цій валюті. Зірки Telegram усюди однакові.",
  "сегодня, {0}": "сьогодні, {0}",
  "вчера, {0}": "учора, {0}",
  "Старт": "Старт",
  "Плюс": "Плюс",
  "Про": "Про",
  "Картой или СБП": "Карткою або СБП",
  "СБП только для РФ": "СБП лише для РФ",
  "1 месяц": "1 місяць",
  "3 месяца": "3 місяці",
  "6 месяцев": "6 місяців",
  "Год": "Рік",
  "год": "рік",
  "С днём рождения": "З днем народження",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "З днем народження. Хай усе задумане виходить з першого разу",
  "Просто так": "Просто так",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Просто так. Хай у тебе буде більше кружечків і смішних голосів",
  "Спасибо": "Дякую",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Дякую, що ти поруч. Це маленький подарунок від мене",
  "С праздником": "Зі святом",
  "С праздником. Твори, снимай и удивляй": "Зі святом. Твори, знімай і дивуй",
  "Для блога": "Для блогу",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Для твого блогу: хай ролики виходять частіше й легше",
  "Удачи": "Удачі",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Удачі в новому проєкті. Хай голос і картинка будуть такими, як задумано",
  "картой": "карткою",
  "оплата картой каждый месяц": "оплата карткою щомісяця",
  "оплата картой за {0}": "оплата карткою за {0}",
  "{0} в месяц": "{0} на місяць",
  "{0} за {1}": "{0} за {1}",
  "кружок|кружка|кружков": "відеоповідомлення|відеоповідомлення|відеоповідомлень",
  "рилс|рилса|рилсов": "рілс|рілси|рілсів",
  "свой голос|своих голоса|своих голосов": "свій голос|своїх голоси|своїх голосів",
  "своего голоса|своих голосов|своих голосов": "свого голосу|своїх голосів|своїх голосів",
  "день|дня|дней": "день|дні|днів",
  "звезда|звезды|звёзд": "зірка|зірки|зірок",
  "Подписаться на {0}": "Підписатися на {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Продовжується щомісяця, скасування будь-коли",
  "Без автопродления, Circle приходят каждый месяц": "Без автопродовження, Circle приходять щомісяця",
  "Перейти на {0}": "Перейти на {0}",
  "Сразу придут {0} C, а {1} больше не продлится": "Одразу прийдуть {0} C, а {1} більше не продовжиться",
  "Сразу придут {0} C": "Одразу прийдуть {0} C",
  "Перейти на {0} с {1}": "Перейти на {0} з {1}",
  "До {0} остаётся {1}, потом {2}": "До {0} лишається {1}, потім {2}",
  "Продлить на {0}": "Продовжити на {0}",
  "Ещё {0} после {1}, без автопродления": "Ще {0} після {1}, без автопродовження",
  "Следующее списание {0}, {1}": "Наступне списання {0}, {1}",
  "Способ оплаты": "Спосіб оплати",
  "Звёздами": "Зірками",
  "Тестовая оплата": "Тестова оплата",
  "Звёзды и деньги не списываются": "Зірки й гроші не списуються",
  "Оплата картой скоро": "Оплата карткою незабаром",
  "Ваш тариф": "Ваш тариф",
  "выгоднее на {0}%": "вигідніше на {0}%",
  "{0} C в месяц": "{0} C на місяць",
  "или": "або",
  "Что сотворим в этом месяце?": "Що створимо цього місяця?",
  "Готовы творить без пауз?": "Готові творити без пауз?",
  "Ваш тариф {0}": "Ваш тариф {0}",
  "{0} C каждый месяц": "{0} C щомісяця",
  "До {0} {1}": "До {0} {1}",
  "Пакеты Circle, если не хватит": "Пакети Circle, якщо не вистачить",
  "{0} включает": "{0} містить",
  "Сравнить": "Порівняти",
  "Помесячно": "Щомісяця",
  "Выгода {0}": "Вигода {0}",
  "Одним платежом": "Одним платежем",
  "{0} с {1}": "{0} з {1}",
  "Оставить {0}": "Залишити {0}",
  "Продлить {0}": "Продовжити {0}",
  "Продлить": "Продовжити",
  "Включить продление": "Увімкнути продовження",
  "Возобновить {0}": "Відновити {0}",
  "Возобновить": "Відновити",
  "Оплата пока не подключена": "Оплату поки не підключено",
  "Сейчас недоступно": "Зараз недоступно",
  "Переход на {0} на {1}": "Перехід на {0} на {1}",
  "Переход на {0}": "Перехід на {0}",
  "Продление {0} на {1}": "Продовження {0} на {1}",
  "Подписка {0} на {1}": "Підписка {0} на {1}",
  "Как удобнее оплатить": "Як зручніше оплатити",
  "Подарок друга": "Подарунок друга",
  "{0} на первый пакет {1} после подписки": "{0} на перший пакет {1} після підписки",
  "Не загрузилось": "Не завантажилося",
  "Прошлую операцию не проверить": "Попередню операцію не перевірити",
  "разрешите хранение данных и откройте раздел снова": "дозвольте зберігання даних і відкрийте розділ знову",
  "Оплата требует проверки": "Оплата потребує перевірки",
  "Исход подтверждения оплаты ещё неизвестен": "Результат підтвердження оплати ще невідомий",
  "Исход отмены счёта неизвестен": "Результат скасування рахунку невідомий",
  "Ждём подтверждения оплаты": "Чекаємо на підтвердження оплати",
  "Исход прошлой операции неизвестен": "Результат попередньої операції невідомий",
  "проверьте его перед новой покупкой": "перевірте його перед новою покупкою",
  "Проверить": "Перевірити",
  "Открыть оплату": "Відкрити оплату",
  "Отменить счёт": "Скасувати рахунок",
  "Продление отменено": "Продовження скасовано",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Може прийти повідомлення зі старим рахунком. Воно не підтверджує нову підписку",
  "Продление требует проверки": "Продовження потребує перевірки",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Рахунок не підтверджено. Оновіть дані або зверніться в підтримку",
  "Не удалось подготовить счёт": "Не вдалося підготувати рахунок",
  "Сервер повторит проверку. Текущие права не меняются": "Сервер повторить перевірку. Поточні права не змінюються",
  "Счёт отправлен": "Рахунок надіслано",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Бот надіслав рахунок. Підписка почнеться після підтвердженої оплати",
  "Счёт подготовлен": "Рахунок підготовлено",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Передано боту. Доставку й оплату ще не підтверджено",
  "Срок счёта истёк": "Термін рахунку минув",
  "Продление не оплачено. Выберите тариф ещё раз": "Продовження не оплачено. Виберіть тариф ще раз",
  "Запланированное продление отменено": "Заплановане продовження скасовано",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Поточний тариф не змінюється. Для нової підписки потрібна окрема оплата",
  "Продление запланировано": "Продовження заплановано",
  "Счёт на свою подписку придёт в конце подарочного месяца": "Рахунок за власну підписку прийде наприкінці подарункового місяця",
  "Подарок ещё действует": "Подарунок ще діє",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "Місячна підписка буде доступна після його завершення. Зараз можна продовжити на 3 або 12 місяців",
  "выберите другой тариф или срок": "виберіть інший тариф або строк",
  "−{0}% на первый пакет · ещё {1}": "−{0}% на перший пакет · ще {1}",
  "Circle из пакетов не сгорают": "Circle з пакетів не згорають",
  "Подарить другу": "Подарувати другу",
  "С открыткой, без продления": "З листівкою, без продовження",
  "Промокод {0}": "Промокод {0}",
  "{0} C, сгорят {1}": "{0} C, згорять {1}",
  "Промокод применён": "Промокод застосовано",
  "{0} C и {1} на первый пакет": "{0} C і {1} на перший пакет",
  "после подписки": "після підписки",
  "Вы пришли по ссылке партнёра": "Ви прийшли за посиланням партнера",
  "привязка уже действует": "прив'язка вже діє",
  "Есть промокод?": "Є промокод?",
  "Загружаем тарифы": "Завантажуємо тарифи",
  "Счёт придёт {0}": "Рахунок прийде {0}",
  "Счёт придёт в конце текущего срока": "Рахунок прийде наприкінці поточного строку",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Новий тариф почнеться після оплати. Зараз нічого не списується.",
  "Оплата подтверждена": "Оплату підтверджено",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "Оплачений період уже закінчився. Circle за минулий період не нараховуються.",
  "Баланс пополнен": "Баланс поповнено",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Тепер на балансі {0} C. Circle з пакетів не згорають",
  "следующие {0} C придут {1}": "наступні {0} C прийдуть {1}",
  "До этой даты действует {0}": "До цієї дати діє {0}",
  "{0} продлён до {1}": "{0} продовжено до {1}",
  "Circle приходят каждый месяц, {0}": "Circle приходять щомісяця, {0}",
  "Тариф {0} подключён": "Тариф {0} підключено",
  "Подписка {0} оформлена": "Підписку {0} оформлено",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Оплачено до {0}. Circle приходять щомісяця, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Тестова підписка діє до {0}. Зірки й гроші не списуються",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle діють до {0}, тоді ж наступне списання {1}",
  "Circle действуют до {0}, продление выключено": "Circle діють до {0}, продовження вимкнено",
  "В месяц": "На місяць",
  "Кружки или фото": "Кружечки або фото",
  "Видео говорит": "Відео говорить",
  "Рилсы": "Рілси",
  "Сравнение тарифов": "Порівняння тарифів",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "У будь-якому тарифі {0} {1} замість {2}, усі інструменти студії й пакети Circle",
  "Следующее списание": "Наступне списання",
  "Сумма": "Сума",
  "Тестовая, без списаний": "Тестова, без списань",
  "Картой": "Карткою",
  "Оплачено до": "Оплачено до",
  "Действует до": "Діє до",
  "Потом": "Потім",
  "Продление": "Продовження",
  "Счёт на {0} запланирован": "Рахунок на {0} заплановано",
  "подписку": "підписку",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Прийде {0}. Новий тариф почнеться після оплати",
  "Отменить": "Скасувати",
  "Отменить подписку": "Скасувати підписку",
  "Тариф останется до {0}": "Тариф залишиться до {0}",
  "Потом тариф {0}": "Потім тариф {0}",
  "Подарок на месяц": "Подарунок на місяць",
  "Оплачено вперёд": "Оплачено наперед",
  "Подписка {0}": "Підписка {0}",
  "Условия тарифа уточняются": "Умови тарифу уточнюються",
  "Сменить тариф": "Змінити тариф",
  "Отмена подписки": "Скасування підписки",
  "Этот переход сейчас недоступен": "Цей перехід зараз недоступний",
  "Переход уже назначен": "Перехід уже призначено",
  "Выберите другой тариф": "Виберіть інший тариф",
  "С {0} начнётся этот тариф": "З {0} почнеться цей тариф",
  "Это ваш тариф": "Це ваш тариф",
  "К подписке": "До підписки",
  "Сейчас {0}, {1}": "Зараз {0}, {1}",
  "Латиница, цифры и «_»": "Латиниця, цифри й «_»",
  "Ник начинается с буквы": "Нік починається з літери",
  "Не короче 5 знаков": "Не коротше 5 знаків",
  "Не длиннее 32 знаков": "Не довше 32 знаків",
  "Ник не кончается на _": "Нік не закінчується на _",
  "Это ваш ник": "Це ваш нік",
  "Сначала проверьте прежнюю операцию": "Спершу перевірте попередню операцію",
  "Подарок сейчас недоступен": "Подарунок зараз недоступний",
  "Укажите ник друга в Telegram": "Вкажіть нік друга в Telegram",
  "Проверьте ник": "Перевірте нік",
  "Друг увидит: {0}": "Друг побачить: {0}",
  "Подарок придёт без имени": "Подарунок прийде без імені",
  "{0} дарит вам": "{0} дарує вам",
  "вам подарили": "вам подарували",
  "Вам подарили": "Вам подарували",
  "{0} подписку STEOS {1} на месяц.": "{0} підписку STEOS {1} на місяць.",
  "Забрать подарок": "Забрати подарунок",
  "От друга": "Від друга",
  "{0} C и {1} {2}": "{0} C і {1} {2}",
  "Подарить {0}": "Подарувати {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Тестовий подарунок: зірки й гроші не списуються",
  "На месяц, без продления": "На місяць, без продовження",
  "Тариф подарка": "Тариф подарунка",
  "Кому": "Кому",
  "ник друга в Telegram": "нік друга в Telegram",
  "Ник друга в Telegram": "Нік друга в Telegram",
  "Пожелание": "Побажання",
  "Пара тёплых слов, по желанию": "Кілька теплих слів, за бажанням",
  "Подписать от меня": "Підписати від мене",
  "Так увидит друг": "Так побачить друг",
  "Подарок оформлен для {0}": "Подарунок оформлено для {0}",
  "Подарок отправлен {0}": "Подарунок надіслано {0}",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Бот надіслав листівку з посиланням «Забрати подарунок» у підписі.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "Місяць {0} почнеться, коли друг забере подарунок",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Друг ще не запускав STEOS? Перешліть листівку самі",
  "Переслать": "Переслати",
  "Загружаем подарок": "Завантажуємо подарунок",
  "Вам подарок": "Вам подарунок",
  "Подписка STEOS на месяц": "Підписка STEOS на місяць",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Цей подарунок призначено {0}. Перешліть отримувачу листівку з посиланням.",
  "Подарок уже получен": "Подарунок уже отримано",
  "Подарок добавлен": "Подарунок додано",
  "Подписка {0} подключена": "Підписку {0} підключено",
  "Circle подарка сгорят {0}": "Circle подарунка згорять {0}",
  "Месяц без продления, Circle действуют до {0}": "Місяць без продовження, Circle діють до {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "У вас уже є {0}: подарунок додасть {1} C, вони згорять через місяць",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Прийдуть {0} C і {1} {2}. Підписка не продовжиться сама",
  "За последние 7 дней": "За останні 7 днів",
  "Потрачено": "Витрачено",
  "Начислено": "Нараховано",
  "Пакеты пока недоступны": "Пакети поки недоступні",
  "Пакет": "Пакет",
  "Оплата пакетов пока не подключена": "Оплату пакетів поки не підключено",
  "Введите промокод": "Введіть промокод",
  "Применить": "Застосувати",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Промокод партнера діє до першої покупки, промокод STEOS можна застосувати один раз",
  "От партнёра или от STEOS": "Від партнера або від STEOS",
  "Например, ANNA24": "Наприклад, ANNA24",
  "Не удалось загрузить операции": "Не вдалося завантажити операції",
  "Начисление": "Нарахування",
  "Списание": "Списання",
  "Загружаем операции": "Завантажуємо операції",
  "Журнал STEOS ID": "Журнал STEOS ID",
  "Операций пока нет": "Операцій поки немає",
  "Применение не подтверждено. Проверьте прежний запрос": "Застосування не підтверджено. Перевірте попередній запит",
  "Отменить подписку?": "Скасувати підписку?",
  "Тариф {0} останется до {1}, потом не продлится.": "Тариф {0} залишиться до {1}, потім не продовжиться.",
  "Оставить": "Залишити",
  "Не удалось подготовить открытку": "Не вдалося підготувати листівку",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Відкрийте Mini App у Telegram, щоб переслати листівку",
  "Отправка отменена": "Надсилання скасовано",
  "Ссылка на подарок скопирована": "Посилання на подарунок скопійовано",
  "Не получилось. Попробуйте ещё раз": "Не вийшло. Спробуйте ще раз",
  "Счёт отменён": "Рахунок скасовано",
  "Оплата не завершена": "Оплату не завершено",
  "Подтверждение оплаты": "Підтвердження оплати",
  "Проверяем подтверждение оплаты": "Перевіряємо підтвердження оплати",
  "Проверяем отмену счёта": "Перевіряємо скасування рахунку",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram почав підтвердження рахунку. Його результат ще невідомий. Не оплачуйте повторно: перевіряйте цей рахунок або зверніться в підтримку.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Подарунок буде оформлено після підтвердження сервера. Місяць підписки почнеться, коли друг забере подарунок. Повернення з вікна оплати ще не означає, що платіж завершено.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle надійдуть на баланс після підтвердження сервера. Повернення з вікна оплати ще не означає, що платіж завершено.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle і підписка з'являться після підтвердження сервера. Повернення з вікна оплати ще не означає, що платіж завершено.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Не вдалося відкрити оплату. Перевірте попередній запит",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Відкрийте Mini App у Telegram, щоб оплатити зірками",
  "Оплата ещё не подтверждена сервером": "Оплату ще не підтверджено сервером",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "Листівка готова. Відкрийте Mini App у Telegram, щоб переслати її",
  "Отменить счёт?": "Скасувати рахунок?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Скасується лише цей неоплачений рахунок. Поточна підписка залишиться. Якщо оплата вже підтверджується, сервер не дозволить скасування.",
  "Вернуться к оплате": "Повернутися до оплати",
  "{0} на первый пакет после подписки": "{0} на перший пакет після підписки",
  "{0} на первый пакет, ещё {1}": "{0} на перший пакет, ще {1}",
  "{0} на первый пакет": "{0} на перший пакет",
  "Промокод {0} применён": "Промокод {0} застосовано",
  "Circle сгорят {0}": "Circle згорять {0}",
  "Circle начислены": "Circle нараховано",
  "Привязка к партнёру подтверждена": "Прив'язку до партнера підтверджено",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Знижка {0}. Бонусні Circle згорять {1}",
  "Привязка к партнёру действует": "Прив'язка до партнера діє",
  "{0} C и {1}": "{0} C і {1}",
  "Открытка передана боту для доставки.": "Листівку передано боту для доставки.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Бот готує доставку листівки. Можна переслати її самостійно.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Доставку листівки не підтверджено. Можна переслати її самостійно.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Спершу витрачаються Circle зі строком: бонусні й за підпискою, потім усі інші, а ті, що можна вивести, — в останню чергу.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Отримувача не знайдено серед користувачів STEOS. Перевірте нік або попросіть друга запустити бота.",
  "Условия оплаты изменились. Обновите данные.": "Умови оплати змінилися. Оновіть дані.",
  "Эту открытку может переслать только отправитель подарка.": "Цю листівку може переслати лише відправник подарунка.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Відкрийте чат із ботом і спробуйте ще раз.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Доставку отримувачу не підтверджено. Перешліть листівку самостійно.",
  "Предложение не найдено. Обновите данные.": "Пропозицію не знайдено. Оновіть дані.",
  "Такого промокода нет": "Такого промокоду немає",
  "Срок действия промокода закончился": "Термін дії промокоду закінчився",
  "Этот промокод пока не действует": "Цей промокод поки не діє",
  "Вы уже активировали этот промокод": "Ви вже активували цей промокод",
  "Промокод больше не действует": "Промокод більше не діє",
  "Это ваш промокод": "Це ваш промокод",
  "Партнёрские промокоды работают только до первой покупки": "Партнерські промокоди діють лише до першої покупки",
  "Промокод партнёра временно недоступен": "Промокод партнера тимчасово недоступний",
  "Вы уже привязаны к партнёру": "Ви вже прив'язані до партнера",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Отримувач змінився. Скасуйте попередній неоплачений рахунок і перевірте нік перед новою покупкою.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Побажання має бути не довшим за 200 знаків, без керівних символів.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Перевірте нік: отримувач має запускати STEOS, дарувати собі не можна",
  "Получатель сейчас занят. Повторите позже": "Отримувач зараз зайнятий. Повторіть пізніше",
  "Подарок не найден": "Подарунок не знайдено",
  "Этот подарок предназначен другому пользователю": "Цей подарунок призначено іншому користувачу",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Не вдалося підтвердити умови продовження. Оновіть тарифи.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Підписка змінилася. Оновіть дані перед новим продовженням.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Продовження вже заплановано. Його можна скасувати в керуванні підпискою.",
  "Запланированное продление отменено. Обновите данные.": "Заплановане продовження скасовано. Оновіть дані.",
  "Счёт будет доступен в конце текущего срока.": "Рахунок буде доступний наприкінці поточного строку.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "Місячна підписка буде доступна після завершення подарунка. Зараз можна продовжити на 3 або 12 місяців.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "Попередня зміна підписки ще перевіряється. Повторіть її перевірку.",
  "Изменение подписки ещё не подтверждено Telegram.": "Зміну підписки ще не підтверджено Telegram.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Підписка змінилася. Оновіть дані й повторіть перевірку.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "Знижку вже закріплено за попереднім рахунком. Перевірте його оплату.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "Рахунок уже підтверджується або недоступний для скасування. Перевірте результат оплати.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Оплата потребує перевірки. Сервер зберіг платіж; права поки не підтверджено. Не оплачуйте повторно — перевірте результат пізніше або зверніться в підтримку.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Рахунок скасовано. Підписку й Circle за ним не нараховано. Можна вибрати нову оплату.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Оплату не завершено. Гроші й Circle не підтверджено; можна почати нову оплату.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "Листівка готується. Натисніть «Перевірити», щоб отримати результат попереднього запиту.",
  "Подарить подписку": "Подарувати підписку",
  "Оплата подписки": "Оплата підписки",
  "Итог оплаты": "Підсумок оплати",
  "Подарок": "Подарунок",
  "Пакет Circle": "Пакет Circle",
  "лента: Хит": "Хіт",
  "настройки: Очистить историю": "Очистити історію",
  "Разделы, которых нет в меню": "Розділи, яких немає в меню",
  "Базовый": "Базовий",
  "Продвинутый": "Просунутий",
  "Амбассадор": "Амбасадор",
  "задание ждёт|задания ждут|заданий ждут": "завдання чекає|завдання чекають|завдань чекають",
  ", до +{0} C": ", до +{0} C",
  "Серия {0}, задания на сегодня": "Серія {0}, завдання на сьогодні",
  "Задания на каждый день": "Завдання на кожен день",
  "Всё созданное в одном месте": "Усе створене в одному місці",
  "Пока пусто: всё созданное будет здесь": "Поки порожньо: усе створене буде тут",
  "{0}, последняя {1}": "{0}, остання {1}",
  "тариф {0}": "тариф {0}",
  "без подписки": "без підписки",
  "{0}, {1}% с покупок": "{0}, {1}% з покупок",
  "{0} уровень, {1}% с покупок": "Рівень {0}, {1}% з покупок",
  "До {0}% с покупок друзей": "До {0}% з покупок друзів",
  "ИИ-агент ответит сразу": "ШІ-агент відповість одразу",
  "Черновики ролей и реплик": "Чернетки ролей і реплік",
  "Тема, язык и валюта": "Тема, мова й валюта",
  "{0} ждут": "{0} чекають",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Тут Telegram відкриє вибір чату: бот додасться в групу й працюватиме там",
  "голос {0}": "голос {0}",
  "Искать в {0} {1}": "Шукати в {0} {1}",
  "работе|работах|работах": "роботі|роботах|роботах",
  "Не прошло модерацию": "Не пройшло модерацію",
  "Бесплатно": "Безкоштовно",
  "Цена недоступна": "Ціна недоступна",
  "Не удалось загрузить историю": "Не вдалося завантажити історію",
  "Проверьте написание или поищите по номеру заказа": "Перевірте написання або шукайте за номером замовлення",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Перевірте написання або шукайте за назвою, голосом чи персонажем",
  "Сбросить поиск": "Скинути пошук",
  "В этой вкладке пока пусто": "У цій вкладці поки порожньо",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Позначайте роботи сердечком у картці, щоб швидко знаходити їх тут",
  "Новые работы этого вида появятся здесь сами": "Нові роботи цього типу з’являться тут самі",
  "Показать все": "Показати все",
  "Поиск по истории": "Пошук в історії",
  "Что показать": "Що показати",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Кружечки, фото, відео, озвучки й тексти, які ви створите",
  "Открыть студию": "Відкрити Студію",
  "{0}: шаг {1} из {2}. Открыть": "{0}: крок {1} з {2}. Відкрити",
  "Шаг {0} из {1}": "Крок {0} з {1}",
  "{0}: {1}. Открыть": "{0}: {1}. Відкрити",
  "Раскладка": "Розкладка",
  "Широкий": "Широкий",
  "Инструмент": "Інструмент",
  "голос|голоса|голосов": "голос|голоси|голосів",
  "Как в оригинале": "Як в оригіналі",
  "фото|фото|фото": "фото|фото|фото",
  "слайд|слайда|слайдов": "слайд|слайди|слайдів",
  "снимок|снимка|снимков": "знімок|знімки|знімків",
  "кадр|кадра|кадров": "кадр|кадри|кадрів",
  "Длительность записи": "Тривалість запису",
  "Цена": "Ціна",
  "Списание не подтверждено": "Списання не підтверджено",
  "Кадры": "Кадри",
  "знак|знака|знаков": "символ|символи|символів",
  "пункт|пункта|пунктов": "пункт|пункти|пунктів",
  "фраза|фразы|фраз": "фраза|фрази|фраз",
  "человек|человека|человек": "людина|людини|людей",
  "Смотреть видео": "Дивитися відео",
  "символ|символа|символов": "символ|символи|символів",
  "Дорожка": "Доріжка",
  "фрагмент 1:00": "фрагмент 1:00",
  "вся песня": "уся пісня",
  "образец|образца|образцов": "зразок|зразки|зразків",
  "Свой голос": "Свій голос",
  "{0} C списаны": "{0} C списано",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Робота ще створюється. Результат з’явиться тут і прийде в чат",
  "Проверяем результат. Обычно это занимает пару минут": "Перевіряємо результат. Зазвичай це займає кілька хвилин",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Не пройшло модерацію. Політику й заборонені теми не пропускаємо, {0}",
  "Не прошло модерацию. {0}": "Не пройшло модерацію. {0}",
  "Не получилось. {0}": "Не вийшло. {0}",
  "Не получилось. {0} C вернулись на баланс": "Не вийшло. {0} C повернулися на баланс",
  "Удалится только запись о заказе": "Видалиться лише запис про замовлення",
  "Удаление из истории": "Видалення з історії",
  "Смотреть: {0}": "Дивитися: {0}",
  "В этой работе нет файлов для просмотра": "У цій роботі немає файлів для перегляду",
  "Вернуть запись в историю не получится.": "Повернути запис в історію не вийде.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Файл у чаті залишиться. Повернути роботу в історію не вийде.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Надсилання ще не підтвердилося. Натисніть ще раз",
  "Принято": "Прийнято",
  "Бот пришлёт результат в чат": "Бот надішле результат у чат",
  "Возврат обрабатывается": "Повернення обробляється",
  "Не списано": "Не списано",
  "Circle не списаны": "Circle не списано",
  "Circle вернулись на баланс": "Circle повернулися на баланс",
  "Списание пока не подтверждено": "Списання ще не підтверджено",
  "Возврат не подтверждён": "Повернення не підтверджено",
  "Ожидаем подтверждения оплаты": "Чекаємо підтвердження оплати",
  "история: Повторить": "Повторити",
  "история: Кружки": "Відеоповідомлення",
  "Фотосессия из селфи": "Фотосесія із селфі",
  "Рилс с вами": "Рилс з вами",
  "Фото говорит": "Фото говорить",
  "Слайды с преимуществами": "Слайди з перевагами",
  "Карусель для поста": "Карусель для допису",
  "Коллаж из фото": "Колаж із фото",
  "Карточка для маркетплейса": "Картка для маркетплейсу",
  "шаг|шага|шагов": "крок|кроки|кроків",
  "вопрос|вопроса|вопросов": "запитання|запитання|запитань",
  "Открыть": "Відкрити",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "Відповідь на це запитання не підтвердилася. Якщо вона важлива, напишіть у підтримку: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "Відповідь на це запитання не підтвердилася. Якщо вона важлива, напишіть у підтримку.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Відповідь ще не надійшла. Перевіримо це саме запитання, вдруге воно не надішлеться.",
  "Открыть профиль": "Відкрити профіль",
  "Войти через STEOS ID": "Увійти через STEOS ID",
  "Тут Telegram откроет выбор чата": "Тут Telegram відкриє вибір чату",
  "Разделы поддержки": "Розділи підтримки",
  "Ответит сразу": "Відповість одразу",
  "Отвечает сразу": "Відповідає одразу",
  "Поддержка в Telegram, {0}": "Підтримка в Telegram, {0}",
  "Поддержка в Telegram": "Підтримка в Telegram",
  "Видео медленнее обычного": "Відео повільніше, ніж зазвичай",
  "Видео работает медленнее обычного": "Відео працює повільніше, ніж зазвичай",
  "Спросить ИИ‑агента поддержки": "Запитати ШІ‑агента підтримки",
  "Отвечает сразу и знает всё о STEOS": "Відповідає одразу й знає все про STEOS",
  "Поиск по вопросам и инструкциям": "Пошук у запитаннях та інструкціях",
  "Шесть коротких сторис о главном": "Шість коротких сторіс про головне",
  "Попробуйте другие слова или спросите ИИ-агента": "Спробуйте інші слова або запитайте ШІ-агента",
  "Проверено в {0}": "Перевірено о {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Замовлення не губляться: результат надійде в чат, а якщо щось зірветься, Circle повернуться на баланс.",
  "Сервисы": "Сервіси",
  "Загружаем статус сервисов": "Завантажуємо статус сервісів",
  "Загружаем справку": "Завантажуємо довідку",
  "Статус не загрузился": "Статус не завантажився",
  "Статус сервисов пока не отслеживается": "Статус сервісів поки не відстежується",
  "Если что-то не работает, напишите в поддержку": "Якщо щось не працює, напишіть у підтримку",
  "Часть сервисов работает с перебоями": "Частина сервісів працює з перебоями",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Статуси ваших робіт і підтверджені повернення дивіться в «Історії».",
  "Справка не загрузилась": "Довідка не завантажилася",
  "Справка пока не опубликована": "Довідку ще не опубліковано",
  "Вопрос можно задать поддержке в Telegram": "Запитання можна поставити підтримці в Telegram",
  "Инструкции появятся после публикации справки": "Інструкції з’являться після публікації довідки",
  "Назад к ИИ-агенту": "Назад до ШІ-агента",
  "Инструкция · {0}": "Інструкція · {0}",
  "Вопрос · {0}": "Запитання · {0}",
  "Справка": "Довідка",
  "Вопрос из Справки": "Запитання з Довідки",
  "Подробнее из Справки": "Докладніше в Довідці",
  "Назад по таблице": "Таблицею назад",
  "Вперёд по таблице": "Таблицею вперед",
  "Здравствуйте, {0}.": "Вітаю, {0}.",
  "Здравствуйте.": "Вітаю.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Я ШІ-агент підтримки STEOS: підкажу щодо тарифів і Circle, інструментів і шаблонів, промокодів, STEOS ID та партнерства. Запитайте своїми словами або виберіть запитання.",
  "ИИ-агент печатает": "ШІ-агент друкує",
  "ИИ-агент ещё отвечает": "ШІ-агент ще відповідає",
  "Напишите вопрос": "Напишіть запитання",
  "Диалог с ИИ-агентом": "Діалог із ШІ-агентом",
  "Распознаём…": "Розпізнаємо…",
  "Слушаю": "Слухаю",
  "Спросите о STEOS": "Запитайте про STEOS",
  "Вопрос ИИ-агенту": "Запитання ШІ-агенту",
  "Остановить диктовку": "Зупинити диктування",
  "Сказать голосом": "Сказати голосом",
  "Отправить": "Надіслати",
  "Не удалось начать новый чат": "Не вдалося почати новий чат",
  "Спасибо, учтём": "Дякуємо, врахуємо",
  "Спасибо, передадим команде": "Дякуємо, передамо команді",
  "Оценка не сохранилась": "Оцінку не збережено",
  "Чат ещё загружается": "Чат ще завантажується",
  "В чате уже {0} вопросов. Начните новый": "У чаті вже {0} запитань. Почніть новий",
  "Вопрос не сохранился. Попробуйте ещё раз": "Запитання не збереглося. Спробуйте ще раз",
  "Некоторые сервисы работают медленнее обычного": "Деякі сервіси працюють повільніше, ніж зазвичай",
  "{0} не работают": "{0} не працюють",
  "{0} не работает": "{0} не працює",
  "{0} медленнее обычного": "{0} повільніше, ніж зазвичай",
  "{0} работают медленнее обычного": "{0} працюють повільніше, ніж зазвичай",
  "{0} работает медленнее обычного": "{0} працює повільніше, ніж зазвичай",
  "Микрофон здесь недоступен": "Мікрофон тут недоступний",
  "Нет доступа к микрофону": "Немає доступу до мікрофона",
  "Нужна запись от 1 до 30 секунд": "Потрібен запис від 1 до 30 секунд",
  "Не удалось разобрать запись": "Не вдалося розібрати запис",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Диктування не розпізналося. Натисніть мікрофон, щоб перевірити ще раз",
  "Вопрос не подошёл. Сформулируйте иначе": "Запитання не підійшло. Сформулюйте інакше",
  "Ответ не подтвердился. Напишите в поддержку": "Відповідь не підтвердилася. Напишіть у підтримку",
  "Ответ не пришёл. Проверьте ещё раз": "Відповідь не надійшла. Перевірте ще раз",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Відеокружечок, що говорить, Відео говорить, Фото говорить, Повтори рухи, власний аватар",
  "Оживить фото, видео по описанию, рилсы и сцены": "Оживити фото, відео за описом, рілси та сцени",
  "Фото, фотосессии, товары, карусели": "Фото, фотосесії, товари, каруселі",
  "Голоса, клон, озвучка проектов, кавер": "Голоси, клон, озвучка проєктів, кавер",
  "Звёзды Telegram и карты": "Зірки Telegram і картки",
  "Не работает": "Не працює",
  "Как сделать по шагам": "Покроково",
  "Полезный ответ": "Корисна відповідь",
  "Ответ не помог": "Відповідь не допомогла",
  "Проверьте связь и попробуйте ещё раз": "Перевірте зв’язок і спробуйте ще раз",
  "Не удалось проверить владельца чата": "Не вдалося перевірити власника чату",
  "Не удалось восстановить чат. Начните новый": "Не вдалося відновити чат. Почніть новий",
  "Клоны для озвучки": "Клони для озвучення",
  "Создайте первый голос": "Створіть перший голос",
  "Люди и питомцы для фото": "Люди й улюбленці для фото",
  "Добавьте близких для фото": "Додайте близьких для фото",
  "Сохранённые работы": "Збережені роботи",
  "Отмечайте работы сердцем": "Позначайте роботи сердечком",
  "Ежедневная серия и бонусы": "Щоденна серія і бонуси",
  "Частые вопросы и связь с нами": "Часті питання і зв’язок з нами",
  "Обучается": "Навчається",
  "Аккаунт недоступен": "Акаунт недоступний",
  "Эта неделя · {0}": "Цей тиждень · {0}",
  "Неделя с {0} · {1}": "Тиждень з {0} · {1}",
  "ID скопирован": "ID скопійовано",
  "Скопировать ID": "Скопіювати ID",
  "Баланс временно недоступен": "Баланс тимчасово недоступний",
  "Разбивка остатка временно недоступна": "Розбивка залишку тимчасово недоступна",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "З них {0} C згорить {1}|З них {0} C згорять {1}|З них {0} C згорять {1}",
  "Ближайшие {0} C сгорят {1}": "Найближчі {0} C згорять {1}",
  "Circle каждый месяц от {0}": "Circle щомісяця від {0}",
  "Circle каждый месяц с подпиской": "Circle щомісяця з підпискою",
  "Тариф временно недоступен": "Тариф тимчасово недоступний",
  "Аккаунт, подписка и баланс": "Акаунт, підписка й баланс",
  "Статистика и моё": "Статистика і Моє",
  "{0} к прошлой неделе": "{0} до минулого тижня",
  "Работы по неделям: на этой неделе {0}": "Роботи за тижнями: цього тижня {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Роботи за тижнями: цього тижня {0}, минулого {1}",
  "Статистика пока недоступна": "Статистика поки недоступна",
  "Дата регистрации недоступна": "Дата реєстрації недоступна",
  "С {0}": "З {0}",
  "Создано": "Створено",
  "Серия": "Серія",
  "день подряд|дня подряд|дней подряд": "день поспіль|дні поспіль|днів поспіль",
  "Общий аккаунт STEOS": "Спільний акаунт STEOS",
  "Для вывода Circle": "Для виведення Circle",
  "До {0}% с их покупок": "До {0}% з їхніх покупок",
  "Обновлено {0}": "Оновлено {0}",
  "Действия": "Дії",
  "Сохранить имя": "Зберегти ім’я",
  "Новое имя": "Нове ім’я",
  "Больше голосов с подпиской": "Більше голосів із підпискою",
  "Создание голосов пока недоступно": "Створення голосів поки недоступне",
  "Свободных мест нет": "Вільних місць немає",
  "с подпиской до {0}": "з підпискою до {0}",
  "Пауза «{0}»": "Пауза «{0}»",
  "Прослушать «{0}»": "Прослухати «{0}»",
  "Переименовать": "Перейменувати",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Запишіть 2 секунд мовлення або завантажте файли, і голос звучатиме як ви",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Вільних місць немає. Видаліть голос, щоб записати новий",
  "Выбрать за «Вы»": "Вибрати за «Ви»",
  "голос по умолчанию": "типовий голос",
  "Сделать кружок с вариантом «{0}»": "Зробити кружечок із варіантом «{0}»",
  "Выбраны": "Вибрано",
  "{0} фото|{0} фото|{0} фото": "{0} фото|{0} фото|{0} фото",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} фото · для всіх інструментів|{0} фото · для всіх інструментів|{0} фото · для всіх інструментів",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} варіант · кружечки, фото й відео|{0} варіанти · кружечки, фото й відео|{0} варіантів · кружечки, фото й відео",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} варіант|{0} варіанти|{0} варіантів",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "Голос {0} видалено, у варіанта {1} тепер типовий голос.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Голоси видалено, у варіантів {0} тепер типовий голос.",
  "Другой голос можно выбрать у каждого кружка": "Інший голос можна вибрати для кожного кружечка",
  "Вариантов пока нет": "Варіантів поки немає",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Завантажте свої фото, і ваш варіант говоритиме вашим голосом у кружечках, фото й відео",
  "Вы: свои фото и варианты": "Ви: ваші фото й варіанти",
  "добавьте фото": "додайте фото",
  "Изменить «{0}»": "Змінити «{0}»",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} близька людина · для фото й відео|{0} близькі людини · для фото й відео|{0} близьких людей · для фото й відео",
  "Люди и питомцы для фото и видео": "Люди й улюбленці для фото й відео",
  "Близких пока нет": "Близьких поки немає",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Додайте людей і улюбленців із фото, і вони з’являться в кадрі поруч із вами",
  "Открыть в «Истории»": "Відкрити в «Історії»",
  "Вернуть в избранное": "Повернути в обране",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "{0} робота із сердечком|{0} роботи із сердечком|{0} робіт із сердечком",
  "Отмеченные сердцем работы": "Роботи, позначені сердечком",
  "Открыть «Историю»": "Відкрити «Історію»",
  "Не удалось загрузить избранное": "Не вдалося завантажити обране",
  "Закройте лист и откройте его ещё раз": "Закрийте вікно й відкрийте його ще раз",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Позначайте роботи сердечком в «Історії», і вони зберуться тут",
  "Не удалось обновить. Попробуйте позже": "Не вдалося оновити. Спробуйте пізніше",
  "Удалить голос «{0}»?": "Видалити голос «{0}»?",
  "Голос пропадёт из списка. Вернуть его не получится.": "Голос зникне зі списку. Повернути його не вийде.",
  "Удалить вариант «{0}»?": "Видалити варіант «{0}»?",
  "За «Вы» снова встанут ваши фото.": "За «Ви» знову стануть ваші фото.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Готові кружечки й фото з ним залишаться в «Історії». Повернути варіант не вийде.",
  "Не удалось удалить голос": "Не вдалося видалити голос",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Не вдалося видалити варіант. Спробуйте ще раз",
  "«{0}»": "«{0}»",
  "подписка: до {0}": "до {0}",
  "варианты «Вы»: Новый вариант": "Новий варіант",
  "в очереди": "у черзі",
  "идёт": "триває",
  "завершено": "завершено",
  "не удалось": "не вдалося",
  "слово подтверждения: УДАЛИТЬ": "ВИДАЛИТИ",
  "Выгрузка: {0}": "Вивантаження: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Видалення: {0}. STEOS ID і фінансові квитанції зберігаються.",
  "Введите {0}": "Введіть {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Перенесення ще не підтверджено. Перевірка триває, відкрийте вікно пізніше",
  "Этот STEOS ID уже связан с другим Telegram": "Цей STEOS ID уже пов’язаний з іншим Telegram",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "На обох акаунтах є підписка. Щоб об’єднати їх, напишіть у підтримку",
  "Слишком много попыток. Попробуйте позже": "Забагато спроб. Спробуйте пізніше",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "Підключення STEOS ID зараз недоступне. Спробуйте пізніше",
  "Не удалось создать аккаунт. Попробуйте позже": "Не вдалося створити акаунт. Спробуйте пізніше",
  "Не удалось отправить письмо": "Не вдалося надіслати лист",
  "Фото не подошло. Выберите другое": "Фото не підійшло. Виберіть інше",
  "Загрузите фото заново": "Завантажте фото заново",
  "Данные изменились. Откройте заново": "Дані змінилися. Відкрийте знову",
  "подряд": "поспіль",
  "Начните {0}": "Почніть {0}",
  "серию": "серію",
  "Завтра +{0} C": "Завтра +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Заходьте щодня: нагорода зростає, на сьомий день — {0} C. Пропущений день починає серію заново.",
  "Забрать {0} C": "Забрати {0} C",
  "Прогресс": "Прогрес",
  "Заданий здесь пока нет": "Завдань тут поки немає",
  "Время обновления недоступно": "Час оновлення недоступний",
  "Новые через {0}": "Нові через {0}",
  "Выполнено {0} из {1}": "Виконано {0} з {1}",
  "друг|друга|друзей": "друг|друзі|друзів",
  "{0} с вами": "{0} з вами",
  "Прогресс друзей недоступен": "Прогрес друзів недоступний",
  "Пригласить": "Запросити",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Зараховуються друзі, які прийшли за вашим посиланням чи промокодом і створили першу роботу",
  "Ещё {0} {1} до награды {2}": "Ще {0} {1} до нагороди {2}",
  "Все ступени пройдены": "Усі сходинки пройдено",
  "Получено {0} из {1}": "Отримано {0} з {1}",
  "Задания": "Завдання",
  "покупатель|покупателя|покупателей": "покупець|покупці|покупців",
  "Партнёрская программа": "Партнерська програма",
  "Партнёрам": "Партнерам",
  "До {0}% {1}": "До {0}% {1}",
  "с покупок друзей": "з покупок друзів",
  "Заработано {0} с покупок {1} {2}": "Зароблено {0} з покупок {1} {2}",
  "друга|друзей|друзей": "друга|друзів|друзів",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Обирайте самі: більше можливостей у STEOS або дохід із рекомендацій.",
  "Ещё {0} до уровня {1}": "Ще {0} до рівня {1}",
  "Максимальный уровень: вывод через STEOS ID": "Максимальний рівень: виведення через STEOS ID",
  "Статистика, материалы и вывод": "Статистика, матеріали та виведення",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Результат попереднього запиту нагороди треба перевірити. Нові нарахування поки заблоковано",
  "Загружаем награды": "Завантажуємо нагороди",
  "Награды не загрузились": "Нагороди не завантажилися",
  "Создайте 3 работы": "Створіть 3 роботи",
  "Сделайте кружок": "Зробіть кружечок",
  "Персонаж или вы сами": "Персонаж або ви самі",
  "Озвучьте текст": "Озвучте текст",
  "Голосом героя или клона": "Голосом героя або клона",
  "Улучшите описание": "Покращте опис",
  "Бот допишет детали": "Бот допише деталі",
  "Отправьте работу": "Надішліть роботу",
  "Из «Истории» в любой чат": "З «Історії» в будь-який чат",
  "Неделя кружков": "Тиждень кружечків",
  "Создайте 10 кружков за неделю": "Створіть 10 кружечків за тиждень",
  "Исследователь": "Дослідник",
  "Попробуйте 5 разных инструментов студии": "Спробуйте 5 різних інструментів Студії",
  "Первый кружок": "Перший кружечок",
  "Видеокружок для Telegram": "Відеокружечок для Telegram",
  "Клон голоса": "Клон голосу",
  "Всего 2 секунды речи": "Лише 2 секунд мовлення",
  "Первое фото": "Перше фото",
  "Портрет в любом стиле": "Портрет у будь-якому стилі",
  "Первый рилс с вами": "Перший рілс із вами",
  "Шаблон одной кнопкой": "Шаблон однією кнопкою",
  "Первый кавер": "Перший кавер",
  "Песня другим голосом": "Пісня іншим голосом",
  "Кружки и видео с вами": "Кружечки й відео з вами",
  "С вашей ссылкой": "З вашим посиланням",
  "Бот в чате": "Бот у чаті",
  "Добавьте бота в группу": "Додайте бота в групу",
  "Вход в STEOS ID": "Вхід у STEOS ID",
  "Один аккаунт с сайтом": "Один акаунт із сайтом",
  "Первый друг": "Перший друг",
  "3 друга": "3 друзі",
  "10 друзей": "10 друзів",
  "25 друзей": "25 друзів",
  "Первый покупатель": "Перший покупець",
  "Первая оплата друга": "Перша оплата друга",
  "{0} мин": "{0} хв",
  "{0} ч": "{0} год",
  "Последний день": "Останній день",
  "Ещё {0} {1}": "Ще {0} {1}",
  "Это задание выполняется вне мини-приложения": "Це завдання виконується поза Mini App",
  "Задание пока недоступно": "Завдання поки недоступне",
  "Прогресс временно недоступен": "Прогрес тимчасово недоступний",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Не вдалося відновити попередній запит нагороди. Перевірте баланс і напишіть у підтримку",
  "Награды временно недоступны. Попробуйте обновить данные": "Нагороди тимчасово недоступні. Спробуйте оновити дані",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Нагороду підтверджено. Оновіть дані: повторно нараховувати не треба",
  "Задание ещё не выполнено. Обновите прогресс": "Завдання ще не виконано. Оновіть прогрес",
  "Награда уже получена. Обновите данные": "Нагороду вже отримано. Оновіть дані",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Нарахування не підтверджено. Перевірте попередній запит: нову нагороду поки заблоковано",
  "Сначала обновите данные наград": "Спершу оновіть дані нагород",
  "Сначала проверьте прежний запрос награды": "Спершу перевірте попередній запит нагороди",
  "Рассказчик": "Оповідач",
  "Встреча на тракте": "Зустріч на тракті",
  "Геральт": "Геральт",
  "Цири": "Цірі",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Дощ ішов третій день, і дорога до фортеці майже зникла під багнюкою.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Ти знову пішла вперед без мене. Я ж просив чекати біля мосту.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Я чекала. Цілу годину. Потім вирішила, що ти заблукав.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Відьмаки не блукають. Ми інколи обираємо довгу дорогу.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Тоді наступного разу обирай її швидше. Я змерзла.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Він мовчки зняв плащ і накинув їй на плечі. Попереду вже виднілися вогні фортеці.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Ходімо. Весемир, певно, вже поставив суп на вогонь.",
  "Опять ты?": "Знову ти?",
  "Мне нужна помощь": "Мені потрібна допомога",
  "Вставьте сценарий или начните с нуля": "Вставте сценарій або почніть з нуля",
  "Напишите хотя бы одну реплику": "Напишіть хоча б одну репліку",
  "Сократите реплику: до {0} знаков": "Скоротіть репліку: до {0} символів",
  "Сократите проект: до {0} знаков": "Скоротіть проєкт: до {0} символів",
  "Озвучка проектов временно недоступна": "Озвучка проєктів тимчасово недоступна",
  "Выберите голос для каждой роли": "Виберіть голос для кожної ролі",
  "Озвучить · {0} C": "Озвучити · {0} C",
  "Без названия": "Без назви",
  "Роль": "Роль",
  "вчера": "учора",
  "Проекты": "Проєкти",
  "роль|роли|ролей": "роль|ролі|ролей",
  "реплика|реплики|реплик": "репліка|репліки|реплік",
  "Нет реплик": "Немає реплік",
  "{0} знаков": "{0} символів",
  "Строки «Имя: реплика» сами станут ролями и голосами": "Рядки «Ім’я: репліка» самі стануть ролями й голосами",
  "Начать с нуля": "Почати з нуля",
  "Роли и реплики добавите сами": "Ролі й репліки додасте самі",
  "Открыть пример": "Відкрити приклад",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Проєкти зберігаються самі: повернутися до них можна будь-коли",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Роль з ім’ям персонажа сама отримає його голос: Геральт, Цірі, Йеннефер",
  "Переименовать проект": "Перейменувати проєкт",
  "Загрузить свежую": "Завантажити свіжу",
  "{0}: голос {1}. Сменить голос": "{0}: голос {1}. Змінити голос",
  "Действия с ролью": "Дії з роллю",
  "Озвучиваем": "Озвучуємо",
  "Действия с репликой": "Дії з реплікою",
  "Реплика: {0}": "Репліка: {0}",
  "Реплик пока нет": "Реплік поки немає",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Натисніть «Репліка» внизу або вставте готовий сценарій",
  "Реплика": "Репліка",
  "за проект": "за проєкт",
  "Цена — по числу знаков": "Ціна — за кількістю символів",
  "Добавить реплику": "Додати репліку",
  "проект|проекта|проектов": "проєкт|проєкти|проєктів",
  "{0} {1} · сохраняются сами": "{0} {1} · зберігаються самі",
  "Пока ни одного": "Поки жодного",
  "Новый проект": "Новий проєкт",
  "Вставить сценарий или начать с нуля": "Вставити сценарій або почати з нуля",
  "Удаление проекта": "Видалення проєкту",
  "Новая роль": "Нова роль",
  "Это первая реплика": "Це перша репліка",
  "Это последняя реплика": "Це остання репліка",
  "Удалить роль": "Видалити роль",
  "Вместе с её репликами": "Разом з її репліками",
  "В проекте нужна хотя бы одна роль": "У проєкті потрібна хоча б одна роль",
  "Удалить роль «{0}»?": "Видалити роль «{0}»?",
  "Вместе с ней уйдут {0} {1}.": "Разом із нею буде видалено: {0} {1}.",
  "Удалить проект?": "Видалити проєкт?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Ролі й репліки буде видалено, повернути проєкт не вийде.",
  "Выбор голоса откроется в приложении": "Вибір голосу відкриється в застосунку",
  "Не удалось удалить проект: {0}": "Не вдалося видалити проєкт: {0}",
  "Не получилось открыть аудио": "Не вдалося відкрити аудіо",
  "Не получилось включить звук": "Не вдалося ввімкнути звук",
  "Сначала напишите текст реплики": "Спершу напишіть текст репліки",
  "Аудио реплики пока недоступно": "Аудіо репліки поки недоступне",
  "Готовим роли": "Готуємо ролі",
  "Роли готовы": "Ролі готові",
  "Озвучиваем реплики": "Озвучуємо репліки",
  "Реплики озвучены": "Репліки озвучено",
  "Собираем дорожку": "Збираємо доріжку",
  "Дорожка собрана": "Доріжку зібрано",
  "дубль {0}": "дубль {0}",
  "Время реплики пока недоступно": "Час репліки поки недоступний",
  "Общий файл · {0}": "Спільний файл · {0}",
  "Аудио пока недоступно": "Аудіо поки недоступне",
  "Слушать дорожку": "Слухати доріжку",
  "реплика {0} из {1}": "репліка {0} з {1}",
  "Проект не озвучен": "Проєкт не озвучено",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Можна піти з екрана: озвучка триватиме, доріжка з’явиться тут і в «Історії».",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Можна піти з екрана: бот напише, коли доріжка буде готова.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Надішліть спільний файл у чат або завантажте його. Будь-яку репліку можна переозвучити окремо.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Бот уже надіслав спільний файл у чат, в окрему тему. Будь-яку репліку можна переозвучити окремо.",
  "Сценарий не прошёл проверку": "Сценарій не пройшов перевірку",
  "проект не озвучен": "проєкт не озвучено",
  "Не получилось собрать дорожку": "Не вдалося зібрати доріжку",
  "К сценарию": "До сценарію",
  "Звук дорожки не загрузился: скачайте файл": "Звук доріжки не завантажився: завантажте файл",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Кожна репліка з нового рядка: ім’я, двокрапка, текст. Рядок без імені дістається попередній ролі",
  "голос персонажа": "голос персонажа",
  "Заменить сценарий": "Замінити сценарій",
  "Сейчас {0} {1}, они уйдут": "Зараз {0} {1}, їх буде видалено",
  "реплику|реплики|реплик": "репліку|репліки|реплік",
  "Заменить на {0} {1}": "Замінити на {0} {1}",
  "Добавить {0} {1}": "Додати {0} {1}",
  "Заменить реплики": "Замінити репліки",
  "Добавить реплики": "Додати репліки",
  "Не нашли реплик: имя, двоеточие, текст": "Реплік не знайдено: ім’я, двокрапка, текст",
  "Вставьте сценарий в поле": "Вставте сценарій у поле",
  "Роли и голоса появятся сами": "Ролі й голоси з’являться самі",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Геральт: Знову ти. Що цього разу?\nЦірі: Мені потрібна твоя допомога.",
  "Сейчас нельзя": "Зараз не можна",
  "Вставьте текст в поле": "Вставте текст у поле",
  "Загружаем проекты": "Завантажуємо проєкти",
  "Проекты не загрузились": "Проєкти не завантажилися",
  "Не хватает Circle: пополните баланс": "Бракує Circle: поповніть баланс",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Ціна: {0} C. Натисніть ще раз, щоб озвучити",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Не вдалося порахувати ціну. Спробуйте ще раз",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Сценарій не пройшов перевірку. Змініть текст і спробуйте ще раз.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Не вдалося зібрати доріжку. Якщо Circle списалися, вони повернуться на баланс.",
  "Запуск не подтверждён": "Запуск не підтверджено",
  "Не получилось собрать дорожку.": "Не вдалося зібрати доріжку.",
  "Повторная проверка не спишет Circle дважды.": "Повторна перевірка не спише Circle двічі.",
  "Отправили в чат": "Надіслали в чат",
  "Отправка принята: бот пришлёт дорожку в чат": "Надсилання прийнято: бот надішле доріжку в чат",
  "Прослушивание реплики пока недоступно": "Прослуховування репліки поки недоступне",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Прослухати репліку: {0} C. Натисніть ще раз",
  "Переозвучка реплики пока недоступна": "Переозвучка репліки поки недоступна",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Переозвучити репліку: {0} C. Натисніть ще раз",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Збереження проєктів зараз недоступне. Оновіть дані.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Зміна проєктів зараз недоступна. Оновіть дані.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Проєкт ще зберігається. Спробуйте за секунду.",
  "Результат больше недоступен.": "Результат більше недоступний.",
  "Не удалось проверить владельца проекта.": "Не вдалося перевірити власника проєкту.",
  "Операция не найдена. Проверьте историю.": "Операцію не знайдено. Перевірте історію.",
  "Проект ещё не сохранён.": "Проєкт ще не збережено.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Озвучка проєктів зараз недоступна. Оновіть дані.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Прослуховування репліки зараз недоступне. Оновіть дані.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Переозвучка репліки зараз недоступна. Оновіть дані.",
  "Дорожка ещё не готова.": "Доріжка ще не готова.",
  "Аккаунт сменился. Обновите страницу.": "Акаунт змінився. Оновіть сторінку.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Надсилання ще не підтверджено. Натисніть ще раз, щоб перевірити попередній запит.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Результат проєкту поки недоступний. Перевірте статус ще раз.",
  "Не удалось открыть аудио проекта.": "Не вдалося відкрити аудіо проєкту.",
  "месяц|месяца|месяцев": "місяць|місяці|місяців",
  "покупателя|покупателей|покупателей": "покупця|покупців|покупців",
  "рабочий день|рабочих дня|рабочих дней": "робочий день|робочі дні|робочих днів",
  "друг купит|друга купят|друзей купят": "друг купить|друзі куплять|друзів куплять",
  "покупателем|покупателями|покупателями": "покупцем|покупцями|покупцями",
  "Баннеры": "Банери",
  "Постер": "Постер",
  "Голос героя": "Голос героя",
  "Персонаж говорит": "Персонаж говорить",
  "Было и стало": "Було і стало",
  "Подарок другу": "Подарунок другу",
  "Кружок, который говорит": "Кружечок, що говорить",
  "Персонаж читает ваш текст": "Персонаж читає ваш текст",
  "Рилс с вами одной кнопкой": "Рілс із вами однією кнопкою",
  "Сюжет, монтаж и музыка в шаблоне": "Сюжет, монтаж і музика в шаблоні",
  "Герой говорит": "Герой говорить",
  "Герой говорит вашим текстом": "Герой говорить вашим текстом",
  "Голос и губы в такт": "Голос і губи в такт",
  "Старое фото как новое": "Старе фото як нове",
  "Цвет и резкость за минуту": "Колір і різкість за хвилину",
  "Кавер любым голосом": "Кавер будь-яким голосом",
  "Рок, джаз или lo-fi": "Рок, джаз або lo-fi",
  "Фотосессия в любом образе": "Фотосесія в будь-якому образі",
  "По паре своих фото": "За парою своїх фото",
  "Друзьям": "Друзям",
  "Личное сообщение": "Особисте повідомлення",
  "Подписчикам": "Підписникам",
  "Пост в канал": "Пост у канал",
  "Семье": "Родині",
  "Сообщение родным": "Повідомлення рідним",
  "Геймерам": "Геймерам",
  "Чат по интересам": "Чат за інтересами",
  "Для работы": "Для роботи",
  "Коллегам и в рабочий чат": "Колегам і в робочий чат",
  "Авторам": "Авторам",
  "Блогерам и создателям роликов": "Блогерам і творцям відео",
  "Подарок по моему промокоду": "Подарунок за моїм промокодом",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Кружечки, фото й голос з ШІ прямо в Telegram",
  "Кружки с персонажами": "Кружечки з персонажами",
  "Пишете текст, персонаж его говорит": "Пишете текст, персонаж його говорить",
  "Озвучка любым голосом": "Озвучка будь-яким голосом",
  "Из библиотеки или своим клоном": "З бібліотеки або своїм клоном",
  "Фотосессия без студии": "Фотосесія без студії",
  "Пара своих фото, любой образ": "Пара своїх фото, будь-який образ",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0} з реєстрації за вашим посиланням або з першої покупки за промокодом. Увесь цей час ви отримуєте відсоток з усіх оплат друга. Промокод діє лише до першої покупки друга, а якщо друг прийшов за посиланням, промокод уже не змінює прив’язку.",
  "Что получает друг?": "Що отримує друг?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C одразу: їх не можна вивести, вони згорають через {1}.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "Знижка {0}% на перший пакет Circle діє {1} після оформлення підписки, бо пакети Circle продаються лише з підпискою. Один подарунок на акаунт: за посиланням або промокодом.",
  "Что считается оплатой?": "Що вважається оплатою?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Підписка й пакети Circle, оплачені зірками або карткою. Відсоток рахується від суми, яку друг сплатив, зі знижкою. Бонусні монети, нагороди за завдання й повернення не враховуються.",
  "Какие бывают промокоды?": "Які бувають промокоди?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Ваш промокод партнера дає другу подарунок і прив’язує його до вас, діє лише до його першої покупки. Промокоди STEOS публікує команда в каналі та спільноті STEOS: вони дають Circle зі своїм терміном і працюють для всіх, один раз на акаунт.",
  "Когда приходят Circle?": "Коли приходять Circle?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Одразу після оплати друга, прямо на баланс. На рівні {0} їх можна вивести.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Одразу після оплати друга, прямо на баланс. На рівнях {0} вони працюють усередині STEOS, на рівні {1} їх можна вивести.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Одразу після оплати друга, прямо на баланс. На рівні {0} вони працюють усередині STEOS, на рівні {1} їх можна вивести.",
  "Считаются ли друзья с истёкшей привязкой?": "Чи рахуються друзі із завершеною прив’язкою?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Так. Відсоток з їхніх оплат більше не йде, але в рахунку рівня вони лишаються: рівень рахується за всіма покупцями за весь час.",
  "Кто может выводить?": "Хто може виводити?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "Партнери рівня {0} (від {1}) зі статусом ІП, самозайнятого чи іноземного аналога, після входу через STEOS ID. Виведення лише грошима на рахунок: тут або на {2}.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Амбасадори (від {0}) зі статусом ІП, самозайнятого чи іноземного аналога, після входу через STEOS ID. Виведення лише грошима на рахунок: тут або на {1}.",
  "Можно ли вывести монеты, заработанные до входа?": "Чи можна вивести монети, зароблені до входу?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Так. Монети Circle, зароблені на рівні {0} до входу через STEOS ID, чекають на балансі й стануть доступні для виведення після входу.",
  "Какие монеты тратятся первыми?": "Які монети витрачаються першими?",
  "Можно пригласить самого себя?": "Чи можна запросити самого себе?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Ні. Покупки з вашого акаунта й з повторних акаунтів не враховуються.",
  "Международный": "Міжнародний",
  "Self-employed, sole trader или компания вне РФ": "Self-employed, sole trader або компанія поза РФ",
  "Самозанятый в РФ": "Самозайнятий у РФ",
  "Налог на профессиональный доход": "Податок на професійний дохід",
  "ИП в РФ": "ІП у РФ",
  "Индивидуальный предприниматель": "Індивідуальний підприємець",
  "Имя или компания": "Ім’я або компанія",
  "Как в документах": "Як у документах",
  "TIN или номер в вашей стране": "TIN або номер у вашій країні",
  "ФИО": "ПІБ",
  "Как в паспорте": "Як у паспорті",
  "ИНН": "ІНН",
  "12 цифр": "12 цифр",
  "Название ИП": "Назва ІП",
  "Как в выписке": "Як у виписці",
  "ИНН или ОГРНИП": "ІНН або ОГРНІП",
  "От 10 до 15 цифр": "Від 10 до 15 цифр",
  "НДС": "ПДВ",
  "Плательщик НДС": "Платник ПДВ",
  "Адрес": "Адреса",
  "КПП": "КПП",
  "ОГРН": "ОГРН",
  "Основной офис STEOS": "Головний офіс STEOS",
  "Платёжный агент STEOS в России": "Платіжний агент STEOS у Росії",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Тут відкриється вибір чату Telegram із цим текстом, посиланням і промокодом",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Тут відкриється вибір чату Telegram: банер піде з підписом і кнопкою «Відкрити STEOS»",
  "Ещё <b>{0} {1}</b> до уровня {2}": "Ще <b>{0} {1}</b> до рівня {2}",
  "Максимальный уровень": "Максимальний рівень",
  "До следующего уровня": "До наступного рівня",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Отримуйте до&nbsp;{0}% <span>з&nbsp;покупок друзів</span>",
  "Период": "Період",
  "Кого показать": "Кого показати",
  "Перешли": "Перейшли",
  "Зарегистрировались": "Зареєструвалися",
  "Купили": "Купили",
  "Пока нет данных": "Поки немає даних",
  "{0} к прошлому периоду": "{0} до минулого періоду",
  "за {0} {1}": "за {0} {1}",
  "Пока не считаем": "Поки не рахуємо",
  "нет начислений": "немає нарахувань",
  "Пик <b>{0} C</b>": "Пік <b>{0} C</b>",
  "Начисления по месяцам": "Нарахування за місяцями",
  "Начисления по дням": "Нарахування за днями",
  "Здесь появятся начисления": "Тут з’являться нарахування",
  "Подписка Про": "Підписка Про",
  "Купила Circle": "Купила Circle",
  "Купил Circle": "Купив Circle",
  "Покупатель": "Покупець",
  "по промокоду": "за промокодом",
  "привязка истекла": "прив’язка завершилась",
  "Это весь список · {0}": "Це весь список · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "Друг прив’язаний до вас {0}: з реєстрації за посиланням або з першої покупки за промокодом. Промокод діє лише до першої покупки друга.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Покупці із завершеною прив’язкою лишаються в рахунку рівня.",
  "Пока никого": "Поки нікого",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Поділіться посиланням або промокодом, перші друзі з’являться тут",
  "Картинка": "Зображення",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Посилання й промокод уже на зображенні. Натисніть на шаблон, щоб змінити підпис і опублікувати.",
  "{0}, открыть и опубликовать": "{0}, відкрити й опублікувати",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Для Reels, Shorts, TikTok і VK Кліпів. Промокод і посилання вже в кадрі, бот надішле ролик у чат.",
  "{0}, открыть": "{0}, відкрити",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Посилання й промокод уже в тексті. Скопіюйте його або надішліть у чат.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "Зображення піде в чат із підписом і кнопкою «Відкрити STEOS». Підійде для груп, каналів і особистих повідомлень.",
  "Баннер «{0}» с вашим промокодом": "Банер «{0}» з вашим промокодом",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR-постер: код веде на ваше посилання, промокод {0}",
  "Кружки, фото и голос с ИИ": "Кружечки, фото й голос з ШІ",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C на старт за промокодом",
  "Начните по ссылке или промокоду": "Почніть за посиланням або промокодом",
  "Наведите камеру телефона": "Наведіть камеру телефона",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4 для друку: стійки, вітрини, візитки. Код веде на ваше посилання, а промокод під ним можна ввести й без камери.",
  "Цвет постера": "Колір постера",
  "Прислать PDF в чат": "Надіслати PDF у чат",
  "Вывести": "Вивести",
  "Заявка на {0} C не подтверждена": "Заявку на {0} C не підтверджено",
  "Вывод сейчас недоступен": "Виведення зараз недоступне",
  "Вывод недоступен": "Недоступно",
  "Деньгами на ваш счёт за {0}": "Грошима на ваш рахунок за {0}",
  "Вывод от {0} C": "Виведення від {0} C",
  "Вывод заработает после входа через STEOS ID": "Виведення запрацює після входу через STEOS ID",
  "Войдите через STEOS ID": "Увійдіть через STEOS ID",
  "Вывод доступен на уровне {0}, от {1}": "Виведення доступне на рівні {0}, від {1}",
  "Нужен уровень {0}": "Потрібен рівень {0}",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Виведення відкриється на рівні {0}, від {1}. Поки Circle працюють усередині STEOS",
  "Не подключён": "Не підключено",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Вхід пов’яже акаунт бота зі спільним акаунтом STEOS: баланс стане спільним, а виведення запрацює тут і на сайті STEOS ID.",
  "Выплачено": "Виплачено",
  "В обработке": "В обробці",
  "Отклонено": "Відхилено",
  "Не удалось загрузить историю выводов": "Не вдалося завантажити історію виведень",
  "Выводов пока не было": "Виведень ще не було",
  "за всё время": "за весь час",
  "Можно вывести": "Можна вивести",
  "Тестовая программа: настоящих выплат нет": "Тестова програма: справжніх виплат немає",
  "Баланс и выводы есть и на {0}.": "Баланс і виведення є й на {0}.",
  "Вопрос о выводе?": "Питання про виведення?",
  "Напишите в поддержку": "Напишіть у підтримку",
  "Поделитесь ссылкой или промокодом": "Поділіться посиланням або промокодом",
  "Друг привязывается к вам на {0}": "Друг прив’язується до вас на {0}",
  "Друг получает подарок": "Друг отримує подарунок",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C одразу і −{1}% на перший пакет Circle після підписки",
  "Друг платит в STEOS": "Друг платить у STEOS",
  "Подписка и пакеты Circle звёздами или картой": "Підписка й пакети Circle зірками або карткою",
  "Вам приходит процент": "Вам надходить відсоток",
  "{0}% с каждой оплаты, сразу на баланс": "{0}% з кожної оплати, одразу на баланс",
  "Шаг {0}": "Крок {0}",
  "От {0}": "Від {0}",
  "С первого дня": "З першого дня",
  "Если {0} {1} {2}": "Якщо {0} {1} {2}",
  "{0} C за {1}": "{0} C за {1}",
  "Хватит на {0} в месяц": "Вистачить на {0} на місяць",
  "Кружок стоит {0} C": "Кружечок коштує {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Рахуємо за підпискою {0}: {1} на місяць, це {2}&nbsp;C. Відсоток іде з кожної оплати друга {3} прив’язки.",
  "Уровень считается вместе с вашими {0}.": "Рівень рахується разом із вашими {0}.",
  "Калькулятор дохода": "Калькулятор доходу",
  "Тариф друзей": "Тариф друзів",
  "Сколько друзей купят подписку": "Скільки друзів куплять підписку",
  "Вы получите": "Ви отримаєте",
  "C в месяц": "C на місяць",
  "Проценты, сроки и ограничения": "Відсотки, терміни й обмеження",
  "Circle можно вывести": "Circle можна вивести",
  "Circle работают внутри STEOS": "Circle працюють усередині STEOS",
  "Привязка на {0}": "Прив’язка на {0}",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Відсоток іде з усіх оплат друга: з реєстрації за посиланням або з першої покупки за промокодом",
  "Ссылка главнее промокода": "Посилання головніше за промокод",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Якщо друг прийшов за посиланням, промокод прив’язку вже не змінює",
  "Промокод только до первой покупки": "Промокод лише до першої покупки",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Після першої оплати друга ваш промокод партнера для нього не діє",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C одразу, згорять через {1}. {2} на перший пакет Circle {3} після підписки",
  "Только уровень {0}": "Лише рівень {0}",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Від {0} {1}, після входу через STEOS ID. Для ІП, самозайнятих та їхніх аналогів в інших країнах",
  "Счёт на компанию STEOS": "Рахунок на компанію STEOS",
  "Плательщик появится, когда вывод откроется": "Платник з’явиться, коли відкриється виведення",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "У РФ: {0}, у рублях. Міжнародний статус: {1}, у євро",
  "Выплата за {0}": "Виплата за {0}",
  "После проверки счёта, от {0} C": "Після перевірки рахунку, від {0} C",
  "Коротко о главном": "Коротко про головне",
  "Здесь краткое изложение. Полный текст условий на {0}": "Тут короткий виклад. Повний текст умов на {0}",
  "Понятно": "Зрозуміло",
  "У вас {0}.": "У вас {0}.",
  "Покупателей пока нет.": "Покупців поки немає.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Рівень рахується за всіма покупцями за весь час, із завершеною прив’язкою теж.",
  "Введите сумму": "Введіть суму",
  "Можно вывести не больше {0} C": "Можна вивести не більше {0} C",
  "Заполните реквизиты": "Заповніть реквізити",
  "Загрузите счёт на оплату": "Завантажте рахунок на оплату",
  "Счёт ещё проверяется": "Рахунок ще перевіряється",
  "Выплата в {0} · 1 C = {1} {0}": "Виплата в {0} · 1 C = {1} {0}",
  "Вывести {0} C": "Вивести {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Виставте рахунок у {0}. Перевіримо його, і гроші надійдуть за {1}.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Виставте рахунок у євро. Перевіримо його, і гроші надійдуть за {0}. Реквізити збережуться в STEOS ID.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Виставте рахунок у рублях. Перевіримо його, і гроші надійдуть за {0}. Реквізити збережуться в STEOS ID.",
  "Скопировать {0}": "Копіювати {0}",
  "юридический адрес": "юридичну адресу",
  "Скопировать название компании": "Копіювати назву компанії",
  "Скопировать все реквизиты": "Копіювати всі реквізити",
  "Реквизиты для счёта": "Реквізити для рахунку",
  "Проверяем счёт…": "Перевіряємо рахунок…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG або PNG, до 10 МБ",
  "Можно вывести {0} C": "Можна вивести {0} C",
  "Сумма, C": "Сума, C",
  "Сумма вывода, C": "Сума виведення, C",
  "Всё": "Усе",
  "Придёт на счёт": "Надійде на рахунок",
  "Реквизиты": "Реквізити",
  "Счёт на оплату": "Рахунок на оплату",
  "Заявка на вывод принята": "Заявку на виведення прийнято",
  "{0} придут за {1} после проверки счёта": "{0} надійдуть за {1} після перевірки рахунку",
  "Ролик принят в обработку": "Ролик прийнято в обробку",
  "Ролик в чате с ботом": "Ролик у чаті з ботом",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Бот надішле його після підготовки. Доставку ще не підтверджено.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Збережіть його й викладіть у Reels, Shorts, TikTok чи VK Кліпи",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Промокод і посилання вже в кадрі. Бот надішле ролик у чат, звідти його можна зберегти й викласти.",
  "Прислать в чат": "Надіслати в чат",
  "Текст выделен: скопируйте его вручную": "Текст виділено: скопіюйте його вручну",
  "Баннер готов: отправить его в чат можно из Telegram": "Банер готовий: надіслати його в чат можна з Telegram",
  "PDF принят в очередь": "PDF у черзі",
  "PDF в чате": "PDF у чаті",
  "Не удалось загрузить период. Попробуйте ещё раз": "Не вдалося завантажити період. Спробуйте ще раз",
  "Без начислений": "Без нарахувань",
  "Значение выделено: скопируйте его вручную": "Значення виділено: скопіюйте його вручну",
  "Реквизиты выделены: скопируйте их вручную": "Реквізити виділено: скопіюйте їх вручну",
  "Нужен файл PDF, JPG или PNG": "Потрібен файл PDF, JPG або PNG",
  "Файл {0}, можно до 10 МБ": "Файл {0}, можна до 10 МБ",
  "Партнёрство не загрузилось": "Партнерство не завантажилося",
  "Загружаем партнёрскую программу": "Завантажуємо партнерську програму",
  "за неделю": "за тиждень",
  "за месяц": "за місяць",
  "Для вывода войдите через STEOS ID": "Для виведення увійдіть через STEOS ID",
  "Вывод недоступен на текущем уровне": "Виведення недоступне на поточному рівні",
  "Сумма больше доступной": "Сума більша за доступну",
  "Сумма меньше минимальной": "Сума менша за мінімальну",
  "Проверьте реквизиты и счёт": "Перевірте реквізити й рахунок",
  "Счёт ещё не проверен. Загрузите его заново": "Рахунок ще не перевірено. Завантажте його знову",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Відповіді немає. Перевірте ту саму заявку: її дані й ключ збережено",
  "Не удалось загрузить список друзей": "Не вдалося завантажити список друзів",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Не вдалося відновити попередню заявку. Напишіть у підтримку перед новою",
  "Партнёрская программа временно недоступна": "Партнерська програма тимчасово недоступна",
  "Не удалось загрузить следующую страницу": "Не вдалося завантажити наступну сторінку",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Не вдалося підготувати банер. Спробуйте ще раз",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Бот не може підготувати матеріал: відкрийте чат із ботом і спробуйте ще раз",
  "Материал сейчас недоступен": "Матеріал зараз недоступний",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Надсилання не підтверджено. Натисніть ще раз: повтор перевірить попередній запит",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Попереднє надсилання не відновлено. Напишіть у підтримку",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Попереднє надсилання підтверджено. Натисніть ще раз",
  "Отправка не подтверждена": "Надсилання не підтверджено",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Рахунок не пройшов перевірку. Виберіть PDF, JPG або PNG до 10 МБ",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Не вдалося безпечно зберегти заявку. Надсилання не виконано",
  "Тут откроется инструмент «{0}»": "Тут відкриється інструмент «{0}»",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Геральт, Цірі та ще 2 400 голосів скажуть усе, що напишете",
  "Снимите себя, и персонаж повторит ваши движения": "Зніміть себе, і персонаж повторить ваші рухи",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Оберіть образ, і за хвилину будуть готові 3 кадри з одного селфі",
  "Сделать": "Створити",
  "2 400 голосов, 19 языков": "2 400 голосів, 19 мов",
  "Текст в речь голосом персонажа или своим клоном": "Текст у мовлення голосом персонажа або своїм клоном",
  "Ваш голос за две минуты": "Ваш голос за дві хвилини",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Запишіть зразок, і клон з’явиться в усіх інструментах з озвучкою",
  "Движения": "Рухи",
  "бесплатно": "безкоштовно",
  "/сек": "/с",
  "готов": "готовий",
  "Клон · готов": "Клон · готовий",
  "студия: Мой голос": "Мій голос",
  "Сейчас в тренде": "Зараз у тренді",
  "Популярное за неделю": "Популярне за тиждень",
  "Геральт скажет ваш текст": "Геральт скаже ваш текст",
  "Вы в знаменитых сценах": "Ви у відомих сценах",
  "3 кадра в любом образе": "3 кадри в будь-якому образі",
  "Готовый сюжет с вами": "Готовий сюжет із вами",
  "Вы повторите любой танец": "Ви повторите будь-який танець",
  "Ваш снимок в движении": "Ваше фото в русі",
  "Фото скажет ваш текст": "Фото скаже ваш текст",
  "Легенды замка": "Легенди замку",
  "Город инков": "Місто інків",
  "Неоновый дождь": "Неоновий дощ",
  "Утренний бег": "Ранкова пробіжка",
  "Танец теней": "Танець тіней",
  "Дорога домой": "Дорога додому",
  "Ночной рейв": "Нічний рейв",
  "Снежный пик": "Сніжна вершина",
  "Тайны Хейвена": "Таємниці Гейвена",
  "Магия рун": "Магія рун",
  "Странные дела": "Дивні справи",
  "Ночной рынок": "Нічний ринок",
  "Ретро-кадр": "Ретро-кадр",
  "Утро в горах": "Ранок у горах",
  "Золотой час": "Золота година",
  "Студийный свет": "Студійне світло",
  "Полароид": "Полароїд",
  "Киберпанк": "Кіберпанк",
  "Старый маяк": "Старий маяк",
  "Шторм в заливе": "Шторм у затоці",
  "Кинотрейлер": "Кінотрейлер",
  "Город в движении": "Місто в русі",
  "Интервью": "Інтерв’ю",
  "Пустыня на закате": "Пустеля на заході сонця",
  "Подводный мир": "Підводний світ",
  "Кружок «Привет»": "Кружечок «Привіт»",
  "Спокойной ночи": "Надобраніч",
  "Поздравляю": "Вітаю",
  "Скучаю": "Сумую",
  "Новости дня": "Новини дня",
  "Нос корабля": "Ніс корабля",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Двоє на носі корабля, руки розкинуті назустріч вітру",
  "Героиня": "Героїня",
  "роль: Герой": "Герой",
  "Уклонение от пуль": "Ухиляння від куль",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Час завмирає, ви прогинаєтеся назад, і кулі пролітають повз",
  "Танец в закусочной": "Танець у закусочній",
  "Пара танцует твист у стойки придорожной закусочной": "Пара танцює твіст біля стійки придорожньої закусочної",
  "Танцор": "Танцюрист",
  "Танцовщица": "Танцівниця",
  "Свидание под дождём": "Побачення під дощем",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Злива, старий дім і зустріч, на яку обоє чекали роками",
  "Он": "Він",
  "Она": "Вона",
  "Речь перед битвой": "Промова перед битвою",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Вождь їде вздовж строю, і військо відповідає ревом",
  "Вождь": "Вождь",
  "Знаменосец": "Прапороносець",
  "Погоня по крышам": "Погоня дахами",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Стрибки між дахами нічного міста, погоня не відстає",
  "Беглец": "Втікач",
  "Преследователь": "Переслідувач",
  "Ограбление казино": "Пограбування казино",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Команда в смокінгах проходить залою, сейф уже відчинено",
  "Главарь": "Ватажок",
  "Напарник": "Напарник",
  "Напарница": "Напарниця",
  "Прощание на вокзале": "Прощання на вокзалі",
  "Поезд трогается, двое держатся за руки до последнего": "Потяг рушає, двоє тримаються за руки до останнього",
  "Пассажир": "Пасажир",
  "Провожающий": "Той, хто проводжає",
  "Дуэль на закате": "Дуель на заході сонця",
  "Пустая улица, два стрелка и последние секунды тишины": "Порожня вулиця, два стрільці й останні секунди тиші",
  "Шериф": "Шериф",
  "Злодей": "Лиходій",
  "Танец на лестнице": "Танець на сходах",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Лиходій у яскравому костюмі танцює на довгих вуличних сходах",
  "Выход в открытый космос": "Вихід у відкритий космос",
  "Астронавт парит над Землёй, трос уходит к станции": "Астронавт ширяє над Землею, трос тягнеться до станції",
  "Астронавт": "Астронавт",
  "Рассвет над саванной": "Світанок над саваною",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Улюбленця піднімають над скелею, і вся савана дивиться на нього",
  "Главная роль": "Головна роль",
  "Хранитель": "Хранитель",
  "Полёт под луной": "Політ під місяцем",
  "Велосипед отрывается от земли и летит на фоне луны": "Велосипед відривається від землі й летить на тлі місяця",
  "Финальная поддержка": "Фінальна підтримка",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Розбіг, стрибок і підтримка над головою під оплески залу",
  "Партнёрша": "Партнерка",
  "Партнёр": "Партнер",
  "Песня на холме": "Пісня на пагорбі",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Альпійський луг і вітер: ви кружляєте з піснею, а діти біжать вам назустріч",
  "Бледная кожа": "Бліда шкіра",
  "Хвойный лес": "Хвойний ліс",
  "Первый взгляд": "Перший погляд",
  "Туман над рекой": "Туман над річкою",
  "Полночь в школе": "Опівночі в школі",
  "Двое на поляне": "Двоє на галявині",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Промінь пробивається крізь хвою, і двоє завмирають посеред лісової галявини",
  "Глаза цвета янтаря": "Очі кольору бурштину",
  "Бал выпускников": "Випускний бал",
  "Клятва": "Клятва",
  "Игра в грозу": "Гра в грозу",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Грім над лісовою галявиною, і кожен удар битою звучить як гуркіт",
  "Отбивающий": "Відбивальник",
  "Подающая": "Подавальниця",
  "Ловец": "Ловець",
  "К вершине сосны": "До верхівки сосни",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Він несе її на спині до верхівки сосни, унизу туман і весь ліс",
  "Примерка брони": "Приміряння броні",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "Броня защіпається на вас деталь за деталлю, і шолом закриває обличчя",
  "Полёт над городом": "Політ над містом",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Розгін над нічним містом, віраж між вежами й посадка на дах",
  "Пилот брони": "Пілот броні",
  "Ночь в мастерской": "Ніч у майстерні",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Іскри зварювання, креслення просто в повітрі й перший вдалий запуск",
  "Изобретатель": "Винахідник",
  "Последний заряд": "Останній заряд",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "Заряд броні на межі, команда стає спина до спини, і все вирішує останній залп",
  "Герой в броне": "Герой у броні",
  "Качели на паутине": "Гойдалка на павутині",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Стрибок із карниза, павутина натягується, і вулиця мчить під ногами",
  "Герой в маске": "Герой у масці",
  "Поцелуй под дождём": "Поцілунок під дощем",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Нічний провулок і злива: він висить догори ногами, вона піднімає край маски",
  "Крыша на закате": "Дах на заході сонця",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Двоє сидять на краю даху, унизу шумить місто, сонце сідає за вежі",
  "Бой в поезде": "Бій у потязі",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Сутичка на даху потяга, що мчить, а потім герой зупиняє вагон руками",
  "Пассажирка": "Пасажирка",
  "Для маркетплейса": "Для маркетплейсів",
  "Праздники": "Свята",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Привітання, кружечки й пости до свят: 1 квітня, Великдень, 8 березня",
  "1 апреля": "1 квітня",
  "Пасха": "Великдень",
  "8 марта": "8 березня",
  "Мода": "Мода",
  "Аватарки": "Аватарки",
  "Фильмы": "Фільми",
  "Игры": "Ігри",
  "Путешествия": "Подорожі",
  "Сумерки": "Сутінки",
  "Железный человек": "Залізна людина",
  "Человек-паук": "Людина-павук",
  "Романтика": "Романтика",
  "Погони": "Погоні",
  "Всей семьёй": "Усією родиною",
  "Особая подборка": "Особлива добірка",
  "Особая подборка {0}, {1}": "Особлива добірка {0}, {1}",
  "Подборка {0}, {1}": "Добірка {0}, {1}",
  "{0} в подборке": "{0} у добірці",
  "шаблон|шаблона|шаблонов": "шаблон|шаблони|шаблонів",
  "шаблона|шаблонов|шаблонов": "шаблону|шаблонів|шаблонів",
  "сцена|сцены|сцен": "сцена|сцени|сцен",
  "инструмент|инструмента|инструментов": "інструмент|інструменти|інструментів",
  "инструмента|инструментов|инструментов": "інструмента|інструментів|інструментів",
  "стиль|стиля|стилей": "стиль|стилі|стилів",
  "кадра|кадров|кадров": "кадру|кадрів|кадрів",
  "ребёнок|ребёнка|детей": "дитина|дитини|дітей",
  "питомец|питомца|питомцев": "улюбленець|улюбленці|улюбленців",
  "кружки": "кружечки",
  "голос": "голос",
  "текст": "текст",
  "для бизнеса": "для бізнесу",
  "Кружок из видео": "Відеоповідомлення з відео",
  "Фото в новом стиле": "Фото в новому стилі",
  "Фото по описанию": "Фото за описом",
  "Семейный портрет": "Сімейний портрет",
  "Видео в новом стиле": "Відео в новому стилі",
  "Видео по описанию": "Відео за описом",
  "Видео другим голосом": "Відео іншим голосом",
  "Объёмное фото": "Об’ємне фото",
  "Анимация из серии": "Анімація із серії",
  "Видео из поездки": "Відео з подорожі",
  "Фильм из фотографий": "Фільм із фотографій",
  "Изменить видео": "Змінити відео",
  "текст или запись": "текст або запис",
  "видео до 1 минуты": "відео до 1 хвилини",
  "1 фото и текст": "1 фото й текст",
  "запись или аудиофайл": "запис або аудіофайл",
  "5 фото лица": "5 фото обличчя",
  "1 селфи": "1 селфі",
  "описание словами": "опис словами",
  "фото или описание": "фото або опис",
  "старое фото": "старе фото",
  "чёрно-белое фото": "чорно-біле фото",
  "фото близких": "фото близьких",
  "от 2 до 9 фото": "від 2 до 9 фото",
  "тема поста": "тема посту",
  "1 фото или видео": "1 фото або відео",
  "ваше фото": "ваше фото",
  "фото тех, кто сыграет": "фото тих, хто зіграє",
  "1 видео": "1 відео",
  "видео и новый текст": "відео й новий текст",
  "видео с речью": "відео з мовленням",
  "текст поздравления": "текст привітання",
  "от 3 фото": "від 3 фото",
  "фото из поездки": "фото з подорожі",
  "семейные фото": "сімейні фото",
  "сценарий": "сценарій",
  "запись голоса": "запис голосу",
  "песня": "пісня",
  "файл или ссылка": "файл або посилання",
  "название товара": "назва товару",
  "от 1 до 5 фото товара": "від 1 до 5 фото товару",
  "фото товара": "фото товару",
  "1 видео с вами": "1 відео з вами",
  "ваше видео": "ваше відео",
  "картинка": "зображення",
  "идея словами": "ідея словами",
  "ваш промпт": "ваш промпт",
  "нужно: 1 фото": "1 фото",
  "нужно: Текст": "Текст",
  "нужно: Тема": "Тема",
  "нужно: Запись": "Запис",
  "формат: Reels": "рілсів",
  "формат: фото": "фото",
  "формат: видео": "відео",
  "формат: кружков": "кружечків",
  "формат: шаблонов": "шаблонів",
  "любое, где хорошо видно лицо": "будь-яке, де добре видно обличчя",
  "лицо крупно и при хорошем свете": "обличчя крупно й при доброму світлі",
  "селфи, лицо крупно": "селфі, обличчя крупно",
  "снимок оживёт в ролике": "знімок оживе в ролику",
  "что скажет герой": "що скаже герой",
  "или фото, из которых сделаем слайды": "або фото, з яких зробимо слайди",
  "Сколько стоит одна генерация": "Скільки коштує одна генерація",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Фото коштує {0} C, фотосесія — {1} C за 3 кадри, відео — {2} C за 5 секунд. Помічники для тексту, наприклад опис товару, коштують {3} C. Ціну завжди видно на кнопці «Створити» до списання.",
  "Что такое C и как пополнить баланс": "Що таке C і як поповнити баланс",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C — це монети Circle, ними платять за створення. Пакети й підписку купують на вкладці «Баланс», там само видно залишок.",
  "Какие файлы можно загружать": "Які файли можна завантажувати",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Відео до 1 хвилини й 15 МБ, фото в JPG або PNG, аудіо в MP3, WAV або M4A. Обмеження показано в самому інструменті.",
  "Как сделать дешевле": "Як зробити дешевше",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Якщо Circle на роботу бракує, кнопка внизу екрана відкриє «Бракує Circle»: там є «Зробити дешевше». Знижка {0}%, на результаті з’явиться водяний знак.",
  "Где найти готовые результаты": "Де знайти готові результати",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "У розділі «Історія» в меню «Ще». Там можна знову завантажити файл або надіслати в чат.",
  "Можно ли использовать свой голос": "Чи можна використати свій голос",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Так. Клонуйте голос на вкладці «Клон», і він з’явиться в списку голосів в усіх інструментах з озвучкою.",
  "Фотосессия из {0} в стиле шаблона": "Фотосесія з {0} у стилі шаблону",
  "По желанию: {0}": "За бажанням: {0}",
  "Тут откроется шаблон «{0}»": "Тут відкриється шаблон «{0}»",
  "Только до": "Тільки до",
  "Только после": "Тільки після",
  "До: {0} %": "До: {0} %",
  "подборка": "добірка",
  "Все форматы": "Усі формати",
  "Состав": "Склад",
  "Вкладки каталога": "Вкладки каталогу",
  "Найти подборку": "Знайти добірку",
  "Найти шаблон": "Знайти шаблон",
  "Поиск среди {0}": "Пошук серед {0}",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "За запитом «{0}» добірок немає. Пошукайте серед усіх шаблонів",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "За запитом «{0}» у добірці «{1}» нічого немає. Пошукайте в усіх шаблонах",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "За запитом «{0}» у «Для вас» нічого немає. Пошукайте в усіх шаблонах",
  "В подборке «{0}» нет сцен «{1}»": "У добірці «{0}» немає сцен «{1}»",
  "Посмотрите все сцены подборки": "Перегляньте всі сцени добірки",
  "В подборке «{0}» нет {1}": "У добірці «{0}» немає {1}",
  "Посмотрите во всех форматах": "Перегляньте всі формати",
  "В «Рекомендуем» нет {0}": "У «Для вас» немає {0}",
  "Пока ничего нет": "Поки нічого немає",
  "Шаблоны этого формата появятся совсем скоро": "Шаблони цього формату з’являться зовсім скоро",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "За запитом «{0}» серед {1} нічого немає. Пошукайте в усіх форматах",
  "Искать во всех форматах": "Шукати в усіх форматах",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "За запитом «{0}» серед шаблонів нічого немає. Спробуйте інше слово",
  "Загружаем ещё": "Завантажуємо ще",
  "Это все шаблоны": "Це всі шаблони",
  "Тренды": "Тренди",
  "Вкладки страницы": "Вкладки сторінки",
  "Найти сцену": "Знайти сцену",
  "Найти в подборке": "Знайти в добірці",
  "Искать во всех сценах": "Шукати в усіх сценах",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "За запитом «{0}» добірок немає. Пошукайте серед усіх сцен",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "За запитом «{0}» у добірці «{1}» нічого немає. Пошукайте в усіх сценах",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "За запитом «{0}» у «Трендах» нічого немає. Пошукайте в усіх сценах",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "За запитом «{0}» у «Для вас» нічого немає. Пошукайте в усіх сценах",
  "В «Трендах» нет сцен «{0}»": "У «Трендах» немає сцен «{0}»",
  "В «Рекомендуем» нет сцен «{0}»": "У «Для вас» немає сцен «{0}»",
  "Посмотрите все сцены этой вкладки": "Перегляньте всі сцени цієї вкладки",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "У добірці «{0}» нічого за запитом «{1}». Пошукайте в усіх шаблонах",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "У цій добірці поки немає таких шаблонів. Перегляньте її повністю або оберіть іншу вкладку",
  "Поиск в подборке «{0}»: {1}": "Пошук у добірці «{0}»: {1}",
  "Вкладки подборки": "Вкладки добірки",
  "Нужно: {0}": "Потрібно: {0}",
  "Нужно": "Потрібно",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "За запитом «{0}» немає ні інструментів, ні шаблонів. Спробуйте інше слово або перегляньте всі інструменти",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "За запитом «{0}» у розділі «{1}» нічого немає. Пошукайте в усіх інструментах",
  "Искать во всех": "Шукати всюди",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "За запитом «{0}» інструментів немає. Спробуйте інше слово",
  "Найти инструмент": "Знайти інструмент",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Не вдалося відкрити інструмент. Оновіть каталог і спробуйте ще раз.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "Інструмент не відкрився за 30 секунд. Повторіть запит або поверніться назад.",
  "Карточка товара": "Картка товару",
  "Рилс готов": "Рілс готовий",
  "Кавер не создан": "Кавер не створено",
  "Фотосессия не создана": "Фотосесію не створено",
  "Рилс не создан": "Рілс не створено",
  "Карточка не создана": "Картку не створено",
  "Слайды не созданы": "Слайди не створено",
  "Запись не обработана": "Запис не оброблено",
  "Коллаж не создан": "Колаж не створено",
  "· остаток {0} C": "· залишок {0} C",
  "Вернули {0} C": "Повернули {0} C",
  "Списано {0} C со скидкой, {1} водяной знак": "Списано {0} C зі знижкою, {1} водяний знак",
  "Списано {0} C": "Списано {0} C",
  "Рисованному стилю камера не нужна": "Мальованому стилю камера не потрібна",
  "У этой камеры объектив встроенный": "У цієї камери вбудований об’єктив",
  "У этой камеры резкость не настраивается": "У цієї камери різкість не налаштовується",
  "У этого объектива диафрагма постоянная": "У цього об’єктива діафрагма постійна",
  "Встроенный": "Вбудований",
  "Как у камеры": "Як у камери",
  "до {0} МБ": "до {0} МБ",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "За запитом {0} немає ні інструментів, ні шаблонів. Спробуйте інше слово або перегляньте всі інструменти",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "За запитом {0} у розділі {1} нічого немає. Пошукайте в усіх інструментах",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "За запитом {0} інструментів немає. Спробуйте інше слово",
  "в «Трендах»": "у «Трендах»",
  "в «Рекомендуем»": "у «Для вас»",
  "в подборке {0}": "у добірці {0}",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "За запитом {0} {1} нічого немає. Пошукайте в усіх сценах",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "У добірці {0} нічого за запитом {1}. Пошукайте в усіх шаблонах",
  "сцен {0}": "сцен {0}",
  "В подборке {0} нет {1}": "У добірці {0} немає {1}",
  "В подборке {0} нет таких шаблонов": "У добірці {0} немає таких шаблонів",
  "Посмотрите её целиком или выберите другую вкладку": "Перегляньте її повністю або оберіть іншу вкладку",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "За запитом {0} у цьому форматі нічого немає. Пошукайте в усіх форматах",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "За запитом {0} серед шаблонів нічого немає. Спробуйте інше слово",
  "Здесь нет шаблонов": "Тут немає шаблонів",
  "Заказ принят": "Замовлення прийнято",
  "Бот пришлёт результат в чат, в отдельную тему.": "Бот надішле результат у чат, в окрему тему.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Змініть запит і спробуйте ще раз. Circle за перевірене замовлення не повертаються.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Збій на нашому боці. Circle повернулися на баланс.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "Інструмент ще підключається: замовлення стоїть у черзі й почнеться саме, бот надішле результат у чат.",
  "Сначала отметьте согласие ниже": "Спершу позначте згоду нижче",
  "Главное фото: {0}": "Головне фото: {0}",
  "Загружаем превью…": "Завантажуємо прев’ю…",
  "Фото не подошло": "Фото не підійшло",
  "Проверить загрузку": "Перевірити завантаження",
  "Опишите, что хотите увидеть": "Опишіть, що хочете побачити",
  "Не помещается: до {0} знаков": "Не вміщується: до {0} символів",
  "{0} во весь экран": "{0} на весь екран",
  "Загрузить картинку": "Завантажити зображення",
  "Ваша": "Ваша",
  "Убрать картинку": "Прибрати зображення",
  "Этот инструмент пока недоступен": "Цей інструмент поки недоступний",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Оберіть інший інструмент або поверніться до шаблонів.",
  "Вернуться": "Повернутися",
  "Образ": "Образ",
  "Ваши селфи": "Ваші селфі",
  "Три разных кадра: лицо крупно, при хорошем свете": "Три різні кадри: обличчя крупно, при доброму світлі",
  "Подтверждаю согласие людей на фото": "Підтверджую згоду людей на фото",
  "От одного до пяти ракурсов, первый — главный": "Від одного до п’яти ракурсів, перший — головний",
  "Категория": "Категорія",
  "Набор сцен": "Набір сцен",
  "Загрузите фото: нужно {0}": "Завантажте фото: потрібно {0}",
  "Выберите: {0}": "Оберіть: {0}",
  "Не удалось загрузить экран.": "Не вдалося завантажити екран.",
  "Сцен: {0}": "Сцен: {0}",
  "Заказ создан, следите за ним в «Истории».": "Замовлення створено, стежте за ним в «Історії».",
  "Старые": "Старі",
  "Длинные": "Довгі",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Стиль уже задає світло й колір. Оберіть інший, якщо хочете змінити",
  "{0} открывается только до f/{1}": "{0} відкривається лише до f/{1}",
  "Объектив не задаёт светосилу": "Об’єктив не задає світлосилу",
  "Этот объектив открывается только до f/{0}": "Цей об’єктив відкривається лише до f/{0}",
  "Назад к настройкам": "Назад до налаштувань",
  "Группа": "Група",
  "Нашли {0}": "Знайшли {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Нічого не знайшлося. Спробуйте інше слово або скиньте групу.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Вибір одразу поверне до налаштувань. Ціна не змінюється",
  "Сравнить: было и стало": "Порівняти: було й стало",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Беремо стиль: колір, світло, обробку. Саме зображення й обличчя з нього не переносимо",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Беремо сцену: фон, світло й подачу. Саме зображення й обличчя з нього не переносимо",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Беремо образ: одяг, позу, фон і світло. У кадрі будете ви, обличчя із зображення не переносимо",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Зображення не підійшло: не відкривається, спробуйте JPG або PNG",
  "Картинка не подошла: больше {0} МБ": "Зображення не підійшло: більше {0} МБ",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Зображення не підійшло: замале, потрібно від {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Зображення не підійшло: на ньому захищений або заборонений вміст",
  "Загрузить картинку-референс": "Завантажити зображення-референс",
  "Озвучка текста": "Озвучення тексту",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Запишіть 2 секунд мовлення, і бот заговорить вашим голосом",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Готові голоси — на вкладці «Мої» в розділі «Голоси»",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Під цією назвою голос буде у вашому списку. Опис бачите лише ви",
  "Голос появится на вкладке «Мои»": "Голос з’явиться на вкладці «Мої»",
  "Имя в списке голосов": "Назва в списку голосів",
  "Уже в «Озвучке»": "Уже в «Голосах»",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "Голос — на вкладці «Мої» з позначкою «Мій»",
  "Карточка голоса": "Картка голосу",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Натисніть на голос у списку, щоб перейменувати або видалити",
  "Так голос выглядит в списке": "Так голос виглядає у списку",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "Голос уже на вкладці «Мої». Послухайте, як він звучить",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Триває перевірка й навчання, зазвичай 1–3 хвилини. Голос сам з’явиться на вкладці «Мої»",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "Голос зникне з вкладки «Мої». Повернути його не вийде.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Зазвичай 1–3 хвилини. Можна закрити застосунок, голос з’явиться у списку",
  "Можно закрыть приложение": "Можна закрити застосунок",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Запишіть мовлення або завантажте файли: від 0:02 до 1:30. Підійдуть MP3, WAV, M4A, OGG і WEBM, до 10 файлів по 20 МБ",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "Створено {n} клонів із {n}. Видаліть один, щоб додати новий",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Без підписки можна створити {n} клони. З підпискою — до {0}",
  "До {0} клонов": "До {0} клонів",
  "Три клона бесплатно": "Три клони безкоштовно",
  "Запишите ещё один, другим тоном или настроением": "Запишіть ще один — іншим тоном чи настроєм",
  "С подпиской можно создать до {0}": "З підпискою можна створити до {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Привіт! Це запис для мого голосу. Я говорю спокійно і в звичайному темпі, як у розмові з другом. Що природніше вийде зараз, то точніше звучатиме клон.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Знаєте, що найдивніше в готуванні за відео? Дивишся, як людина за хвилину ріже цибулю, і думаєш: це ж просто. А потім цибуля чомусь скрізь, крім сковорідки.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Учора нарешті розібрав коробки після переїзду. Знайшов старий плеєр, три зарядки від телефонів, яких уже немає, і зошит із планами на літо. Плеєр досі працює.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Погода сьогодні дивна: зранку світило сонце, до обіду пішов дощ, а на вечір обіцяють сніг. Саме час заварити щось гаряче й нікуди не поспішати.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Раз, два, три, перевірка. Мене добре чути? Зараз я прочитаю кілька фраз різним тоном: спочатку спокійно, потім трохи голосніше, а наприкінці зовсім тихо, майже пошепки.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Мій кіт вважає, що клавіатура створена для сну, а монітор потрібен, щоб закривати його хвостом. Тож якщо в записі щось зашурхотить, знайте: це була командна робота.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Є просте правило: якщо щось не виходить із третьої спроби, треба встати, налити чаю й повернутися за п’ять хвилин. Зазвичай після цього все виходить саме.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Тихо, чуєте? Десь поруч кроки. Зараз обережно визирнемо за ріг, і якщо там нікого немає, перебіжимо до дверей. Тільки не шуміть, будь ласка, я серйозно.",
  "Проверено": "Перевірено",
  "Создание новых голосов пока недоступно": "Створення нових голосів поки недоступне",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 секунд мовлення: запис тут або готові файли",
  "Внутренняя ошибка, попробуйте позже": "Внутрішня помилка, спробуйте пізніше",
  "образцов: {n}": "зразків: {n}",
  "Образец короче 2 секунд": "Зразок коротший за 2 секунд",
  "Образец длиннее 1,5 минуты": "Зразок довший за 1,5 хвилин",
  "Слишком шумная запись — попробуйте в тихом месте": "Запис надто шумний — спробуйте в тихому місці",
  "В записи слышно несколько голосов": "У записі чути кілька голосів",
  "Проверка не пройдена: голос не совпадает с образцами": "Перевірку не пройдено: голос не збігається зі зразками",
  "Голос не прошёл правила площадки": "Голос не відповідає правилам платформи",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Перевірку не пройдено: запишіть зразок без музики й інших людей",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Потрібно від 2 секунд до 1,5 хвилин мовлення загалом",
  "Результат обработки уточняется, загляните чуть позже": "Результат обробки уточнюється, загляньте трохи згодом",
  "Удалить голос «{n}»?": "Видалити голос «{n}»?",
  "Навсегда, вместе с образцами": "Назавжди, разом зі зразками",
  "Например, спокойный, низкий": "Наприклад, спокійний, низький",
  "Образец": "Зразок",
  "Запись или файлы, от 2 секунд": "Запис або файли, від 2 секунд",
  "Имя, описание и согласие": "Назва, опис і згода",
  "Проверка и обучение": "Перевірка й навчання",
  "Модель STEOS · 1–3 минуты": "Модель STEOS · 1–3 хв",
  "Тихое место без эха": "Тихе місце без луни",
  "Фоновый шум и музыка попадут в голос": "Фоновий шум і музика потраплять у голос",
  "Хороший микрофон": "Хороший мікрофон",
  "Гарнитура или настольный микрофон лучше встроенного": "Гарнітура чи настільний мікрофон кращі за вбудований",
  "То же оборудование": "Те саме обладнання",
  "Не меняйте микрофон между записями": "Не міняйте мікрофон між записами",
  "Под ним голос стоит в списке выбора": "Під нею голос стоїть у списку вибору",
  "Шумоподавление": "Шумозаглушення",
  "Включайте, только если в записи слышен шум": "Вмикайте, лише якщо в записі чути шум",
  "Согласие обязательно": "Згода обов’язкова",
  "Клонировать можно свой голос или с согласия владельца": "Клонувати можна свій голос або за згодою власника",
  "Проверка образца": "Перевірка зразка",
  "Один говорящий, без музыки и шума": "Один мовець, без музики й шуму",
  "Обучение": "Навчання",
  "Модель STEOS, обычно 1–3 минуты": "Модель STEOS, зазвичай 1–3 хвилини",
  "Голос появится в списке сам": "Голос сам з’явиться у списку",
  "Проверьте запись": "Перевірте запис",
  "Один голос, без музыки и шума на фоне": "Один голос, без музики й шуму на фоні",
  "Длина образца": "Довжина зразка",
  "Нужно не меньше 2 секунд чистой речи": "Потрібно щонайменше 2 секунд чистого мовлення",
  "Образцы сохранены": "Зразки збережено",
  "Можно попробовать снова с теми же файлами": "Можна спробувати знову з тими самими файлами",
  "Не получилось — попробуйте снова": "Не вийшло — спробуйте знову",
  "Шаг {a} из {b}": "Крок {a} з {b}",
  "Персональный": "Персональний",
  "Дальше": "Далі",
  "Продолжить": "Продовжити",
  "К списку голосов": "До списку голосів",
  "Результат уточняется": "Уточнюється",
  "Попробовать снова": "Спробувати знову",
  "Голос готов": "Голос готовий",
  "Опишите голос": "Опишіть голос",
  "Например, Мой голос": "Наприклад, Мій голос",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Це мій голос або в мене є згода його власника. Я не використовуватиму клон для обману, образ і забороненого контенту",
  "Загружаем {a} из {b}": "Завантажуємо {a} з {b}",
  "Обрабатываем голос": "Обробляємо голос",
  "Не получилось создать голос": "Не вдалося створити голос",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "Результат обробки ще уточнюється. Повтор поки недоступний.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Зразки збережено — можна спробувати знову з тими самими файлами",
  "Загруженные файлы": "Завантажені файли",
  "Читаем аудио…": "Читаємо аудіо…",
  "Записать ещё": "Записати ще",
  "Ждём разрешение…": "Чекаємо дозволу…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Дозвольте доступ у налаштуваннях браузера або завантажте файл",
  "Другой текст": "Інший текст",
  "Прочитайте вслух": "Прочитайте вголос",
  "Микрофон по умолчанию": "Типовий мікрофон",
  "Минимум": "Мінімум",
  "Хорошо": "Добре",
  "Отлично": "Чудово",
  "Набрано {a} из {b}": "Набрано {a} з {b}",
  "из {t}": "з {t}",
  "всё готово": "усе готово",
  "Файлов с ошибкой: {n}": "Файлів з помилкою: {n}",
  "до «{n}» ещё {t}": "до «{n}» ще {t}",
  "Ещё {t} до минимума": "Ще {t} до мінімуму",
  "Нужно не меньше 2 секунд": "Потрібно щонайменше 2 секунд",
  "Загрузка образцов": "Завантаження зразків",
  "Образцы приняты сервером": "Сервер прийняв зразки",
  "Проверка голоса": "Перевірка голосу",
  "Пройдена": "Пройдено",
  "Не запрашивалась": "Не запитувалася",
  "Результат проверки пока недоступен": "Результат перевірки поки недоступний",
  "Обработка голоса": "Обробка голосу",
  "Не удалось обработать": "Не вдалося обробити",
  "Выполняется на сервере": "Виконується на сервері",
  "Очистка шума": "Очищення шуму",
  "Пропущено": "Пропущено",
  "Модель STEOS · один говорящий, без музыки": "Модель STEOS · один мовець, без музики",
  "Обучение голоса": "Навчання голосу",
  "Файл больше 20 МБ": "Файл більший за 20 МБ",
  "Запись {n}": "Запис {n}",
  "Не удалось прочитать аудио": "Не вдалося прочитати аудіо",
  "Неподдерживаемый формат": "Непідтримуваний формат",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Результат попереднього створення ще уточнюється. Поверніться до попереднього запиту, щоб не створити другий клон.",
  "Проверить прошлое создание": "Перевірити попереднє",
  "Остановить": "Зупинити",
  "Ждём доступ": "Чекаємо доступ",
  "Ещё раз": "Ще раз",
  "Начать запись": "Почати запис",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Натисніть на голос у списку, щоб відкрити його картку: прослухати, перейменувати чи видалити.",
  "Озвучек": "Озвучень",
  "Знаков": "Знаків",
  "Образцов": "Зразків",
  "Доступна": "Доступна",
  "Недоступна": "Недоступна",
  "После обучения": "Після навчання",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Голос навчено на ваших записах: зразків {n}, загалом {d}",
  "Происхождение: ваши записи. Подробнее": "Походження: ваші записи. Докладніше",
  "Происхождение": "Походження",
  "Ваши записи": "Ваші записи",
  "Проверка": "Перевірка",
  "Не пройдена": "Не пройдено",
  "Идёт": "Триває",
  "Переозвучка аудио": "Переозвучення аудіо",
  "Создан": "Створено",
  "Доступ": "Доступ",
  "Только вы": "Лише ви",
  "Голос пока недоступен для выбора. Обновите список.": "Голос поки не можна вибрати. Оновіть список.",
  "Голос ещё учится, обычно 1–3 минуты": "Голос ще навчається, зазвичай 1–3 хвилини",
  "Коротко о голосе": "Коротко про голос",
  "О голосе": "Про голос",
  "Голос не создан": "Голос не створено",
  "Обработка дольше обычного": "Обробка триває довше, ніж зазвичай",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Сервер ще обробляє голос. Можна закрити застосунок і повернутися пізніше.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "Аватар {n} залишиться без голосу, у кружечках звучатиме типовий голос.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "Аватари {n} залишаться без голосу, у кружечках звучатиме типовий голос.",
  "Записать первый голос": "Записати перший голос",
  "клон|клона|клонов": "клон|клони|клонів",
  "в месяц": "на місяць",
  "{n} C в месяц": "{n} C на місяць",
  "{n} своих голосов": "{n} власних голосів",
  "Оформить": "Оформити",
  "Подписка активна": "Підписка активна",
  "Подписка «{n}»": "Підписка «{n}»",
  "{n} голосов ваши": "{n} голосів — ваші",
  "Доступно — своих голосов": "Доступні власні голоси",
  "{n} голосов мало?": "{n} голосів замало?",
  "Возьмите {n}": "Візьміть {n}",
  "Нужно больше голосов?": "Потрібно більше голосів?",
  "До {n} с подпиской": "До {n} з підпискою",
  "Посмотрите доступные подписки": "Перегляньте доступні підписки",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "Зайнято {a} з {b}. Записуйте голоси під різні завдання й настрої",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Без підписки можна створити {a} {w}. З будь-якою підпискою — до {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Без підписки: {n}. Ліміт залежить від обраної підписки.",
  "Занято {a} из {b}": "Зайнято {a} з {b}",
  "Без подписки · {n}": "Без підписки · {n}",
  "С подпиской · {n}": "З підпискою · {n}",
  "Смотреть все подписки": "Усі підписки",
  "Повторить сохранение": "Зберегти ще раз",
  "Сохраняем изменения…": "Зберігаємо зміни…",
  "Управление голосами временно недоступно": "Керування голосами тимчасово недоступне",
  "клон: Мой голос": "Мій голос",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Власні голоси тимчасово недоступні. Спробуйте оновити список пізніше.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Сервіс голосів тимчасово недоступний. Спробуйте ще раз пізніше.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Не вдалося підтвердити ліміт голосів. Оновіть список пізніше.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Не вдалося підтвердити акаунт. Спробуйте ще раз пізніше.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Назва голосу має містити від 2 до 32 символів.",
  "Описание должно содержать не больше 120 символов.": "Опис має містити не більше 120 символів.",
  "Добавьте от 1 до 10 подходящих образцов.": "Додайте від 1 до 10 відповідних зразків.",
  "Превью этого голоса пока недоступно.": "Прев’ю цього голосу поки недоступне.",
  "Не удалось загрузить превью. Попробуйте позже.": "Не вдалося завантажити прев’ю. Спробуйте пізніше.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "Запис надто шумний. Спробуйте записати голос у тихому місці.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "У записі чути кілька голосів. Додайте мовлення однієї людини.",
  "Голос не прошёл правила площадки.": "Голос не відповідає правилам платформи.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Сервіс не зміг обробити голос. Перевірте статус перед повтором.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Згода змінилася або недоступна. Оновіть список і підтвердьте актуальну версію перед повтором.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Завантаження відхилено. Натисніть кнопку ще раз, щоб завантажити зразок заново.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Завантаження ще не підтверджено. Натисніть кнопку ще раз: спершу перевіримо попереднє завантаження.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Виберіть аудіофайл MP3, WAV, M4A, OGG або WebM.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Не вдалося прочитати аудіо. Спробуйте ще раз або завантажте файл.",
  "Пример звучания": "Приклад звучання",
  "Пример звучания пока недоступен": "Приклад звучання поки недоступний",
  "Превью голоса": "Прев’ю голосу",
  "Прослушать пример": "Прослухати приклад",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "Знижка {0}% на перший пакет Circle діє {1} {2} після оформлення підписки",
  "Вы уже пришли по ссылке партнёра": "Ви вже прийшли за посиланням партнера",
  "Промокод партнёра уже применён": "Промокод партнера вже застосовано",
  "Тут откроется тема чата, куда бот прислал {0}": "Тут відкриється тема чату, куди бот надіслав {0}",
  "можно вывести": "можна вивести",
  "только в STEOS": "лише в STEOS",
  "Не короче {0} знаков": "Не менше {0} символів",
  "Введите почту и пароль": "Введіть пошту й пароль",
  "от {0} знаков": "від {0} символів",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Після входу Circle стануть спільними для бота й облікового запису STEOS. Баланс і виведення є також на {0}.",
  "Вход или новый аккаунт": "Вхід або новий обліковий запис",
  "Придумайте пароль": "Придумайте пароль",
  "Ваш пароль": "Ваш пароль",
  "Принимаю {0} и {1} STEOS": "Приймаю {0} і {1} STEOS",
  "согласие: условия": "умови",
  "согласие: политику конфиденциальности": "політику конфіденційності",
  "Пришлём ссылку на почту": "Надішлемо посилання на пошту",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Відкрийте посилання з листа й задайте новий пароль на {0}. Потім увійдіть тут із новим паролем.",
  "Ссылка для нового пароля ушла на {0}": "Посилання для нового пароля надіслано на {0}",
  "Письма нет? Проверьте папку «Спам».": "Листа немає? Перевірте папку «Спам».",
  "Аккаунт создан и подключён": "Обліковий запис створено й підключено",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Баланс бота тепер спільний з обліковим записом STEOS.",
  "Подтвердите почту по ссылке из письма.": "Підтвердьте пошту за посиланням з листа.",
  "Вывод работает здесь и на {0}.": "Виведення працює тут і на {0}.",
  "Открыть {0}": "Відкрити {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Посилання надіслано на {0}. Відкрийте його, потім перевірте підключення тут.",
  "Проверить подключение": "Перевірити підключення",
  "Почти готово": "Майже готово",
  "Почта ещё не подтверждена": "Пошту ще не підтверджено",
  "Не удалось проверить. Попробуйте позже": "Не вдалося перевірити. Спробуйте пізніше",
  "Озвучиваю тексты голосом героя": "Озвучую тексти голосом героя",
  "Любой голос из библиотеки или свой": "Будь-який голос із бібліотеки або свій",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "Озвучую тексти голосами героїв у STEOS. Спробуйте за моїм посиланням, промокод {0}",
  "Пишу текст, персонаж говорит": "Пишу текст, персонаж говорить",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "Роблю кружечки з персонажами в STEOS: пишу текст, а персонаж його говорить. Промокод {0}",
  "Свои фото в любом образе": "Свої фото в будь-якому образі",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Фотосесія в будь-якому образі з пари моїх фото, без студії. STEOS, промокод {0}",
  "Вы в кадре, монтаж и музыка сами": "Ви в кадрі, монтаж і музика самі",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "Знімаюся в рілсах однією кнопкою в STEOS: сюжет, монтаж і музика вже в шаблоні. Промокод {0}",
  "Персонаж оживает": "Персонаж оживає",
  "Говорит вашим текстом": "Говорить вашим текстом",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Персонаж говорить моїм текстом і своїм голосом. Спробуйте STEOS, промокод {0}",
  "Клон голоса за минуту": "Клон голосу за хвилину",
  "Запишите от 2 секунд, дальше говорит клон": "Запишіть 2 секунд, далі говорить клон",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Клон мого голосу за хвилину в STEOS: тепер він озвучує все сам. Промокод {0}",
  "Старому фото цвет и резкость": "Старому фото — колір і різкість",
  "Восстановление за минуту": "Відновлення за хвилину",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "Повертаю старим фото колір і різкість у STEOS. Промокод {0}",
  "По ссылке или промокоду": "За посиланням або промокодом",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Дарую +{0} C і знижку {1}% на перший пакет у STEOS за моїм промокодом {2}",
  "Кавер на любую песню": "Кавер на будь-яку пісню",
  "Рок, джаз, lo-fi любым голосом": "Рок, джаз, lo-fi будь-яким голосом",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Кавер на будь-яку пісню будь-яким голосом у STEOS. Промокод {0}",
  "Мой аватар в любом образе": "Мій аватар у будь-якому образі",
  "Свой аватар из 10 фото": "Свій аватар із 10 фото",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Мій аватар у будь-якому образі: зібраний із 10 фото в STEOS. Промокод {0}",
  "Это я, только говорю вашим текстом": "Це я, тільки говорю вашим текстом",
  "сторис: Мой голос": "Мій голос",
  "на баланс сразу": "на баланс одразу",
  "на первый пакет Circle": "на перший пакет Circle",
  "Сторис открыта в Telegram": "Сторіс відкрито в Telegram",
  "Сторис готова": "Сторіс готова",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Залишилося натиснути «Опублікувати» в редакторі Telegram",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Тут відкриється редактор сторіс Telegram із цією картинкою та підписом",
  "Подпись к сторис": "Підпис до сторіс",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Кнопка-посилання в сторіс Telegram є лише з Premium. Промокод на картинці бачать усі.",
  "Опубликовать в сторис": "Опублікувати в сторіс",
  "Попробовать STEOS": "Спробувати STEOS",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Не вдалося підготувати сторіс. Спробуйте ще раз",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Сторіс надсилає Telegram: відкрийте Mini App у Telegram",
  "Ссылка и промокод уже на картинке": "Посилання й промокод уже на картинці",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Спробуйте STEOS за моїм посиланням. Промокод {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Спробуйте STEOS за моїм посиланням: +{0} C і знижка {1}% на перший пакет. Промокод {2}",
  "Ссылка": "Посилання",
  "Скопировать ссылку": "Скопіювати посилання",
  "Друзьям {0} и {1} на первый пакет": "Друзям {0} і {1} на перший пакет",
  "Промокод выделен: скопируйте вручную": "Промокод виділено: скопіюйте вручну",
  "Ссылка выделена: скопируйте вручную": "Посилання виділено: скопіюйте вручну",
  "Ссылка скопирована": "Посилання скопійовано",
  "Ссылка выделена: скопируйте её вручную": "Посилання виділено: скопіюйте його вручну",
  "Ссылка выделена": "Посилання виділено",
  "Вы пришли по приглашению": "Ви прийшли за запрошенням",
  "{0} C на баланс": "{0} C на баланс",
  "Сгорят через {0} {1}": "Згорять через {0} {1}",
  "{0} на первый пакет Circle": "{0} на перший пакет Circle",
  "{0} {1} после оформления подписки": "{0} {1} після оформлення підписки",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Пакети Circle можна купити з будь-якою підпискою. Знижка почне діяти, щойно ви її оформите.",
  "Выбрать тариф": "Вибрати тариф",
  "QR-код ссылки приглашения, промокод {0}": "QR-код посилання-запрошення, промокод {0}",
  "Друг наведёт камеру и откроет бота": "Друг наведе камеру й відкриє бота",
  "Цвет карточки": "Колір картки",
  "Скачать картинку": "Завантажити",
  "Аврора": "Аврора",
  "Закат": "Захід",
  "Океан": "Океан",
  "Графит": "Графіт",
  "Партнёры": "Партнери",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Знайшов бота, де будь-який персонаж скаже твій текст у відеоповідомленні. Там же фото, відео й озвучка будь-яким голосом, усе просто в Telegram.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Ділюся знахідкою: STEOS, бот у Telegram, де я роблю відеоповідомлення з персонажами, озвучку й фото. Пишете текст, обираєте голос, і за хвилину готово.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Відновлюю наші старі сімейні фото в STEOS: за хвилину повертає колір і різкість. Надішліть мені знімки, які хочете оновити, або спробуйте самі.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Хто хотів відеоповідомлення голосом улюбленого героя? У STEOS пишеш текст, і персонаж із гри чи серіалу його вимовляє. Це бот у Telegram.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Фото товару, картки з перевагами й описи для маркетплейсів роблю в STEOS за кілька хвилин, без студії та дизайнера. Може, і вам знадобиться.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Озвучую ролики своїм клоном голосу, знімаюся в рилсах за готовими шаблонами й записую кавери. Усе в одному боті STEOS у Telegram.",
  "По моей ссылке +{0} C на старт.": "За моїм посиланням +{0} C на старт.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "За моїм посиланням +{0} C і −{1}% на перший пакет.",
  "Попробуй сам.": "Спробуй сам.",
  "Попробуйте сами.": "Спробуйте самі.",
  "Актёры": "Актори",
  "Персонажи и актёры": "Персонажі та актори",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "За запитом «{q}» голосів немає. Спробуйте інше слово або перегляньте добірки",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Тут поки немає голосів. Перегляньте інші вкладки або добірки",
  "Голос вернётся на экран создания": "Голос повернеться на екран створення",
  "После выбора пишите текст для озвучки в чат бота": "Після вибору пишіть текст для озвучки в чат бота",
  "От Я до А": "Від Я до А",
  "Сортировка и фильтры": "Сортування й фільтри",
  "Сбросить": "Скинути",
  "Чаще всего выбирают": "Найчастіше обирають",
  "Сначала свежие": "Спершу нові",
  "Сначала давние": "Спершу давні",
  "Сначала недорогие": "Спершу недорогі",
  "Сначала короткие ролики": "Спершу короткі ролики",
  "По названию": "За назвою",
  "По названию, с конца алфавита": "За назвою, з кінця абетки",
  "Вертикальные ролики": "Вертикальні ролики",
  "Картинки и посты": "Зображення й дописи",
  "Горизонтальные ролики": "Горизонтальні ролики",
  "Видеосообщения Telegram": "Відеоповідомлення Telegram",
  "Один человек в кадре": "Одна людина в кадрі",
  "Трое и больше": "Троє й більше",
  "С ребёнком": "З дитиною",
  "С питомцем": "З улюбленцем",
  "Двое человек в кадре": "Двоє людей у кадрі",
  "О разделе": "Про розділ",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Перетворює текст на мовлення: голос із каталогу або ваш клон, налаштування інтонації та швидкості.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Копія вашого голосу за записом: нею можна озвучувати будь-які тексти.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "AI-студія: ролики, фото, кружечки та інші шаблони з вами, близькими й персонажами.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Кредити (C) на рахунку та поповнення. Кредити списуються за озвучку та замовлення студії.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Завдання й нагороди: виконуйте завдання та отримуйте кредити.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Усі ваші озвучки й замовлення студії: послухати, завантажити або повторити.",
  "Ваш профиль и данные аккаунта.": "Ваш профіль і дані акаунта.",
  "Настройки приложения: язык, валюта и уведомления.": "Налаштування застосунку: мова, валюта й сповіщення.",
  "Ответы на частые вопросы и связь с поддержкой.": "Відповіді на часті запитання та зв’язок із підтримкою.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Партнерська програма: запрошуйте друзів і отримуйте відсоток з їхніх поповнень.",
  "Озвучка больших текстов и сценариев по ролям.": "Озвучення великих текстів і сценаріїв за ролями.",
  "Вы или один близкий": "Ви або один близький",
  "Вы и близкий": "Ви і близький",
  "Товары и места": "Товари й місця",
  "Фото товара, блюда или места": "Фото товару, страви або місця",
  "В избранном": "В обраному",
  "Голоса и персонажи, которые вы отметили сердцем": "Голоси та персонажі, які ви позначили сердечком",
  "Нажмите — выбрать голос": "Натисніть — вибрати голос",
  "Удерживайте — карточка голоса": "Утримуйте — картка голосу",
  "Карточка голоса или персонажа": "Картка голосу або персонажа",
  "Нажмите на голос, чтобы выбрать его": "Натисніть на голос, щоб обрати його",
  "Удерживайте, чтобы открыть карточку голоса": "Утримуйте, щоб відкрити картку голосу",
  "Удаление голоса": "Видалення голосу",
  "Подсказка": "Підказка",
  "Пример звучания пока недоступен. Попробуйте позже.": "Приклад звучання поки недоступний. Спробуйте пізніше.",
  "Языков: {0}": "Мов: {0}",
  "Ещё языков: {0}": "Ще мов: {0}",
  "Ход примера": "Перебіг прикладу",
  "Голос говорит на {0} языках": "Голос говорить {0} мовами",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Усі голоси багатомовні й озвучать текст будь-якою мовою системи.",
  "Голоса подборки": "Голоси добірки",
  "Удерживайте голос, чтобы открыть его": "Утримуйте голос, щоб відкрити його",
  "Назад к голосу": "Назад до голосу",
  "Оригинал голоса говорил на {0} языке": "Оригінал голосу говорив мовою: {0}",
  "Происхождение: {0}. Подробнее": "Походження: {0}. Докладніше",
  "Новый": "Новий",
  "Официальный": "Офіційний",
  "Актёр": "Актор",
  "Удерживайте, чтобы послушать": "Утримуйте, щоб послухати",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Утримуйте рядок голосу або натисніть його правою кнопкою миші, щоб відкрити картку голосу. Персонаж відкривається звичайним натисканням.",
  "Подборка · Голосов: {0}": "Добірка · Голосів: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Доступні голоси з’являться в каталозі. Тут можна буде прослухати приклад і обрати голос для бота.",
  "Зажмите голос": "Затисніть голос",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Утримуйте рядок голосу, щоб відкрити його картку: прослухати й переглянути добірки. Коротке натискання обирає голос.",
  "Нажмите на аватарку": "Натисніть на аватарку",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "Кругла аватарка в рядку відтворює приклад голосу. Натисніть ще раз, щоб зупинити. Натискання на сам рядок обирає голос.",
  "Сохраняйте в избранное": "Зберігайте в обране",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Натисніть серце в картці голосу або персонажа — вони зберуться в добірці «Обране», першій у «Добірках» і на «Рекомендуємо». Натисніть ще раз, щоб прибрати.",
  "Запишите свой голос": "Запишіть свій голос",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 секунд мовлення або кілька файлів — і за дві хвилини ваш голос з’явиться в усіх інструментах з озвученням. Натисніть «Записати» й читайте текст з екрана.",
  "Читать полностью": "Читати повністю",
  "Голос STEOS": "Голос STEOS",
  "Назад к персонажу": "Назад до персонажа",
  "Назад к списку": "Назад до списку",
  "Актёр STEOS": "Актор STEOS",
  "Персонаж STEOS": "Персонаж STEOS",
  "Об актёре": "Про актора",
  "О персонаже": "Про персонажа",
  "Голоса актёра": "Голоси актора",
  "Голоса персонажа": "Голоси персонажа",
  "шапка: Мой голос": "Мій голос",
  "Пример голоса «{0}»": "Приклад голосу «{0}»",
  "Ещё языки": "Інші мови",
  "Юзеры": "Користувачі",
  "Лайки": "Вподобання",
  "Пол": "Стать",
  "В каталоге с": "У каталозі з",
  "Автор": "Автор",
  "Откуда": "Звідки",
  "Характер": "Характер",
  "Голосов": "Голосів",
  "Мужской": "Чоловічий",
  "Женский": "Жіночий",
  "Детский": "Дитячий",
  "Не указан": "Не вказано",
  "Голос персонажа": "Голос персонажа",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Оберіть підтримуваний аудіофайл до {0} МБ.",
  "пол: Детский": "Дитячий",
  "Состав подборки": "Склад добірки",
  "Закрыть выбор голоса": "Закрити вибір голосу",
  "Не удалось открыть запись для прослушивания.": "Не вдалося відкрити запис для прослуховування.",
  "Использовать готовую запись": "Використати готовий запис",
  "Подтвердите права на материалы, чтобы взять запись.": "Підтвердьте права на матеріали, щоб узяти запис.",
  "Работа из доната": "Робота з донату",
  "Модель синтеза": "Модель синтезу",
  "Новая модель": "Нова модель",
  "Прежняя модель": "Попередня модель",
  "Удерживайте — карточка голоса и модель синтеза": "Утримуйте — картка голосу й модель синтезу",
  "Модель для озвучки в чате": "Модель для озвучення в чаті",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Нова модель: емоції та жива інтонація, запитання, багато мов, клони голосу",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Попередня модель: лише п’ять мов, без емоцій і питальної інтонації, без клонів",
  "Активная модель: STEOS Voice": "Активна модель: STEOS Voice",
  "Активная модель:": "Активна модель:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Нова модель: 19 мов, природне звучання з живими інтонаціями — без металу й роботизованості, якісне клонування голосу",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Попередня модель: лише 5 мов, без емоцій і питальної інтонації, без клонів голосу",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "На моделі STEOS Voice {0} усі голоси багатомовні й озвучать текст будь-якою з цих мов.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "На моделі STEOS Voice {0} усі голоси багатомовні й озвучать текст будь-якою з {1}.",
  "этих языков": "цих мов",
  "Языки озвучки": "Мови озвучення",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "Будь-який голос на моделі STEOS Voice {0} озвучить текст кожною з цих мов",
  "Все голоса": "Усі голоси",
  "Озвучка текста и переозвучка": "Озвучення тексту й переозвучення",
  "Переозвучка записи": "Переозвучення запису",
  "Меняют голос в вашей записи": "Змінюють голос у вашому записі",
  "Выберите голос для переозвучки записи": "Виберіть голос для переозвучення запису",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Голос вибрано — поверніться в чат і натисніть «Продовжити переозвучення»"
}
